package com.isaias.fyattravel.web.i18n
 
import androidx.compose.runtime.Composable
 
enum class WebLocale(
    val code: String,
    val displayName: String,
    val nativeName: String,
    val isRtl: Boolean = false
) {
    EN("en", "English", "English"),
    AM("am", "Amharic", "አማርኛ"),
    AR("ar", "Arabic", "العربية", isRtl = true),
    SO("so", "Somali", "Soomaali"),
    SW("sw", "Swahili", "Kiswahili"),
    TI("ti", "Tigrinya", "ትግርኛ");
}
 
enum class WebStringKey {
    APP_NAME,
    BRAND_SHORT,
    BRAND_SUFFIX,
    SEARCH,
    GO,
    UPDATED_AT,
    REFRESH,
    CATEGORIES,
    CART,
    FLIGHTS,
    STAYS,
    CARS,
    CARS_PAGE_SUBTITLE,
    VISA,
    EXPLORE,
    CONTACT,
    STAYS_PAGE_SUBTITLE,
    MY_PROFILE,
    SIGN_OUT,
    ACCOUNT_ACTIONS,
    EMAIL_NOT_VERIFIED,
    USER_LABEL,
    USER_ID,
    PHONE_NUMBER,
    NOT_PROVIDED,
    EMAIL_VERIFIED,
    YES_TEXT,
    NO_TEXT,
    ACCOUNT_TYPE,
    ACCOUNT_TYPE_EMAIL,
    ACCOUNT_TYPE_PHONE,
    SIGN_OUT_TITLE,
    SIGN_OUT_CONFIRMATION,
    SIGN_IN,
    PROFILE,
    ADMIN,
    NOT_FOUND,
    UNKNOWN_ROUTE,
    EXPLORE_COMING_SOON,
    CART_COMING_SOON,
    ADMIN_COMING_SOON,
    SEARCH_PAGE,
    SEARCH_WITH_QUERY,
    TRAVELERS_ECONOMY_CURRENCY,
    SEARCHING,
    VISA_PAGE_SUBTITLE,
    PASSPORT_COUNTRY_LABEL,
    SELECT_PASSPORT_COUNTRY,
    DESTINATION_COUNTRY_LABEL,
    SELECT_DESTINATION_COUNTRY,
    SEARCH_COUNTRIES_PLACEHOLDER,
    CHECK_VISA_REQUIREMENTS,
    CHECKING,
    VISA_REQUIREMENT_TITLE,
    VISA_FREE_STATUS,
    VISA_ON_ARRIVAL_STATUS,
    EVISA_STATUS,
    VISA_REQUIRED_STATUS,
    UNKNOWN_STATUS,
    PASSPORT_FROM,
    TRAVELING_TO,
    MAXIMUM_STAY,
    IMPORTANT_INFORMATION,
    DESTINATION_INFORMATION,
    CURRENCY_LABEL,
    PHONE_LABEL,
    TIMEZONE_LABEL,
    VISIT_EMBASSY_WEBSITE,
    VISA_REQUIREMENTS_WARNING,
    LANGUAGE,
    LANGUAGE_SETTINGS,
    SELECT_LANGUAGE,
    CURRENT_LANGUAGE,
    APPLY_LANGUAGE,
    LANGUAGE_HELP,
    OPEN_LANGUAGE,
    CLOSE,
    SAVE,
    DONE,
    CANCEL,
    APPLY,
    LOADING,
    RETRY,
    SIGN_IN_SUBTITLE,
    AUTH_SUCCESS,
    ERROR_NO_INTERNET,
    ERROR_SIGN_IN_CANCELED,
    ERROR_UNKNOWN,
    SIGN_IN_WITH_GOOGLE,
    PLEASE_WAIT,
    CONTACT_US,
    BACK,
    GET_IN_TOUCH,
    CONNECT_SOCIAL_MEDIA,
    CHAT_WITH_US,
    FOLLOW_US,
    NEED_IMMEDIATE_ASSISTANCE,
    WHATSAPP_FASTEST_RESPONSE,
    WHATSAPP,
    INSTAGRAM,
    FACEBOOK,
    TWITTER_X,
    TIKTOK,
    OPEN_LINK,
    UPDATE,
    SUCCESSFULLY_UPDATED,
    OOPS,
    SELECT_LANGUAGE_TITLE,
    CHOOSE_PREFERRED_LANGUAGE,
    SELECTED,
    COMING_SOON,
    MORE_LANGUAGES_COMING,
    INFO,
    ENGLISH,
    KISWAHILI,
    TIGRINYA,
    AMHARIC,
    ARABIC,
    SOMALI,
    CONNECTIVITY_OFFLINE,
    CONNECTIVITY_CONNECTED,
    CONNECTIVITY_CHECK_CONNECTION,
    CONNECTIVITY_RETRY,
    CONNECTIVITY_DISMISS,
    CONNECTIVITY_NO_INTERNET,
    CONNECTIVITY_CONNECTION_RESTORED,
    FYAT_TRAVEL_TOUR,
    TRAVEL_OPERATOR,
    BLOG,
    LOCATIONS,
    CHECKOUT,
    MENU,
    SHOP,
    EXPLORE_LABEL,
    CART_LABEL,
    CATEGORIES_LABEL,
    CATEGORIES_SEARCH_PLACEHOLDER,
    CATEGORIES_FILTER_ALL,
    CATEGORIES_FILTER_FLIGHTS,
    CATEGORIES_FILTER_HOTELS,
    CATEGORIES_FILTER_GUEST_HOUSES,
    CATEGORIES_FILTER_CAR_RENTALS,
    CATEGORIES_FILTER_VISA_SERVICES,
    CATEGORIES_FILTER_TOURS,
    CATEGORIES_FILTER_TRANSFERS,
    CATEGORIES_EMPTY,
    CATEGORIES_NO_MATCH,
    CATEGORIES_CLEAR_FILTERS,
    CATEGORIES_SHOWING_COUNT,
    CATEGORY_TYPE_OTHER,
    FLIGHT_OFFERS,
    HOTEL,
    GUEST_HOUSE,
    CAR_RENTAL,
    TOUR,
    TOUR_PACKAGES,
    EXPLORE_FLIGHTS,
    EXPLORE_STAYS,
    EXPLORE_TRANSFER,
    EXPLORE_VISA,
    ERROR_WITH_MESSAGE,
    FLIGHT_TAB_RETURN,
    FLIGHT_TAB_ONE_WAY,
    FLIGHT_TAB_MULTI_CITY,
    FLIGHT_FROM,
    FLIGHT_TO,
    FLIGHT_SELECT_AIRPORT,
    FLIGHT_DEPARTURE,
    FLIGHT_RETURN,
    FLIGHT_ORIGIN_PLACEHOLDER,
    FLIGHT_DESTINATION_PLACEHOLDER,
    FLIGHT_SELECT_DATE,
    FLIGHT_TRAVELERS,
    FLIGHT_TRAVELLER_SINGULAR,
    FLIGHT_TRAVELLER_PLURAL,
    FLIGHT_CABIN,
    FLIGHT_SEARCH,
    FLIGHT_SPECIAL_OFFERS,
    FLIGHT_NO_OFFERS,
    FLIGHT_CLOSE,
    FLIGHT_DONE,
    FLIGHT_ADULTS,
    FLIGHT_ADULTS_WITH_COUNT,
    FLIGHT_INCREASE,
    FLIGHT_DECREASE,
    FLIGHT_PRICE,
    FLIGHT_DISCOUNTED,
    FLIGHT_NEW,
    FLIGHT_DETAILS,
    FLIGHT_AVAILABLE_OPTIONS,
    FLIGHT_BOOK_NOW_FROM,
    FLIGHT_ARROW,
    FLIGHT_CABIN_ECONOMY,
    FLIGHT_CABIN_PREMIUM_ECONOMY,
    FLIGHT_CABIN_BUSINESS,
    FLIGHT_CABIN_FIRST,
    FLIGHT_MONTH_JAN,
    FLIGHT_MONTH_FEB,
    FLIGHT_MONTH_MAR,
    FLIGHT_MONTH_APR,
    FLIGHT_MONTH_MAY,
    FLIGHT_MONTH_JUN,
    FLIGHT_MONTH_JUL,
    FLIGHT_MONTH_AUG,
    FLIGHT_MONTH_SEP,
    FLIGHT_MONTH_OCT,
    FLIGHT_MONTH_NOV,
    FLIGHT_MONTH_DEC,
    VISA_TITLE,
    VISA_SUBTITLE,
    VISA_PASSPORT_COUNTRY,
    VISA_DESTINATION_COUNTRY,
    VISA_PASSPORT_HINT,
    VISA_DESTINATION_HINT,
    VISA_CHECKING,
    VISA_CHECK_BUTTON,
    VISA_ERROR,
    VISA_ALWAYS_VERIFY,
    VISA_EXPAND_DETAILS,
    VISA_COLLAPSE_DETAILS,
    VISA_STAY_DURATION,
    VISA_NO_DETAILS,
    VISA_SEARCH_TIP,
    VISA_KEY_INFO_TITLE,
    VISA_CAPITAL,
    VISA_CURRENCY,
    VISA_EXCHANGE_RATE,
    VISA_PASSPORT_VALIDITY,
    VISA_EMBASSY_WEBSITE,
    VISA_PHONE_CODE,
    VISA_TIMEZONE,
    VISA_POPULATION,
    VISA_AREA,
    VISA_MANDATORY_REGISTRATION,
    VISA_VISA_OPTIONS,
    VISA_OPEN_LINK,
    VISA_STATUS_VISA_FREE,
    VISA_STATUS_VISA_ON_ARRIVAL,
    VISA_STATUS_EVISA,
    VISA_STATUS_VISA_REQUIRED,
    VISA_STATUS_UNKNOWN,
    VISA_UNIT_MONTH,
    VISA_UNIT_MONTHS,
    VISA_UNIT_DAY,
    VISA_UNIT_DAYS,
    VISA_UNIT_YEAR,
    VISA_UNIT_YEARS,
    CAR_FIND_A_CAR,
    CAR_PICKUP_LOCATION,
    CAR_DROPOFF_LOCATION_OPTIONAL,
    CAR_PICKUP_DATETIME,
    CAR_DROPOFF_DATETIME,
    CAR_DRIVER_AGE,
    CAR_SEARCH_CARS,
    HOTEL_WHERE_TO,
    HOTEL_SEARCH_DESTINATION,
    HOTEL_CHECK_IN,
    HOTEL_CHECK_OUT,
    HOTEL_GUESTS_ROOMS,
    HOTEL_ADULT_SINGULAR,
    HOTEL_ADULT_PLURAL,
    HOTEL_CHILD_SINGULAR,
    HOTEL_CHILD_PLURAL,
    HOTEL_ROOM_SINGULAR,
    HOTEL_ROOM_PLURAL,
    HOTEL_SEARCH_HOTELS,
    HOTEL_ADULTS,
    HOTEL_CHILDREN,
    HOTEL_ROOMS,
    HOTEL_DONE,
    HOTEL_CLOSE,
    HOTEL_WHERE_ARE_YOU_GOING,
    HOTEL_SEARCH_DESTINATIONS,
    HOTEL_START_TYPING,
    HOTEL_ENTER_CITY_HOTEL_DESTINATION,
    HOTEL_SEARCHING_DESTINATIONS,
    HOTEL_NO_DESTINATIONS_FOUND,
    HOTEL_TRY_DIFFERENT_SEARCH_TERM,
    HOTEL_CLEAR,
    HOTEL_HOTELS,
    HOTEL_UNKNOWN,
    CONTACT_SUBTITLE,
    CONTACT_INFORMATION,
    SOCIAL_LABEL,
    SEND_A_COMMENT,
    YOUR_NAME,
    FULL_NAME_PLACEHOLDER,
    EMAIL_OPTIONAL,
    EMAIL_PLACEHOLDER,
    MESSAGE_COMMENTS,
    MESSAGE_PLACEHOLDER,
    ERROR_NAME_MESSAGE_REQUIRED,
    WHATSAPP_SENT_HINT,
    SEND_VIA_WHATSAPP,
    CONTACT_MESSAGE_TEMPLATE,
    CAR_PICKUP_CITY,
    CAR_DROPOFF_CITY_OPTIONAL,
    CAR_PICKUP_DATE,
    CAR_DROPOFF_DATE,
    CAR_PICKUP_TIME,
    CAR_DROPOFF_TIME,
    ERROR_SEARCH_CARS_FAILED,
    ERROR_INVALID_RESPONSE,
    ERROR_NETWORK,
    OPEN_ON_BOOKING,
    CAR_RESULTS_COUNT,
    CAR_LABEL,
    ERROR_SEARCH_HOTELS_FAILED,
    HOTEL_RESULTS_COUNT,
    RATING_WITH_REVIEWS,
    NO_HOTELS_FOUND,
    QUICK_SELECT,
    BOOK_YOUR_JOURNEY,
    CLOSE_FORM,
    CLICK_TO_FILL_DETAILS,
    ENQUIRY_SENT,
    SEND_ANOTHER,
    ENTER_YOUR_NAME,
    EMAIL_LABEL,
    SEND_INQUIRY,
    VALIDATION_ENTER_VALID_EMAIL,
    SERVICE_LABEL,
    DEPARTURE_CITY_PLACEHOLDER,
    DESTINATION_PLACEHOLDER,
    GUESTS_LABEL,
    GUESTS_PLACEHOLDER,
    NOTES_LABEL,
    NOTES_PLACEHOLDER,
    SENDING,
    SEND_EMAIL,
    BOOKING_ENQUIRY_TITLE,
    VALIDATION_ENTER_FULL_NAME,
    VALIDATION_ENTER_EMAIL_OR_PHONE,
    VALIDATION_ENTER_DEPARTURE,
    VALIDATION_ENTER_DESTINATION,
    ADDITIONAL_DETAILS_LABEL,
    GUESTS_AND_CABIN_LABEL,
    FILTER_BY_AIRLINE,
    CLEAR_FILTER,
    NO_AIRLINE_FLIGHTS_FOUND,
    NO_FLIGHTS_FOUND_MESSAGE,
    FLIGHT_OFFER_LABEL,
    FLIGHT_NUMBER_LABEL,
    COMPLETE_BOOKING,
    BOOKING_REQUEST_SENT,
    BOOKING_REQUEST_SUBTITLE,
    YOUR_DETAILS_SECTION,
    TRAVEL_DETAILS_SECTION,
    GUESTS_EXAMPLE_PLACEHOLDER,
    SPECIAL_REQUIREMENTS_PLACEHOLDER,
    PRIVACY_NOTE,
    SEND_VIA_EMAIL,
    OFFER_WEEKEND_ESCAPE,
    OFFER_WEEKEND_DESC,
    OFFER_HOLIDAY_DEALS,
    OFFER_HOLIDAY_DESC,
    HOME_SUBTITLE,
    HOME_HELP_TEXT,
    FEATURED_FLIGHT_OFFERS,
    VIEW_ALL,
    BROWSE_CATEGORIES,
    ITEMS_COUNT,
    BOOK_ACTION,
    WHATSAPP_DEFAULT_MESSAGE,
    WHATSAPP_CHAT_LABEL,
    WHATSAPP_ASK_LABEL,
    WHATSAPP_NEED_HELP_TITLE,
    WHATSAPP_HELP_SUBTITLE,
    WHATSAPP_CHAT_NOW,
    WHATSAPP_MESSAGE_FLIGHT,
    WHATSAPP_MESSAGE_HOTEL,
    WHATSAPP_MESSAGE_VISA,
    WHATSAPP_MESSAGE_TOUR,
    WHATSAPP_MESSAGE_CAR,
    WHATSAPP_MESSAGE_GENERAL,
    FIRESTORE_INDEX_REQUIRED_TITLE,
    FIRESTORE_INDEX_REQUIRED_BODY,
    FIRESTORE_CREATE_INDEX,
    FIRESTORE_DISMISS,
    FIRESTORE_INDEX_NOTE,
    FIRESTORE_INDEX_MISSING,
    FIRESTORE_ACCESS_DENIED,
    FIRESTORE_NOT_FOUND,
    FIRESTORE_NETWORK_UNAVAILABLE,
    FOOTER_BRAND,
    FOOTER_TAGLINE,
    COPYRIGHT_TEXT,
    QUICK_LINKS,
    SERVICES_LABEL,
    ABOUT_US,
    CONTACT_LABEL,
    BOOK_NOW_LABEL,
    TOP_SERVICES,
    FLIGHT_BOOKING,
    HOTEL_RESERVATIONS,
    VISA_PROCESSING,
    CAR_HIRE,
    GET_APP,
    GET_IT_ON,
    DOWNLOAD_ON,
    GOOGLE_PLAY,
    APP_STORE,
    PAYMENT_SUCCESS_TITLE,
    PAYMENT_SUCCESS_MESSAGE_WITH_NAME,
    PAYMENT_SUCCESS_MESSAGE_GENERIC,
    ORDER_DETAILS,
    ORDER_ID_LABEL,
    STATUS_LABEL,
    PAYMENT_STATUS_PAID,
    PAYMENT_METHOD_LABEL,
    PAYMENT_METHOD_PESAPAL,
    CONFIRMATION_EMAIL_NOTE,
    BROWSE_MORE_PRODUCTS,
    GO_TO_HOME,
    NEED_HELP_CONTACT,
    PAYMENT_FAILED_TITLE,
    PAYMENT_FAILED_MESSAGE,
    PAYMENT_FAILED_SUGGESTIONS_TITLE,
    PAYMENT_FAILED_SUGGESTION_1,
    PAYMENT_FAILED_SUGGESTION_2,
    PAYMENT_FAILED_SUGGESTION_3,
    PAYMENT_FAILED_SUGGESTION_4,
    TRY_AGAIN,
    CONTACT_VIA_WHATSAPP,
    PAYMENT_FAILED_WHATSAPP_MESSAGE
}
 
object WebStrings {
    private val en = mapOf(
        WebStringKey.APP_NAME to "TRAVEL & TOUR APP",
        WebStringKey.BRAND_SHORT to "FyatTravel",
        WebStringKey.BRAND_SUFFIX to "Tour LTD",
        WebStringKey.SEARCH to "Search",
        WebStringKey.GO to "Go",
        WebStringKey.UPDATED_AT to "Updated: {0}",
        WebStringKey.REFRESH to "Refresh",
        WebStringKey.CATEGORIES to "Categories",
        WebStringKey.CART to "Cart",
        WebStringKey.FLIGHTS to "Flights",
        WebStringKey.STAYS to "Stays",
        WebStringKey.CARS to "Cars",
        WebStringKey.CARS_PAGE_SUBTITLE to "Tell us your car rental details and our team will contact you by WhatsApp or email.",
        WebStringKey.VISA to "Visa",
        WebStringKey.EXPLORE to "Explore",
        WebStringKey.CONTACT to "Contact",
        WebStringKey.STAYS_PAGE_SUBTITLE to "Tell us your stay details and our team will contact you by WhatsApp or email.",
        WebStringKey.MY_PROFILE to "My Profile",
        WebStringKey.SIGN_OUT to "Sign Out",
        WebStringKey.ACCOUNT_ACTIONS to "Account Actions",
        WebStringKey.EMAIL_NOT_VERIFIED to "⚠ Email not verified",
        WebStringKey.USER_LABEL to "User",
        WebStringKey.USER_ID to "User ID",
        WebStringKey.PHONE_NUMBER to "Phone",
        WebStringKey.NOT_PROVIDED to "Not provided",
        WebStringKey.EMAIL_VERIFIED to "Email Verified",
        WebStringKey.YES_TEXT to "Yes",
        WebStringKey.NO_TEXT to "No",
        WebStringKey.ACCOUNT_TYPE to "Account Type",
        WebStringKey.ACCOUNT_TYPE_EMAIL to "Email",
        WebStringKey.ACCOUNT_TYPE_PHONE to "Phone",
        WebStringKey.SIGN_OUT_TITLE to "Sign Out",
        WebStringKey.SIGN_OUT_CONFIRMATION to "Are you sure you want to sign out? You'll need to sign in again to access your account.",
        WebStringKey.SIGN_IN to "Sign In",
        WebStringKey.PROFILE to "Profile",
        WebStringKey.ADMIN to "Admin",
        WebStringKey.NOT_FOUND to "Not found",
        WebStringKey.UNKNOWN_ROUTE to "Unknown route: {0}",
        WebStringKey.EXPLORE_COMING_SOON to "Explore page for web is coming next.",
        WebStringKey.CART_COMING_SOON to "Cart page for web is coming next.",
        WebStringKey.ADMIN_COMING_SOON to "Admin web dashboard will be wired next.",
        WebStringKey.SEARCH_PAGE to "Search",
        WebStringKey.SEARCH_WITH_QUERY to "Search: {0}",
        WebStringKey.TRAVELERS_ECONOMY_CURRENCY to "1 traveller • Economy • USD / UGX",
        WebStringKey.SEARCHING to "Searching...",
        WebStringKey.VISA_PAGE_SUBTITLE to "Check visa requirements for any destination. Enter your passport country and where you want to travel.",
        WebStringKey.PASSPORT_COUNTRY_LABEL to "Passport Country",
        WebStringKey.SELECT_PASSPORT_COUNTRY to "Select passport country",
        WebStringKey.DESTINATION_COUNTRY_LABEL to "Destination Country",
        WebStringKey.SELECT_DESTINATION_COUNTRY to "Select destination country",
        WebStringKey.SEARCH_COUNTRIES_PLACEHOLDER to "Search countries...",
        WebStringKey.CHECK_VISA_REQUIREMENTS to "Check Visa Requirements",
        WebStringKey.CHECKING to "Checking...",
        WebStringKey.VISA_REQUIREMENT_TITLE to "Visa Requirement",
        WebStringKey.VISA_FREE_STATUS to "Visa Free",
        WebStringKey.VISA_ON_ARRIVAL_STATUS to "Visa on Arrival",
        WebStringKey.EVISA_STATUS to "E-Visa Available",
        WebStringKey.VISA_REQUIRED_STATUS to "Visa Required",
        WebStringKey.UNKNOWN_STATUS to "Unknown",
        WebStringKey.PASSPORT_FROM to "Passport From",
        WebStringKey.TRAVELING_TO to "Traveling To",
        WebStringKey.MAXIMUM_STAY to "Maximum Stay",
        WebStringKey.IMPORTANT_INFORMATION to "Important Information",
        WebStringKey.DESTINATION_INFORMATION to "Destination Information",
        WebStringKey.CURRENCY_LABEL to "Currency: {0}",
        WebStringKey.PHONE_LABEL to "Phone: +{0}",
        WebStringKey.TIMEZONE_LABEL to "Timezone: {0}",
        WebStringKey.VISIT_EMBASSY_WEBSITE to "Visit Embassy Website →",
        WebStringKey.VISA_REQUIREMENTS_WARNING to "⚠️ Visa requirements can change. Always verify with the official embassy before traveling.",
        WebStringKey.LANGUAGE to "Language",
        WebStringKey.LANGUAGE_SETTINGS to "Language Settings",
        WebStringKey.SELECT_LANGUAGE to "Select your language",
        WebStringKey.CURRENT_LANGUAGE to "Current language",
        WebStringKey.APPLY_LANGUAGE to "Apply language",
        WebStringKey.LANGUAGE_HELP to "Choose the language you want to use on the website.",
        WebStringKey.OPEN_LANGUAGE to "Change language",
        WebStringKey.CLOSE to "Close",
        WebStringKey.SAVE to "Save",
        WebStringKey.DONE to "Done",
        WebStringKey.CANCEL to "Cancel",
        WebStringKey.APPLY to "Apply",
        WebStringKey.LOADING to "Loading...",
        WebStringKey.RETRY to "Retry",
        WebStringKey.SIGN_IN_SUBTITLE to "Sign in to continue",
        WebStringKey.AUTH_SUCCESS to "Authentication successful!",
        WebStringKey.ERROR_NO_INTERNET to "Internet connection unavailable.",
        WebStringKey.ERROR_SIGN_IN_CANCELED to "Sign in canceled.",
        WebStringKey.ERROR_UNKNOWN to "Unknown",
        WebStringKey.SIGN_IN_WITH_GOOGLE to "Sign in with Google",
        WebStringKey.PLEASE_WAIT to "Please wait...",
        WebStringKey.CONTACT_US to "Contact Us",
        WebStringKey.BACK to "Back",
        WebStringKey.GET_IN_TOUCH to "Get in Touch",
        WebStringKey.CONNECT_SOCIAL_MEDIA to "Connect with us on social media",
        WebStringKey.CHAT_WITH_US to "Chat with us",
        WebStringKey.FOLLOW_US to "Follow us",
        WebStringKey.NEED_IMMEDIATE_ASSISTANCE to "Need immediate assistance?",
        WebStringKey.WHATSAPP_FASTEST_RESPONSE to "Message us on WhatsApp for fastest response",
        WebStringKey.WHATSAPP to "WhatsApp",
        WebStringKey.INSTAGRAM to "Instagram",
        WebStringKey.FACEBOOK to "Facebook",
        WebStringKey.TWITTER_X to "Twitter (X)",
        WebStringKey.TIKTOK to "TikTok",
        WebStringKey.OPEN_LINK to "Open",
        WebStringKey.UPDATE to "Update",
        WebStringKey.SUCCESSFULLY_UPDATED to "Successfully updated!",
        WebStringKey.OOPS to "Oops!",
        WebStringKey.SELECT_LANGUAGE_TITLE to "Select Language",
        WebStringKey.CHOOSE_PREFERRED_LANGUAGE to "Choose your preferred language for the app",
        WebStringKey.SELECTED to "Selected",
        WebStringKey.COMING_SOON to "Coming Soon",
        WebStringKey.MORE_LANGUAGES_COMING to "More languages coming soon! We're working hard to bring Fyat Travel to your language.",
        WebStringKey.INFO to "Info",
        WebStringKey.ENGLISH to "English",
        WebStringKey.KISWAHILI to "Kiswahili",
        WebStringKey.TIGRINYA to "Tigrinya",
        WebStringKey.AMHARIC to "Amharic",
        WebStringKey.ARABIC to "Arabic",
        WebStringKey.SOMALI to "Somali",
        WebStringKey.CONNECTIVITY_OFFLINE to "You're offline",
        WebStringKey.CONNECTIVITY_CONNECTED to "Connected",
        WebStringKey.CONNECTIVITY_CHECK_CONNECTION to "Check your internet connection",
        WebStringKey.CONNECTIVITY_RETRY to "Retry",
        WebStringKey.CONNECTIVITY_DISMISS to "Dismiss",
        WebStringKey.CONNECTIVITY_NO_INTERNET to "No internet connection",
        WebStringKey.CONNECTIVITY_CONNECTION_RESTORED to "Connection restored",
        WebStringKey.FYAT_TRAVEL_TOUR to "Fyat Travel & Tour Ltd",
        WebStringKey.TRAVEL_OPERATOR to "Tour Operator",
        WebStringKey.SIGN_OUT to "Sign out",
        WebStringKey.ADMIN to "Admin",
        WebStringKey.BLOG to "Blog",
        WebStringKey.LOCATIONS to "Locations",
        WebStringKey.CHECKOUT to "Checkout",
        WebStringKey.MENU to "Menu",
        WebStringKey.SHOP to "Shop",
        WebStringKey.EXPLORE_LABEL to "Explore",
        WebStringKey.CART_LABEL to "Cart",
        WebStringKey.CATEGORIES_LABEL to "Categories",
        WebStringKey.CATEGORIES_SEARCH_PLACEHOLDER to "Search categories...",
        WebStringKey.CATEGORIES_FILTER_ALL to "All",
        WebStringKey.CATEGORIES_FILTER_FLIGHTS to "Flights",
        WebStringKey.CATEGORIES_FILTER_HOTELS to "Hotels",
        WebStringKey.CATEGORIES_FILTER_GUEST_HOUSES to "Guest Houses",
        WebStringKey.CATEGORIES_FILTER_CAR_RENTALS to "Car Rentals",
        WebStringKey.CATEGORIES_FILTER_VISA_SERVICES to "Visa Services",
        WebStringKey.CATEGORIES_FILTER_TOURS to "Tours",
        WebStringKey.CATEGORIES_FILTER_TRANSFERS to "Transfers",
        WebStringKey.CATEGORIES_EMPTY to "No categories found in Firestore.",
        WebStringKey.CATEGORIES_NO_MATCH to "No categories match your search",
        WebStringKey.CATEGORIES_CLEAR_FILTERS to "Clear filters",
        WebStringKey.CATEGORIES_SHOWING_COUNT to "Showing {0} of {1} categories",
        WebStringKey.CATEGORY_TYPE_OTHER to "Other",
        WebStringKey.FLIGHT_OFFERS to "Flight Offers",
        WebStringKey.HOTEL to "Hotel",
        WebStringKey.GUEST_HOUSE to "Guest House",
        WebStringKey.CAR_RENTAL to "Car Rental",
        WebStringKey.TOUR to "Tour",
        WebStringKey.TOUR_PACKAGES to "Tour Packages",
        WebStringKey.EXPLORE_FLIGHTS to "Flights",
        WebStringKey.EXPLORE_STAYS to "Stays",
        WebStringKey.EXPLORE_TRANSFER to "Transfer",
        WebStringKey.EXPLORE_VISA to "Visa",
        WebStringKey.ERROR_WITH_MESSAGE to "Error: {0}",
        WebStringKey.FLIGHT_TAB_RETURN to "Round Trip",
        WebStringKey.FLIGHT_TAB_ONE_WAY to "One Way",
        WebStringKey.FLIGHT_TAB_MULTI_CITY to "Multi City",
        WebStringKey.FLIGHT_FROM to "From",
        WebStringKey.FLIGHT_TO to "To",
        WebStringKey.FLIGHT_SELECT_AIRPORT to "Select airport",
        WebStringKey.FLIGHT_DEPARTURE to "Departure",
        WebStringKey.FLIGHT_RETURN to "Return",
        WebStringKey.FLIGHT_ORIGIN_PLACEHOLDER to "Origin (e.g., EBB)",
        WebStringKey.FLIGHT_DESTINATION_PLACEHOLDER to "Destination (e.g., NBO)",
        WebStringKey.FLIGHT_SELECT_DATE to "Select date",
        WebStringKey.FLIGHT_TRAVELERS to "Travelers",
        WebStringKey.FLIGHT_TRAVELLER_SINGULAR to "traveller",
        WebStringKey.FLIGHT_TRAVELLER_PLURAL to "travellers",
        WebStringKey.FLIGHT_CABIN to "Cabin",
        WebStringKey.FLIGHT_SEARCH to "Search",
        WebStringKey.FLIGHT_SPECIAL_OFFERS to "Special Flight Offers ✈️",
        WebStringKey.FLIGHT_NO_OFFERS to "No flight offers available.",
        WebStringKey.FLIGHT_CLOSE to "Close",
        WebStringKey.FLIGHT_DONE to "Done",
        WebStringKey.FLIGHT_ADULTS to "Adults",
        WebStringKey.FLIGHT_ADULTS_WITH_COUNT to "Adults: {0}",
        WebStringKey.FLIGHT_INCREASE to "Increase",
        WebStringKey.FLIGHT_DECREASE to "Decrease",
        WebStringKey.FLIGHT_PRICE to "Price",
        WebStringKey.FLIGHT_DISCOUNTED to "Discounted",
        WebStringKey.FLIGHT_NEW to "New",
        WebStringKey.FLIGHT_DETAILS to "Flight Details",
        WebStringKey.FLIGHT_AVAILABLE_OPTIONS to "Available Options",
        WebStringKey.FLIGHT_BOOK_NOW_FROM to "Book Now",
        WebStringKey.FLIGHT_ARROW to "→",
        WebStringKey.FLIGHT_CABIN_ECONOMY to "Economy",
        WebStringKey.FLIGHT_CABIN_PREMIUM_ECONOMY to "Premium Economy",
        WebStringKey.FLIGHT_CABIN_BUSINESS to "Business",
        WebStringKey.FLIGHT_CABIN_FIRST to "First",
        WebStringKey.FLIGHT_MONTH_JAN to "Jan",
        WebStringKey.FLIGHT_MONTH_FEB to "Feb",
        WebStringKey.FLIGHT_MONTH_MAR to "Mar",
        WebStringKey.FLIGHT_MONTH_APR to "Apr",
        WebStringKey.FLIGHT_MONTH_MAY to "May",
        WebStringKey.FLIGHT_MONTH_JUN to "Jun",
        WebStringKey.FLIGHT_MONTH_JUL to "Jul",
        WebStringKey.FLIGHT_MONTH_AUG to "Aug",
        WebStringKey.FLIGHT_MONTH_SEP to "Sep",
        WebStringKey.FLIGHT_MONTH_OCT to "Oct",
        WebStringKey.FLIGHT_MONTH_NOV to "Nov",
        WebStringKey.FLIGHT_MONTH_DEC to "Dec",
        WebStringKey.VISA_TITLE to "Visa Requirements Checker",
        WebStringKey.VISA_SUBTITLE to "Check visa requirements for your next trip",
        WebStringKey.VISA_PASSPORT_COUNTRY to "Your Passport Country",
        WebStringKey.VISA_DESTINATION_COUNTRY to "Destination Country",
        WebStringKey.VISA_PASSPORT_HINT to "Search country or enter code (e.g., Uganda or UG)",
        WebStringKey.VISA_DESTINATION_HINT to "Search country or enter code (e.g., United States or US)",
        WebStringKey.VISA_CHECKING to "Checking...",
        WebStringKey.VISA_CHECK_BUTTON to "Check Visa Requirements",
        WebStringKey.VISA_ERROR to "Error",
        WebStringKey.VISA_ALWAYS_VERIFY to "ℹ️ Always verify requirements with official sources before travel",
        WebStringKey.VISA_EXPAND_DETAILS to "Expand details",
        WebStringKey.VISA_COLLAPSE_DETAILS to "Collapse details",
        WebStringKey.VISA_STAY_DURATION to "Stay Duration: {0}",
        WebStringKey.VISA_NO_DETAILS to "No detailed information available.",
        WebStringKey.VISA_SEARCH_TIP to "💡 Search for a country by name or enter a 2-letter code (e.g., Uganda or UG)",
        WebStringKey.VISA_KEY_INFO_TITLE to "Key info",
        WebStringKey.VISA_CAPITAL to "Capital city",
        WebStringKey.VISA_CURRENCY to "Currency",
        WebStringKey.VISA_EXCHANGE_RATE to "Exchange rate",
        WebStringKey.VISA_PASSPORT_VALIDITY to "Passport validity",
        WebStringKey.VISA_EMBASSY_WEBSITE to "Embassy website",
        WebStringKey.VISA_PHONE_CODE to "Phone code",
        WebStringKey.VISA_TIMEZONE to "Time zone",
        WebStringKey.VISA_POPULATION to "Population",
        WebStringKey.VISA_AREA to "Area",
        WebStringKey.VISA_MANDATORY_REGISTRATION to "Mandatory registration",
        WebStringKey.VISA_VISA_OPTIONS to "Visa options",
        WebStringKey.VISA_OPEN_LINK to "Open",
        WebStringKey.VISA_STATUS_VISA_FREE to "VISA FREE",
        WebStringKey.VISA_STATUS_VISA_ON_ARRIVAL to "VISA ON ARRIVAL",
        WebStringKey.VISA_STATUS_EVISA to "EVISA",
        WebStringKey.VISA_STATUS_VISA_REQUIRED to "VISA REQUIRED",
        WebStringKey.VISA_STATUS_UNKNOWN to "UNKNOWN",
        WebStringKey.VISA_UNIT_MONTH to "month",
        WebStringKey.VISA_UNIT_MONTHS to "months",
        WebStringKey.VISA_UNIT_DAY to "day",
        WebStringKey.VISA_UNIT_DAYS to "days",
        WebStringKey.VISA_UNIT_YEAR to "year",
        WebStringKey.VISA_UNIT_YEARS to "years",
        WebStringKey.CAR_FIND_A_CAR to "Find a car",
        WebStringKey.CAR_PICKUP_LOCATION to "Pick-up Location",
        WebStringKey.CAR_DROPOFF_LOCATION_OPTIONAL to "Drop-off Location (optional)",
        WebStringKey.CAR_PICKUP_DATETIME to "Pick-up Date/Time",
        WebStringKey.CAR_DROPOFF_DATETIME to "Drop-off Date/Time",
        WebStringKey.CAR_DRIVER_AGE to "Driver Age",
        WebStringKey.CAR_SEARCH_CARS to "Search Cars",
        WebStringKey.HOTEL_WHERE_TO to "Where to?",
        WebStringKey.HOTEL_SEARCH_DESTINATION to "Search destination",
        WebStringKey.HOTEL_CHECK_IN to "Check-in",
        WebStringKey.HOTEL_CHECK_OUT to "Check-out",
        WebStringKey.HOTEL_GUESTS_ROOMS to "Guests & Rooms",
        WebStringKey.HOTEL_ADULT_SINGULAR to "adult",
        WebStringKey.HOTEL_ADULT_PLURAL to "adults",
        WebStringKey.HOTEL_CHILD_SINGULAR to "child",
        WebStringKey.HOTEL_CHILD_PLURAL to "children",
        WebStringKey.HOTEL_ROOM_SINGULAR to "room",
        WebStringKey.HOTEL_ROOM_PLURAL to "rooms",
        WebStringKey.HOTEL_SEARCH_HOTELS to "Search Hotels",
        WebStringKey.HOTEL_ADULTS to "Adults",
        WebStringKey.HOTEL_CHILDREN to "Children",
        WebStringKey.HOTEL_ROOMS to "Rooms",
        WebStringKey.HOTEL_DONE to "DONE",
        WebStringKey.HOTEL_CLOSE to "Close",
        WebStringKey.HOTEL_WHERE_ARE_YOU_GOING to "Where are you going?",
        WebStringKey.HOTEL_SEARCH_DESTINATIONS to "Search destinations",
        WebStringKey.HOTEL_START_TYPING to "Start typing to search",
        WebStringKey.HOTEL_ENTER_CITY_HOTEL_DESTINATION to "Enter city name, hotel, or destination",
        WebStringKey.HOTEL_SEARCHING_DESTINATIONS to "Searching destinations...",
        WebStringKey.HOTEL_NO_DESTINATIONS_FOUND to "No destinations found",
        WebStringKey.HOTEL_TRY_DIFFERENT_SEARCH_TERM to "Try a different search term",
        WebStringKey.HOTEL_CLEAR to "Clear",
        WebStringKey.HOTEL_HOTELS to "hotels",
        WebStringKey.HOTEL_UNKNOWN to "Unknown",
        WebStringKey.CONTACT_SUBTITLE to "We’re here to help you with all your travel needs.",
        WebStringKey.CONTACT_INFORMATION to "Contact Information",
        WebStringKey.SOCIAL_LABEL to "Social",
        WebStringKey.SEND_A_COMMENT to "Send a Comment",
        WebStringKey.YOUR_NAME to "Your Name",
        WebStringKey.FULL_NAME_PLACEHOLDER to "Full name",
        WebStringKey.EMAIL_OPTIONAL to "Email (optional)",
        WebStringKey.EMAIL_PLACEHOLDER to "you@example.com",
        WebStringKey.MESSAGE_COMMENTS to "Message / Comments",
        WebStringKey.MESSAGE_PLACEHOLDER to "Write your message here...",
        WebStringKey.ERROR_NAME_MESSAGE_REQUIRED to "Please enter your name and message.",
        WebStringKey.WHATSAPP_SENT_HINT to "WhatsApp opened with your message. Tap send to submit.",
        WebStringKey.SEND_VIA_WHATSAPP to "Send via WhatsApp",
        WebStringKey.CONTACT_MESSAGE_TEMPLATE to "Hello FYAT Travel & Tour LTD,\n\nI would like to share the following comment:\n\nName: {0}\nEmail: {1}\nMessage: {2}\n\nThank you.",
        WebStringKey.CAR_PICKUP_CITY to "Pickup city",
        WebStringKey.CAR_DROPOFF_CITY_OPTIONAL to "Dropoff city (optional)",
        WebStringKey.CAR_PICKUP_DATE to "Pickup date",
        WebStringKey.CAR_DROPOFF_DATE to "Dropoff date",
        WebStringKey.CAR_PICKUP_TIME to "Pickup time (HH:mm)",
        WebStringKey.CAR_DROPOFF_TIME to "Dropoff time (HH:mm)",
        WebStringKey.ERROR_SEARCH_CARS_FAILED to "Failed to search car rentals",
        WebStringKey.ERROR_INVALID_RESPONSE to "Invalid response from server",
        WebStringKey.ERROR_NETWORK to "Network error (is the Cloud Function deployed?)",
        WebStringKey.OPEN_ON_BOOKING to "Open on Booking.com",
        WebStringKey.CAR_RESULTS_COUNT to "Cars ({0})",
        WebStringKey.CAR_LABEL to "Car",
        WebStringKey.ERROR_SEARCH_HOTELS_FAILED to "Failed to search hotels",
        WebStringKey.HOTEL_RESULTS_COUNT to "Hotels ({0})",
        WebStringKey.RATING_WITH_REVIEWS to "Rating: {0} ({1} reviews)",
        WebStringKey.NO_HOTELS_FOUND to "No hotels found for this search. Try a different city or dates.",
        WebStringKey.QUICK_SELECT to "Quick Select"
        ,WebStringKey.BOOK_YOUR_JOURNEY to "Book Your Journey"
        ,WebStringKey.CLOSE_FORM to "Close the form"
        ,WebStringKey.CLICK_TO_FILL_DETAILS to "Click to fill your travel details"
        ,WebStringKey.ENQUIRY_SENT to "✓ Enquiry sent! We'll contact you soon."
        ,WebStringKey.SEND_ANOTHER to "Send another"
        ,WebStringKey.ENTER_YOUR_NAME to "Enter your name"
        ,WebStringKey.EMAIL_LABEL to "Email"
        ,WebStringKey.SEND_INQUIRY to "Send Inquiry"
        ,WebStringKey.VALIDATION_ENTER_VALID_EMAIL to "Please enter a valid email address"
        ,WebStringKey.SERVICE_LABEL to "Service"
        ,WebStringKey.DEPARTURE_CITY_PLACEHOLDER to "Departure city"
        ,WebStringKey.DESTINATION_PLACEHOLDER to "Destination"
        ,WebStringKey.GUESTS_LABEL to "Guests"
        ,WebStringKey.GUESTS_PLACEHOLDER to "1 Adult"
        ,WebStringKey.NOTES_LABEL to "Notes"
        ,WebStringKey.NOTES_PLACEHOLDER to "Any special requests..."
        ,WebStringKey.SENDING to "Sending..."
        ,WebStringKey.SEND_EMAIL to "Send Email"
        ,WebStringKey.BOOKING_ENQUIRY_TITLE to "FYAT Travel & Tour - New Booking Enquiry"
        ,WebStringKey.VALIDATION_ENTER_FULL_NAME to "Please enter your full name"
        ,WebStringKey.VALIDATION_ENTER_EMAIL_OR_PHONE to "Please enter email or phone number"
        ,WebStringKey.VALIDATION_ENTER_DEPARTURE to "Please enter departure location"
        ,WebStringKey.VALIDATION_ENTER_DESTINATION to "Please enter destination"
        ,WebStringKey.ADDITIONAL_DETAILS_LABEL to "Additional Details"
        ,WebStringKey.GUESTS_AND_CABIN_LABEL to "Guests & Cabin"
        ,WebStringKey.FILTER_BY_AIRLINE to "Filter by Airline"
        ,WebStringKey.CLEAR_FILTER to "Clear filter"
        ,WebStringKey.NO_AIRLINE_FLIGHTS_FOUND to "No {0} flights found in these results."
        ,WebStringKey.NO_FLIGHTS_FOUND_MESSAGE to "No flights found. Try different dates or airports."
        ,WebStringKey.FLIGHT_OFFER_LABEL to "Flight Offer"
        ,WebStringKey.FLIGHT_NUMBER_LABEL to "Flight {0}"
        ,WebStringKey.COMPLETE_BOOKING to "Complete Your Booking"
        ,WebStringKey.BOOKING_REQUEST_SENT to "Booking Request Sent!"
        ,WebStringKey.BOOKING_REQUEST_SUBTITLE to "Our team will contact you shortly to confirm availability and payment options."
        ,WebStringKey.YOUR_DETAILS_SECTION to "Your Details"
        ,WebStringKey.TRAVEL_DETAILS_SECTION to "Travel Details"
        ,WebStringKey.GUESTS_EXAMPLE_PLACEHOLDER to "e.g., 2 Adults, 1 Child"
        ,WebStringKey.SPECIAL_REQUIREMENTS_PLACEHOLDER to "Any specific requirements, dietary needs, accessibility requests..."
        ,WebStringKey.PRIVACY_NOTE to "Your information will be used only to process this booking request. We will contact you within 24 hours."
        ,WebStringKey.SEND_VIA_EMAIL to "Send via Email"
        ,WebStringKey.OFFER_WEEKEND_ESCAPE to "Weekend Escape"
        ,WebStringKey.OFFER_WEEKEND_DESC to "Save big this weekend"
        ,WebStringKey.OFFER_HOLIDAY_DEALS to "Holiday Deals"
        ,WebStringKey.OFFER_HOLIDAY_DESC to "Limited time offer"
        ,WebStringKey.HOME_SUBTITLE to "Explore tours, flights, and travel offers"
        ,WebStringKey.HOME_HELP_TEXT to "Browse categories, open a product, and see full details — powered by your Firebase backend."
        ,WebStringKey.FEATURED_FLIGHT_OFFERS to "Featured Flight Offers"
        ,WebStringKey.VIEW_ALL to "View All →"
        ,WebStringKey.BROWSE_CATEGORIES to "Browse Categories"
        ,WebStringKey.ITEMS_COUNT to "{0} items"
        ,WebStringKey.BOOK_ACTION to "Book"
        ,WebStringKey.WHATSAPP_DEFAULT_MESSAGE to "Hi! I'm interested in your travel services. Can you help me?"
        ,WebStringKey.WHATSAPP_CHAT_LABEL to "Chat on WhatsApp"
        ,WebStringKey.WHATSAPP_ASK_LABEL to "Ask on WhatsApp"
        ,WebStringKey.WHATSAPP_NEED_HELP_TITLE to "Need help?"
        ,WebStringKey.WHATSAPP_HELP_SUBTITLE to "Chat with our travel experts"
        ,WebStringKey.WHATSAPP_CHAT_NOW to "Chat Now"
        ,WebStringKey.WHATSAPP_MESSAGE_FLIGHT to "Hi! I need help booking a flight. Can you assist me?"
        ,WebStringKey.WHATSAPP_MESSAGE_HOTEL to "Hi! I'm looking for hotel recommendations. Can you help?"
        ,WebStringKey.WHATSAPP_MESSAGE_VISA to "Hi! I have questions about visa requirements. Can you assist?"
        ,WebStringKey.WHATSAPP_MESSAGE_TOUR to "Hi! I'm interested in booking a tour package. Can you help?"
        ,WebStringKey.WHATSAPP_MESSAGE_CAR to "Hi! I need to rent a car. Can you provide options?"
        ,WebStringKey.WHATSAPP_MESSAGE_GENERAL to "Hi! I need assistance with travel booking. Can you help me?"
        ,WebStringKey.FIRESTORE_INDEX_REQUIRED_TITLE to "Database Index Required"
        ,WebStringKey.FIRESTORE_INDEX_REQUIRED_BODY to "The app needs a Firestore database index to show products by category. This is a one-time setup."
        ,WebStringKey.FIRESTORE_CREATE_INDEX to "Create Index →"
        ,WebStringKey.FIRESTORE_DISMISS to "Dismiss"
        ,WebStringKey.FIRESTORE_INDEX_NOTE to "Index: product → category (ascending) + createdAt (descending)"
        ,WebStringKey.FIRESTORE_INDEX_MISSING to "Database index missing. Click 'Create Index' to fix this."
        ,WebStringKey.FIRESTORE_ACCESS_DENIED to "Access denied. Please check your permissions."
        ,WebStringKey.FIRESTORE_NOT_FOUND to "The requested data was not found."
        ,WebStringKey.FIRESTORE_NETWORK_UNAVAILABLE to "Network unavailable. Please check your connection."
        ,WebStringKey.FOOTER_BRAND to "FYAT TRAVEL & TOUR LTD."
        ,WebStringKey.FOOTER_TAGLINE to "Your trusted partner for flights, hotels, visas, and adventures worldwide."
        ,WebStringKey.COPYRIGHT_TEXT to "© 2025 Fyat travel & tour Ltd."
        ,WebStringKey.QUICK_LINKS to "Quick Links"
        ,WebStringKey.SERVICES_LABEL to "Services"
        ,WebStringKey.ABOUT_US to "About Us"
        ,WebStringKey.CONTACT_LABEL to "Contact"
        ,WebStringKey.BOOK_NOW_LABEL to "Book Now"
        ,WebStringKey.TOP_SERVICES to "Top Services"
        ,WebStringKey.FLIGHT_BOOKING to "Flight Booking"
        ,WebStringKey.HOTEL_RESERVATIONS to "Hotel Reservations"
        ,WebStringKey.VISA_PROCESSING to "Visa Processing"
        ,WebStringKey.CAR_HIRE to "Car Hire"
        ,WebStringKey.GET_APP to "Get the App"
        ,WebStringKey.GET_IT_ON to "GET IT ON"
        ,WebStringKey.DOWNLOAD_ON to "Download on the"
        ,WebStringKey.GOOGLE_PLAY to "Google Play"
        ,WebStringKey.APP_STORE to "App Store"
        ,WebStringKey.PAYMENT_SUCCESS_TITLE to "Payment Successful!"
        ,WebStringKey.PAYMENT_SUCCESS_MESSAGE_WITH_NAME to "Thank you {0}! Your payment has been processed successfully."
        ,WebStringKey.PAYMENT_SUCCESS_MESSAGE_GENERIC to "Thank you! Your payment has been processed successfully."
        ,WebStringKey.ORDER_DETAILS to "Order Details"
        ,WebStringKey.ORDER_ID_LABEL to "Order ID:"
        ,WebStringKey.STATUS_LABEL to "Status:"
        ,WebStringKey.PAYMENT_STATUS_PAID to "PAID"
        ,WebStringKey.PAYMENT_METHOD_LABEL to "Payment Method:"
        ,WebStringKey.PAYMENT_METHOD_PESAPAL to "PesaPal"
        ,WebStringKey.CONFIRMATION_EMAIL_NOTE to "A confirmation email will be sent to you shortly. If you have any questions, please contact our support team."
        ,WebStringKey.BROWSE_MORE_PRODUCTS to "Browse More Products"
        ,WebStringKey.GO_TO_HOME to "Go to Home"
        ,WebStringKey.NEED_HELP_CONTACT to "Need help? Contact us at info@fyattraveltour.com or +256 758 250 625"
        ,WebStringKey.PAYMENT_FAILED_TITLE to "Payment Failed"
        ,WebStringKey.PAYMENT_FAILED_MESSAGE to "Unfortunately your payment was not completed. This may have been due to a cancellation or a technical issue."
        ,WebStringKey.PAYMENT_FAILED_SUGGESTIONS_TITLE to "What can you do?"
        ,WebStringKey.PAYMENT_FAILED_SUGGESTION_1 to "Try the payment again with a different card or mobile money"
        ,WebStringKey.PAYMENT_FAILED_SUGGESTION_2 to "Use WhatsApp to arrange a cash payment"
        ,WebStringKey.PAYMENT_FAILED_SUGGESTION_3 to "Contact our team and we will assist you manually"
        ,WebStringKey.PAYMENT_FAILED_SUGGESTION_4 to "Check your internet connection and try again"
        ,WebStringKey.TRY_AGAIN to "Try Again"
        ,WebStringKey.CONTACT_VIA_WHATSAPP to "Contact via WhatsApp"
        ,WebStringKey.PAYMENT_FAILED_WHATSAPP_MESSAGE to "Hi, I tried to make a payment but it failed. I would like to arrange my booking for product ID: {0}"
    )
 
    private val am = mapOf(
        WebStringKey.APP_NAME to "Fyat Travel & Tour Ltd",
        WebStringKey.SIGN_IN_SUBTITLE to "ለመቀጠል እባክዎ ይግቡ",
        WebStringKey.AUTH_SUCCESS to "ማረጋገጫ ተሳክቷል!",
        WebStringKey.ERROR_NO_INTERNET to "የኢንተርኔት ግንኙነት የለም።",
        WebStringKey.ERROR_SIGN_IN_CANCELED to "መግባት ተሰርዟል።",
        WebStringKey.ERROR_UNKNOWN to "ያልታወቀ ስህተት አጋጥሟል",
        WebStringKey.SIGN_IN_WITH_GOOGLE to "በGoogle ይግቡ",
        WebStringKey.PLEASE_WAIT to "እባክዎ ይጠብቁ...",
        WebStringKey.CONTACT_US to "ያግኙን",
        WebStringKey.BACK to "ተመለስ",
        WebStringKey.GET_IN_TOUCH to "ያግኙን",
        WebStringKey.CONNECT_SOCIAL_MEDIA to "በማህበራዊ ሚዲያ ይከተሉን",
        WebStringKey.CHAT_WITH_US to "ያነጋግሩን",
        WebStringKey.FOLLOW_US to "ይከተሉን",
        WebStringKey.NEED_IMMEDIATE_ASSISTANCE to "አስቸኳይ እርዳታ ይፈልጋሉ?",
        WebStringKey.WHATSAPP_FASTEST_RESPONSE to "ለፈጣን ምላሽ በWhatsApp መልዕክት ይላኩ",
        WebStringKey.WHATSAPP to "WhatsApp",
        WebStringKey.INSTAGRAM to "Instagram",
        WebStringKey.FACEBOOK to "Facebook",
        WebStringKey.TWITTER_X to "Twitter (X)",
        WebStringKey.TIKTOK to "TikTok",
        WebStringKey.OPEN_LINK to "ክፈት",
        WebStringKey.MY_PROFILE to "መገለጫዬ",
        WebStringKey.UPDATE to "አድስ",
        WebStringKey.SUCCESSFULLY_UPDATED to "በተሳካ ሁኔታ ታድሷል!",
        WebStringKey.OOPS to "ይቅርታ!",
        WebStringKey.LANGUAGE to "ቋንቋ",
        WebStringKey.SELECT_LANGUAGE_TITLE to "ቋንቋ ይምረጡ",
        WebStringKey.CHOOSE_PREFERRED_LANGUAGE to "የሚመርጡትን ቋንቋ ይምረጡ",
        WebStringKey.SELECTED to "ተመርጧል",
        WebStringKey.COMING_SOON to "በቅርብ ቀን",
        WebStringKey.MORE_LANGUAGES_COMING to "ተጨማሪ ቋንቋዎች በቅርቡ ይጠበቃሉ!",
        WebStringKey.INFO to "መረጃ",
        WebStringKey.ENGLISH to "እንግሊዝኛ",
        WebStringKey.KISWAHILI to "ስዋሂሊ",
        WebStringKey.TIGRINYA to "ትግርኛ",
        WebStringKey.AMHARIC to "አማርኛ",
        WebStringKey.ARABIC to "አረብኛ",
        WebStringKey.SOMALI to "ሶማሊኛ",
        WebStringKey.FYAT_TRAVEL_TOUR to "Fyat Travel & Tour Ltd",
        WebStringKey.TRAVEL_OPERATOR to "የጉዞ አገልግሎት",
        WebStringKey.PROFILE to "መገለጫ",
        WebStringKey.SIGN_OUT to "ውጣ",
        WebStringKey.ADMIN to "አስተዳዳሪ",
        WebStringKey.BLOG to "ብሎግ",
        WebStringKey.LOCATIONS to "ቦታዎች",
        WebStringKey.CHECKOUT to "ሂሳብ ክፈል",
        WebStringKey.MENU to "ምናሌ",
        WebStringKey.CLOSE to "ዝጋ",
        WebStringKey.SHOP to "ሱቅ",
        WebStringKey.EXPLORE_LABEL to "ያስሱ",
        WebStringKey.CART_LABEL to "ቅርጫት",
        WebStringKey.CATEGORIES_LABEL to "ምድቦች",
        WebStringKey.CATEGORIES_SEARCH_PLACEHOLDER to "ምድቦችን ፈልግ...",
        WebStringKey.CATEGORIES_FILTER_ALL to "ሁሉም",
        WebStringKey.CATEGORIES_FILTER_FLIGHTS to "በረራዎች",
        WebStringKey.CATEGORIES_FILTER_HOTELS to "ሆቴሎች",
        WebStringKey.CATEGORIES_FILTER_GUEST_HOUSES to "የእንግዳ ቤቶች",
        WebStringKey.CATEGORIES_FILTER_CAR_RENTALS to "የመኪና ኪራይ",
        WebStringKey.CATEGORIES_FILTER_VISA_SERVICES to "የቪዛ አገልግሎት",
        WebStringKey.CATEGORIES_FILTER_TOURS to "ጉብኝቶች",
        WebStringKey.CATEGORIES_FILTER_TRANSFERS to "ትራንስፈር",
        WebStringKey.CATEGORIES_EMPTY to "በFirestore ላይ ምንም ምድብ አልተገኘም።",
        WebStringKey.CATEGORIES_NO_MATCH to "ምንም ምድብ ከፍለጋዎ ጋር አልተዛመደም",
        WebStringKey.CATEGORIES_CLEAR_FILTERS to "ማጣሪያዎችን አጥፋ",
        WebStringKey.CATEGORIES_SHOWING_COUNT to "ከ{1} ምድቦች ውስጥ {0} ታሳያለህ",
        WebStringKey.CATEGORY_TYPE_OTHER to "ሌላ",
        WebStringKey.FLIGHT_OFFERS to "የበረራ ቅናሾች",
        WebStringKey.HOTEL to "ሆቴል",
        WebStringKey.GUEST_HOUSE to "የእንግዳ ማረፊያ",
        WebStringKey.CAR_RENTAL to "የመኪና ኪራይ",
        WebStringKey.TOUR to "ጉብኝት",
        WebStringKey.TOUR_PACKAGES to "የጉብኝት ጥቅሎች",
        WebStringKey.EXPLORE_FLIGHTS to "በረራዎች",
        WebStringKey.EXPLORE_STAYS to "ማረፊያዎች",
        WebStringKey.EXPLORE_TRANSFER to "ትራንስፈር",
        WebStringKey.EXPLORE_VISA to "ቪዛ",
        WebStringKey.ERROR_WITH_MESSAGE to "ስህተት: {0}",
        WebStringKey.FLIGHT_TAB_RETURN to "ደርሶ መልስ",
        WebStringKey.FLIGHT_TAB_ONE_WAY to "አንድ መንገድ",
        WebStringKey.FLIGHT_TAB_MULTI_CITY to "ባለብዙ ከተማ",
        WebStringKey.FLIGHT_FROM to "ከ",
        WebStringKey.FLIGHT_TO to "ወደ",
        WebStringKey.FLIGHT_SELECT_AIRPORT to "አውሮፕላን ማረፊያ ይምረጡ",
        WebStringKey.FLIGHT_DEPARTURE to "መነሻ",
        WebStringKey.FLIGHT_RETURN to "መልስ",
        WebStringKey.FLIGHT_ORIGIN_PLACEHOLDER to "መነሻ (ለምሳሌ፦ EBB)",
        WebStringKey.FLIGHT_DESTINATION_PLACEHOLDER to "መድረሻ (ለምሳሌ፦ NBO)",
        WebStringKey.FLIGHT_SELECT_DATE to "ቀን ይምረጡ",
        WebStringKey.FLIGHT_TRAVELERS to "ተጓዦች",
        WebStringKey.FLIGHT_TRAVELLER_SINGULAR to "ተጓዥ",
        WebStringKey.FLIGHT_TRAVELLER_PLURAL to "ተጓዦች",
        WebStringKey.FLIGHT_CABIN to "የጉዞ ክፍል",
        WebStringKey.FLIGHT_SEARCH to "ፈልግ",
        WebStringKey.FLIGHT_SPECIAL_OFFERS to "ልዩ የበረራ ቅናሾች ✈️",
        WebStringKey.FLIGHT_NO_OFFERS to "ምንም የበረራ ቅናሽ አልተገኘም",
        WebStringKey.FLIGHT_CLOSE to "ዝጋ",
        WebStringKey.FLIGHT_DONE to "ተጠናቀቀ",
        WebStringKey.FLIGHT_ADULTS to "አዋቂዎች",
        WebStringKey.FLIGHT_ADULTS_WITH_COUNT to "አዋቂዎች: {0}",
        WebStringKey.FLIGHT_INCREASE to "ጨምር",
        WebStringKey.FLIGHT_DECREASE to "ቀንስ",
        WebStringKey.FLIGHT_PRICE to "ዋጋ",
        WebStringKey.FLIGHT_DISCOUNTED to "ቅናሽ ያለው",
        WebStringKey.FLIGHT_NEW to "አዲስ",
        WebStringKey.FLIGHT_DETAILS to "የበረራ ዝርዝር",
        WebStringKey.FLIGHT_AVAILABLE_OPTIONS to "ያሉ አማራጮች",
        WebStringKey.FLIGHT_BOOK_NOW_FROM to "አሁኑኑ ይያዙ",
        WebStringKey.FLIGHT_ARROW to "→",
        WebStringKey.FLIGHT_CABIN_ECONOMY to "ኢኮኖሚ",
        WebStringKey.FLIGHT_CABIN_PREMIUM_ECONOMY to "ፕሪሚየም ኢኮኖሚ",
        WebStringKey.FLIGHT_CABIN_BUSINESS to "ቢዝነስ ክላስ",
        WebStringKey.FLIGHT_CABIN_FIRST to "ፈርስት ክላስ",
        WebStringKey.VISA_TITLE to "የቪዛ መስፈርቶች",
        WebStringKey.VISA_SUBTITLE to "ለጉዞዎ የሚያስፈልጉ የቪዛ መስፈርቶችን ይፈትሹ",
        WebStringKey.VISA_PASSPORT_COUNTRY to "የፓስፖርት ሀገር",
        WebStringKey.VISA_DESTINATION_COUNTRY to "መድረሻ ሀገር",
        WebStringKey.VISA_PASSPORT_HINT to "ሀገር ይፈልጉ (ለምሳሌ: ኢትዮጵያ)",
        WebStringKey.VISA_DESTINATION_HINT to "ሀገር ይፈልጉ (ለምሳሌ: ኡጋንዳ)",
        WebStringKey.VISA_CHECKING to "በመፈተሽ ላይ...",
        WebStringKey.VISA_CHECK_BUTTON to "የቪዛ መስፈርቶችን እይ",
        WebStringKey.VISA_ERROR to "ስህተት",
        WebStringKey.VISA_ALWAYS_VERIFY to "ℹ️ እባክዎ ከመጓዝዎ በፊት መረጃዎችን ከዋና ምንጮች ያረጋግጡ",
        WebStringKey.VISA_EXPAND_DETAILS to "ዝርዝር አሳይ",
        WebStringKey.VISA_COLLAPSE_DETAILS to "ዝርዝር ደብቅ",
        WebStringKey.VISA_STAY_DURATION to "የቆይታ ጊዜ: {0}",
        WebStringKey.VISA_NO_DETAILS to "ተጨማሪ መረጃ የለም።",
        WebStringKey.VISA_SEARCH_TIP to "💡 ሀገር በስም ወይም በኮድ ይፈልጉ",
        WebStringKey.VISA_CURRENCY to "ምንዛሬ",
        WebStringKey.VISA_CAPITAL to "ዋና ከተማ",
        WebStringKey.VISA_PASSPORT_VALIDITY to "የፓስፖርት ፀናኝት",
        WebStringKey.VISA_STATUS_VISA_FREE to "ቪዛ አያስፈልግም",
        WebStringKey.VISA_STATUS_VISA_ON_ARRIVAL to "ቪዛ በመድረሻ",
        WebStringKey.VISA_STATUS_EVISA to "ኢ-ቪዛ (e-Visa)",
        WebStringKey.VISA_STATUS_VISA_REQUIRED to "ቪዛ ያስፈልጋል",
        WebStringKey.VISA_STATUS_UNKNOWN to "ያልታወቀ",
        WebStringKey.CAR_FIND_A_CAR to "መኪና ፈልግ",
        WebStringKey.CAR_PICKUP_LOCATION to "የመረከቢያ ቦታ",
        WebStringKey.CAR_DROPOFF_LOCATION_OPTIONAL to "የመመለሻ ቦታ (አማራጭ)",
        WebStringKey.CAR_PICKUP_DATETIME to "የመረከቢያ ቀን እና ሰዓት",
        WebStringKey.CAR_DROPOFF_DATETIME to "የመመለሻ ቀን እና ሰዓት",
        WebStringKey.CAR_DRIVER_AGE to "የአሽከርካሪ ዕድሜ",
        WebStringKey.CAR_SEARCH_CARS to "መኪናዎችን ፈልግ",
        WebStringKey.HOTEL_WHERE_TO to "ወዴት መሄድ ይፈልጋሉ?",
        WebStringKey.HOTEL_SEARCH_DESTINATION to "መድረሻ ፈልግ",
        WebStringKey.HOTEL_CHECK_IN to "የመግቢያ ቀን",
        WebStringKey.HOTEL_CHECK_OUT to "የመውጫ ቀን",
        WebStringKey.HOTEL_ADULTS to "ጎልማሶች",
        WebStringKey.HOTEL_ROOMS to "ክፍሎች",
        WebStringKey.HOTEL_GUESTS_ROOMS to "እንግዶች እና ክፍሎች",
        WebStringKey.HOTEL_ADULT_SINGULAR to "አዋቂ",
        WebStringKey.HOTEL_ADULT_PLURAL to "አዋቂዎች",
        WebStringKey.HOTEL_CHILD_SINGULAR to "ልጅ",
        WebStringKey.HOTEL_CHILD_PLURAL to "ልጆች",
        WebStringKey.HOTEL_ROOM_SINGULAR to "ክፍል",
        WebStringKey.HOTEL_ROOM_PLURAL to "ክፍሎች",
        WebStringKey.HOTEL_SEARCH_HOTELS to "ሆቴሎችን ፈልግ",
        WebStringKey.HOTEL_WHERE_ARE_YOU_GOING to "ወዴት ነው የሚሄዱት?",
        WebStringKey.HOTEL_ENTER_CITY_HOTEL_DESTINATION to "የከተማ ስም ወይም ሆቴል ያስገቡ",
        WebStringKey.HOTEL_SEARCHING_DESTINATIONS to "በመፈለግ ላይ...",
        WebStringKey.HOTEL_NO_DESTINATIONS_FOUND to "ምንም መድረሻ አልተገኘም",
        WebStringKey.HOTEL_TRY_DIFFERENT_SEARCH_TERM to "ሌላ ቃል ይሞክሩ",
        WebStringKey.HOTEL_CLEAR to "አጽዳ",
        WebStringKey.HOTEL_HOTELS to "ሆቴሎች",
        WebStringKey.CONTACT_SUBTITLE to "ሁሉንም የጉዞ ፍላጎቶችዎን ለመርዳት እዚህ ነን።",
        WebStringKey.CONTACT_INFORMATION to "የመገኛ መረጃ",
        WebStringKey.SOCIAL_LABEL to "ማህበራዊ",
        WebStringKey.SEND_A_COMMENT to "አስተያየት ላክ",
        WebStringKey.YOUR_NAME to "ስምዎ",
        WebStringKey.FULL_NAME_PLACEHOLDER to "ሙሉ ስም",
        WebStringKey.EMAIL_OPTIONAL to "ኢሜይል (አማራጭ)",
        WebStringKey.EMAIL_PLACEHOLDER to "you@example.com",
        WebStringKey.MESSAGE_COMMENTS to "መልእክት / አስተያየት",
        WebStringKey.MESSAGE_PLACEHOLDER to "መልእክትዎን እዚህ ይጻፉ...",
        WebStringKey.ERROR_NAME_MESSAGE_REQUIRED to "እባክዎ ስምዎን እና መልእክትዎን ያስገቡ።",
        WebStringKey.WHATSAPP_SENT_HINT to "WhatsApp ከመልእክትዎ ጋር ተከፍቷል። ለመላክ ላክ ይጫኑ።",
        WebStringKey.SEND_VIA_WHATSAPP to "በWhatsApp ላክ",
        WebStringKey.CONTACT_MESSAGE_TEMPLATE to "ሰላም FYAT Travel & Tour LTD፣\n\nእነዚህን አስተያየቶች መጋራት እፈልጋለሁ፦\n\nስም: {0}\nኢሜይል: {1}\nመልእክት: {2}\n\nእናመሰግናለን።",
        WebStringKey.CAR_PICKUP_CITY to "የመረከቢያ ከተማ",
        WebStringKey.CAR_DROPOFF_CITY_OPTIONAL to "የመመለሻ ከተማ (አማራጭ)",
        WebStringKey.CAR_PICKUP_DATE to "የመረከቢያ ቀን",
        WebStringKey.CAR_DROPOFF_DATE to "የመመለሻ ቀን",
        WebStringKey.CAR_PICKUP_TIME to "የመረከቢያ ሰዓት (HH:mm)",
        WebStringKey.CAR_DROPOFF_TIME to "የመመለሻ ሰዓት (HH:mm)",
        WebStringKey.ERROR_SEARCH_CARS_FAILED to "የመኪና ኪራይ መፈለግ አልተሳካም",
        WebStringKey.ERROR_INVALID_RESPONSE to "ከሰርቨር የተሳሳተ ምላሽ",
        WebStringKey.ERROR_NETWORK to "የኔትወርክ ስህተት (Cloud Function ተተግብሯል?)",
        WebStringKey.OPEN_ON_BOOKING to "በBooking.com ክፈት",
        WebStringKey.CAR_RESULTS_COUNT to "መኪናዎች ({0})",
        WebStringKey.CAR_LABEL to "መኪና",
        WebStringKey.ERROR_SEARCH_HOTELS_FAILED to "ሆቴል መፈለግ አልተሳካም",
        WebStringKey.HOTEL_RESULTS_COUNT to "ሆቴሎች ({0})",
        WebStringKey.RATING_WITH_REVIEWS to "ደረጃ: {0} ({1} ግምገማዎች)",
        WebStringKey.NO_HOTELS_FOUND to "ለዚህ ፍለጋ ሆቴል አልተገኘም። ሌላ ከተማ ወይም ቀኖችን ይሞክሩ።",
        WebStringKey.QUICK_SELECT to "ፈጣን ምርጫ",
        WebStringKey.BOOK_YOUR_JOURNEY to "ጉዞዎን ያዝዙ",
        WebStringKey.CLOSE_FORM to "ፎርሙን ዝጋ",
        WebStringKey.CLICK_TO_FILL_DETAILS to "የጉዞ ዝርዝሮችን ለመሙላት ጠቅ ያድርጉ",
        WebStringKey.ENQUIRY_SENT to "✓ ጥያቄዎ ተልኳል! በቅርቡ እንገናኛለን።",
        WebStringKey.SEND_ANOTHER to "ሌላ ላክ",
        WebStringKey.ENTER_YOUR_NAME to "ስምዎን ያስገቡ",
        WebStringKey.EMAIL_LABEL to "ኢሜይል",
        WebStringKey.SERVICE_LABEL to "አገልግሎት",
        WebStringKey.DEPARTURE_CITY_PLACEHOLDER to "የመነሻ ከተማ",
        WebStringKey.DESTINATION_PLACEHOLDER to "መድረሻ",
        WebStringKey.GUESTS_LABEL to "እንግዶች",
        WebStringKey.GUESTS_PLACEHOLDER to "1 አዋቂ",
        WebStringKey.NOTES_LABEL to "ማስታወሻ",
        WebStringKey.NOTES_PLACEHOLDER to "ልዩ ጥያቄዎች...",
        WebStringKey.SENDING to "በመላክ ላይ...",
        WebStringKey.SEND_EMAIL to "ኢሜይል ላክ",
        WebStringKey.CONNECTIVITY_NO_INTERNET to "የኢንተርኔት ግንኙነት የለም",
        WebStringKey.CONNECTIVITY_RETRY to "ዳግም ይሞክሩ",
        WebStringKey.CONNECTIVITY_CONNECTED to "ተገናኝቷል",
        WebStringKey.BOOKING_ENQUIRY_TITLE to "FYAT Travel & Tour - አዲስ የቦታ ጥያቄ",
        WebStringKey.VALIDATION_ENTER_FULL_NAME to "እባክዎ ሙሉ ስምዎን ያስገቡ",
        WebStringKey.VALIDATION_ENTER_EMAIL_OR_PHONE to "እባክዎ ኢሜይል ወይ ስልክ ቁጥር ያስገቡ",
        WebStringKey.VALIDATION_ENTER_DEPARTURE to "እባክዎ የመነሻ ቦታ ያስገቡ",
        WebStringKey.VALIDATION_ENTER_DESTINATION to "እባክዎ መድረሻ ያስገቡ",
        WebStringKey.ADDITIONAL_DETAILS_LABEL to "ተጨማሪ ዝርዝሮች",
        WebStringKey.GUESTS_AND_CABIN_LABEL to "እንግዶች & ክፍል",
        WebStringKey.FILTER_BY_AIRLINE to "በአውሮፕላን ኩባንያ አጣራ",
        WebStringKey.CLEAR_FILTER to "ማጣሪያ አጥፋ",
        WebStringKey.NO_AIRLINE_FLIGHTS_FOUND to "በዚህ ውጤት ውስጥ {0} በረራ የለም።",
        WebStringKey.NO_FLIGHTS_FOUND_MESSAGE to "ምንም በረራ አልተገኘም። ቀኖችን ወይም አየር ማረፊያዎችን ይሞክሩ።",
        WebStringKey.FLIGHT_OFFER_LABEL to "የበረራ አቅርቦት",
        WebStringKey.FLIGHT_NUMBER_LABEL to "በረራ {0}",
        WebStringKey.COMPLETE_BOOKING to "ቦታ መያዝዎን ያጠናቁ",
        WebStringKey.BOOKING_REQUEST_SENT to "የቦታ ጥያቄው ተልኳል!",
        WebStringKey.BOOKING_REQUEST_SUBTITLE to "ቡድናችን ቅርብ ጊዜ ውስጥ ለመረጋገጥ እና የክፍያ አማራጮችን ለማሳወቅ ይገናኛል።",
        WebStringKey.YOUR_DETAILS_SECTION to "ዝርዝሮችዎ",
        WebStringKey.TRAVEL_DETAILS_SECTION to "የጉዞ ዝርዝሮች",
        WebStringKey.GUESTS_EXAMPLE_PLACEHOLDER to "ለምሳሌ፦ 2 አዋቂዎች፣ 1 ልጅ",
        WebStringKey.SPECIAL_REQUIREMENTS_PLACEHOLDER to "ልዩ መስፈርቶች፣ የእንጀራ ፍላጎቶች፣ የእርዳታ ጥያቄዎች...",
        WebStringKey.PRIVACY_NOTE to "መረጃዎ ይህን የቦታ ጥያቄ ለመቀናበር ብቻ ይጠቀማል። በ24 ሰዓታት ውስጥ እንገናኛለን።",
        WebStringKey.SEND_VIA_EMAIL to "በኢሜይል ላክ",
        WebStringKey.OFFER_WEEKEND_ESCAPE to "የሳምንቱ እረፍት",
        WebStringKey.OFFER_WEEKEND_DESC to "በዚህ ሳምንት ብዙ ቁጠባ",
        WebStringKey.OFFER_HOLIDAY_DEALS to "የበዓል ቅናሾች",
        WebStringKey.OFFER_HOLIDAY_DESC to "የጊዜያዊ ቅናሽ",
        WebStringKey.HOME_SUBTITLE to "ጉብኝቶችን፣ በረራዎችን እና የጉዞ ቅናሾችን ያስሱ",
        WebStringKey.HOME_HELP_TEXT to "ምድቦችን ያስሱ፣ ምርት ይክፈቱ እና ሙሉ ዝርዝር ይዩ — በFirebase የተጎዳኘ።",
        WebStringKey.FEATURED_FLIGHT_OFFERS to "ተመራጭ የበረራ ቅናሾች",
        WebStringKey.VIEW_ALL to "ሁሉንም ይመልከቱ →",
        WebStringKey.BROWSE_CATEGORIES to "ምድቦችን ያስሱ",
        WebStringKey.ITEMS_COUNT to "{0} እቃዎች",
        WebStringKey.BOOK_ACTION to "ቦታ ያዝ",
        WebStringKey.WHATSAPP_DEFAULT_MESSAGE to "ሰላም! በጉዞ አገልግሎትዎ ላይ ፍላጎት አለኝ። ልትረዱኝ ትችላላችሁ?",
        WebStringKey.WHATSAPP_CHAT_LABEL to "በWhatsApp ይወያዩ",
        WebStringKey.WHATSAPP_ASK_LABEL to "በWhatsApp ጠይቅ",
        WebStringKey.WHATSAPP_NEED_HELP_TITLE to "እርዳታ ይፈልጋሉ?",
        WebStringKey.WHATSAPP_HELP_SUBTITLE to "ከጉዞ ባለሙያዎቻችን ጋር ይወያዩ",
        WebStringKey.WHATSAPP_CHAT_NOW to "አሁን ይወያዩ",
        WebStringKey.WHATSAPP_MESSAGE_FLIGHT to "ሰላም! በረራ ለመቀየር እርዳታ እፈልጋለሁ። ትረዱኝ?",
        WebStringKey.WHATSAPP_MESSAGE_HOTEL to "ሰላም! የሆቴል ምክሮች እፈልጋለሁ። ትረዱኝ?",
        WebStringKey.WHATSAPP_MESSAGE_VISA to "ሰላም! ስለ ቪዛ መስፈርቶች ጥያቄ አለኝ። ትረዱኝ?",
        WebStringKey.WHATSAPP_MESSAGE_TOUR to "ሰላም! የጉብኝት ጥቅል ለመቀየር ፍላጎት አለኝ። ትረዱኝ?",
        WebStringKey.WHATSAPP_MESSAGE_CAR to "ሰላም! መኪና ለመከራየት እፈልጋለሁ። አማራጮች ትሰጡኝ?",
        WebStringKey.WHATSAPP_MESSAGE_GENERAL to "ሰላም! በጉዞ መያዝ ላይ እርዳታ እፈልጋለሁ። ትረዱኝ?",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_TITLE to "የዳታቤዝ መረጃ ማውጫ ያስፈልጋል",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_BODY to "ምርቶችን በምድብ ለማሳየት የFirestore ኢንዴክስ ያስፈልጋል። ይህ አንድ ጊዜ ማስተካከያ ነው።",
        WebStringKey.FIRESTORE_CREATE_INDEX to "ኢንዴክስ ፍጠር →",
        WebStringKey.FIRESTORE_DISMISS to "ዝጋ",
        WebStringKey.FIRESTORE_INDEX_NOTE to "ኢንዴክስ: product → category (ከፍ የሚል) + createdAt (ዝቅ የሚል)",
        WebStringKey.FIRESTORE_INDEX_MISSING to "የዳታቤዝ ኢንዴክስ ጠፍቷል። 'ኢንዴክስ ፍጠር' ይጫኑ።",
        WebStringKey.FIRESTORE_ACCESS_DENIED to "መድረሻ ተከልክሏል። ፈቃዶችን ይፈትሹ።",
        WebStringKey.FIRESTORE_NOT_FOUND to "የተጠየቀው ዳታ አልተገኘም።",
        WebStringKey.FIRESTORE_NETWORK_UNAVAILABLE to "ኔትወርክ አይገኝም። ግንኙነትዎን ይፈትሹ።",
        WebStringKey.FOOTER_BRAND to "FYAT TRAVEL & TOUR LTD.",
        WebStringKey.FOOTER_TAGLINE to "ለበረራ፣ ሆቴል፣ ቪዛ እና የዓለም አቀፍ መንገዶች የታመነ አጋርዎ።",
        WebStringKey.COPYRIGHT_TEXT to "© 2025 Fyat travel & tour Ltd.",
        WebStringKey.QUICK_LINKS to "ፈጣን አገናኞች",
        WebStringKey.SERVICES_LABEL to "አገልግሎቶች",
        WebStringKey.ABOUT_US to "ስለ እኛ",
        WebStringKey.CONTACT_LABEL to "አግኙን",
        WebStringKey.BOOK_NOW_LABEL to "አሁኑኑ ይያዙ",
        WebStringKey.TOP_SERVICES to "ምርጥ አገልግሎቶች",
        WebStringKey.FLIGHT_BOOKING to "የበረራ ማስያዝ",
        WebStringKey.HOTEL_RESERVATIONS to "የሆቴል ማስያዝ",
        WebStringKey.VISA_PROCESSING to "የቪዛ ስራ",
        WebStringKey.CAR_HIRE to "የመኪና ኪራይ",
        WebStringKey.GET_APP to "መተግበሪያውን ያግኙ",
        WebStringKey.GET_IT_ON to "ያግኙት በ",
        WebStringKey.DOWNLOAD_ON to "ከዚህ ያውርዱ",
        WebStringKey.GOOGLE_PLAY to "Google Play",
        WebStringKey.APP_STORE to "App Store",
        WebStringKey.PAYMENT_SUCCESS_TITLE to "ክፍያ ተሳክቷል!",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_WITH_NAME to "እናመሰግናለን {0}! ክፍያዎ ተከናውኗል።",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_GENERIC to "እናመሰግናለን! ክፍያዎ ተከናውኗል።",
        WebStringKey.ORDER_DETAILS to "የትእዛዝ ዝርዝሮች",
        WebStringKey.ORDER_ID_LABEL to "የትእዛዝ መለያ:",
        WebStringKey.STATUS_LABEL to "ሁኔታ:",
        WebStringKey.PAYMENT_STATUS_PAID to "ተከፍሏል",
        WebStringKey.PAYMENT_METHOD_LABEL to "የክፍያ መንገድ:",
        WebStringKey.PAYMENT_METHOD_PESAPAL to "PesaPal",
        WebStringKey.CONFIRMATION_EMAIL_NOTE to "የማረጋገጫ ኢሜይል በቅርቡ ይላካል። ጥያቄ ካለዎት የድጋፍ ቡድናችንን ያነጋግሩ።",
        WebStringKey.BROWSE_MORE_PRODUCTS to "ተጨማሪ ምርቶችን ያስሱ",
        WebStringKey.GO_TO_HOME to "ወደ መነሻ ይመለሱ",
        WebStringKey.NEED_HELP_CONTACT to "እርዳታ ይፈልጋሉ? info@fyattraveltour.com ወይም +256 758 250 625 ያነጋግሩን",
        WebStringKey.PAYMENT_FAILED_TITLE to "ክፍያ አልተሳካም",
        WebStringKey.PAYMENT_FAILED_MESSAGE to "ይቅርታ፣ ክፍያው አልተጠናቀቀም። ይህ በማጥፋት ወይም ቴክኒክ ችግኝ ምክንያት ሊሆን ይችላል።",
        WebStringKey.PAYMENT_FAILED_SUGGESTIONS_TITLE to "ምን ማድረግ ይቻላል?",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_1 to "በሌላ ካርድ ወይም በሞባይል ገንዘብ እንደገና ሙከሩ",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_2 to "በWhatsApp የእጅ ክፍያ ለማዘጋጀት ይጠቀሙ",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_3 to "ከቡድናችን ጋር ያነጋግሩ እና በእጅ እንረዳዎታለን",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_4 to "የኢንተርኔት ግንኙነትዎን ያረጋግጡ እና እንደገና ሙከሩ",
        WebStringKey.TRY_AGAIN to "እንደገና ሞክር",
        WebStringKey.CONTACT_VIA_WHATSAPP to "በWhatsApp ያነጋግሩ",
        WebStringKey.PAYMENT_FAILED_WHATSAPP_MESSAGE to "ሰላም፣ ክፍያ ለማድረግ ሞከርኩ ግን አልተሳካም። ለዚህ ምርት ማስያዝ እፈልጋለሁ: {0}"
        ,WebStringKey.SEND_INQUIRY to "ጥያቄ ላክ"
        ,WebStringKey.VALIDATION_ENTER_VALID_EMAIL to "እባክዎ ትክክለኛ የኢሜይል አድራሻ ያስገቡ"
    )

    private val ar = mapOf(
        WebStringKey.APP_NAME to "فيات للسفر والسياحة المحدودة",
        WebStringKey.BRAND_SHORT to "FyatTravel",
        WebStringKey.BRAND_SUFFIX to "Tour LTD",
        WebStringKey.SEARCH to "بحث",
        WebStringKey.GO to "اذهب",
        WebStringKey.UPDATED_AT to "آخر تحديث: {0}",
        WebStringKey.REFRESH to "تحديث",
        WebStringKey.CATEGORIES to "الفئات",
        WebStringKey.CART to "السلة",
        WebStringKey.FLIGHTS to "الرحلات",
        WebStringKey.STAYS to "الإقامات",
        WebStringKey.CARS to "السيارات",
        WebStringKey.CARS_PAGE_SUBTITLE to "أخبرنا بتفاصيل تأجير السيارة وسيتواصل معك فريقنا عبر واتساب أو البريد الإلكتروني.",
        WebStringKey.VISA to "التأشيرة",
        WebStringKey.EXPLORE to "استكشاف",
        WebStringKey.CONTACT to "اتصل بنا",
        WebStringKey.STAYS_PAGE_SUBTITLE to "أخبرنا بتفاصيل إقامتك وسيتواصل معك فريقنا عبر واتساب أو البريد الإلكتروني.",
        WebStringKey.MY_PROFILE to "ملفي الشخصي",
        WebStringKey.SIGN_OUT to "تسجيل الخروج",
        WebStringKey.ACCOUNT_ACTIONS to "إجراءات الحساب",
        WebStringKey.EMAIL_NOT_VERIFIED to "⚠ البريد الإلكتروني غير مُؤكد",
        WebStringKey.USER_LABEL to "مستخدم",
        WebStringKey.USER_ID to "معرّف المستخدم",
        WebStringKey.PHONE_NUMBER to "الهاتف",
        WebStringKey.NOT_PROVIDED to "غير متوفر",
        WebStringKey.EMAIL_VERIFIED to "تم تأكيد البريد الإلكتروني",
        WebStringKey.YES_TEXT to "نعم",
        WebStringKey.NO_TEXT to "لا",
        WebStringKey.ACCOUNT_TYPE to "نوع الحساب",
        WebStringKey.ACCOUNT_TYPE_EMAIL to "بريد إلكتروني",
        WebStringKey.ACCOUNT_TYPE_PHONE to "هاتف",
        WebStringKey.SIGN_OUT_TITLE to "تسجيل الخروج",
        WebStringKey.SIGN_OUT_CONFIRMATION to "هل أنت متأكد أنك تريد تسجيل الخروج؟ ستحتاج إلى تسجيل الدخول مرة أخرى للوصول إلى حسابك.",
        WebStringKey.SIGN_IN to "تسجيل الدخول",
        WebStringKey.PROFILE to "الملف الشخصي",
        WebStringKey.ADMIN to "المسؤول",
        WebStringKey.NOT_FOUND to "غير موجود",
        WebStringKey.UNKNOWN_ROUTE to "مسار غير معروف: {0}",
        WebStringKey.EXPLORE_COMING_SOON to "صفحة الاستكشاف للويب قادمة قريبًا.",
        WebStringKey.CART_COMING_SOON to "صفحة السلة للويب قادمة قريبًا.",
        WebStringKey.ADMIN_COMING_SOON to "لوحة تحكم المسؤول للويب ستُجهّز قريبًا.",
        WebStringKey.SEARCH_PAGE to "بحث",
        WebStringKey.SEARCH_WITH_QUERY to "بحث: {0}",
        WebStringKey.TRAVELERS_ECONOMY_CURRENCY to "مسافر واحد • الدرجة الاقتصادية • USD / UGX",
        WebStringKey.SEARCHING to "جارٍ البحث...",
        WebStringKey.VISA_PAGE_SUBTITLE to "تحقق من متطلبات التأشيرة لأي وجهة. أدخل بلد جواز سفرك والوجهة التي تريد السفر إليها.",
        WebStringKey.PASSPORT_COUNTRY_LABEL to "بلد جواز السفر",
        WebStringKey.SELECT_PASSPORT_COUNTRY to "اختر بلد جواز السفر",
        WebStringKey.DESTINATION_COUNTRY_LABEL to "بلد الوجهة",
        WebStringKey.SELECT_DESTINATION_COUNTRY to "اختر بلد الوجهة",
        WebStringKey.SEARCH_COUNTRIES_PLACEHOLDER to "ابحث عن الدول...",
        WebStringKey.CHECK_VISA_REQUIREMENTS to "تحقق من متطلبات التأشيرة",
        WebStringKey.CHECKING to "جارٍ التحقق...",
        WebStringKey.VISA_REQUIREMENT_TITLE to "متطلبات التأشيرة",
        WebStringKey.VISA_FREE_STATUS to "بدون تأشيرة",
        WebStringKey.VISA_ON_ARRIVAL_STATUS to "تأشيرة عند الوصول",
        WebStringKey.EVISA_STATUS to "تأشيرة إلكترونية متاحة",
        WebStringKey.VISA_REQUIRED_STATUS to "التأشيرة مطلوبة",
        WebStringKey.UNKNOWN_STATUS to "غير معروف",
        WebStringKey.PASSPORT_FROM to "جواز السفر من",
        WebStringKey.TRAVELING_TO to "السفر إلى",
        WebStringKey.MAXIMUM_STAY to "أقصى مدة إقامة",
        WebStringKey.IMPORTANT_INFORMATION to "معلومات مهمة",
        WebStringKey.DESTINATION_INFORMATION to "معلومات الوجهة",
        WebStringKey.CURRENCY_LABEL to "العملة: {0}",
        WebStringKey.PHONE_LABEL to "الهاتف: +{0}",
        WebStringKey.TIMEZONE_LABEL to "المنطقة الزمنية: {0}",
        WebStringKey.VISIT_EMBASSY_WEBSITE to "زيارة موقع السفارة →",
        WebStringKey.VISA_REQUIREMENTS_WARNING to "⚠️ يمكن أن تتغير متطلبات التأشيرة. يرجى التحقق دائمًا من السفارة الرسمية قبل السفر.",
        WebStringKey.LANGUAGE to "اللغة",
        WebStringKey.LANGUAGE_SETTINGS to "إعدادات اللغة",
        WebStringKey.SELECT_LANGUAGE to "اختر لغتك",
        WebStringKey.CURRENT_LANGUAGE to "اللغة الحالية",
        WebStringKey.APPLY_LANGUAGE to "تطبيق اللغة",
        WebStringKey.LANGUAGE_HELP to "اختر اللغة التي تريد استخدامها على الموقع.",
        WebStringKey.OPEN_LANGUAGE to "تغيير اللغة",
        WebStringKey.CLOSE to "إغلاق",
        WebStringKey.SAVE to "حفظ",
        WebStringKey.DONE to "تم",
        WebStringKey.CANCEL to "إلغاء",
        WebStringKey.APPLY to "تطبيق",
        WebStringKey.LOADING to "جارٍ التحميل...",
        WebStringKey.RETRY to "إعادة المحاولة",
        WebStringKey.APP_NAME to "Fyat Travel & Tour Ltd",
        WebStringKey.SIGN_IN_SUBTITLE to "سجل الدخول للمتابعة",
        WebStringKey.AUTH_SUCCESS to "تم التحقق بنجاح!",
        WebStringKey.ERROR_NO_INTERNET to "اتصال الإنترنت غير متوفر.",
        WebStringKey.ERROR_SIGN_IN_CANCELED to "تم إلغاء تسجيل الدخول.",
        WebStringKey.ERROR_UNKNOWN to "حدث خطأ غير معروف",
        WebStringKey.SIGN_IN_WITH_GOOGLE to "تسجيل الدخول بواسطة Google",
        WebStringKey.PLEASE_WAIT to "يرجى الانتظار...",
        WebStringKey.CONTACT_US to "اتصل بنا",
        WebStringKey.BACK to "رجوع",
        WebStringKey.GET_IN_TOUCH to "تواصل معنا",
        WebStringKey.CONNECT_SOCIAL_MEDIA to "تابعنا على وسائل التواصل الاجتماعي",
        WebStringKey.CHAT_WITH_US to "تحدث معنا",
        WebStringKey.FOLLOW_US to "تابعنا",
        WebStringKey.NEED_IMMEDIATE_ASSISTANCE to "هل تحتاج إلى مساعدة فورية؟",
        WebStringKey.WHATSAPP_FASTEST_RESPONSE to "راسلنا عبر واتساب للحصول على رد سريع",
        WebStringKey.WHATSAPP to "واتساب",
        WebStringKey.INSTAGRAM to "إنستغرام",
        WebStringKey.FACEBOOK to "فيسبوك",
        WebStringKey.TWITTER_X to "تويتر (X)",
        WebStringKey.TIKTOK to "تيك توك",
        WebStringKey.OPEN_LINK to "فتح",
        WebStringKey.UPDATE to "تحديث",
        WebStringKey.SUCCESSFULLY_UPDATED to "تم التحديث بنجاح!",
        WebStringKey.OOPS to "عذراً!",
        WebStringKey.LANGUAGE to "اللغة",
        WebStringKey.SELECT_LANGUAGE_TITLE to "اختر اللغة",
        WebStringKey.CHOOSE_PREFERRED_LANGUAGE to "اختر لغتك المفضلة للتطبيق",
        WebStringKey.SELECTED to "تم الاختيار",
        WebStringKey.COMING_SOON to "قريباً",
        WebStringKey.MORE_LANGUAGES_COMING to "المزيد من اللغات قادمة قريباً! نحن نعمل بجد لتوفير Fyat Travel بلغتك.",
        WebStringKey.INFO to "معلومات",
        WebStringKey.ENGLISH to "الإنجليزية",
        WebStringKey.KISWAHILI to "السواحيلية",
        WebStringKey.TIGRINYA to "التغرينية",
        WebStringKey.AMHARIC to "الأمهرية",
        WebStringKey.ARABIC to "العربية",
        WebStringKey.SOMALI to "الصومالية",
        WebStringKey.FYAT_TRAVEL_TOUR to "فيات للسياحة والسفر",
        WebStringKey.TRAVEL_OPERATOR to "مشغل رحلات",
        WebStringKey.PROFILE to "الملف الشخصي",
        WebStringKey.SIGN_OUT to "تسجيل الخروج",
        WebStringKey.ADMIN to "المسؤول",
        WebStringKey.BLOG to "المدونة",
        WebStringKey.LOCATIONS to "المواقع",
        WebStringKey.CHECKOUT to "الدفع",
        WebStringKey.MENU to "القائمة",
        WebStringKey.CLOSE to "إغلاق",
        WebStringKey.SHOP to "المتجر",
        WebStringKey.EXPLORE_LABEL to "استكشف",
        WebStringKey.CART_LABEL to "السلة",
        WebStringKey.CATEGORIES_LABEL to "الفئات",
        WebStringKey.CATEGORIES_SEARCH_PLACEHOLDER to "ابحث في الفئات...",
        WebStringKey.CATEGORIES_FILTER_ALL to "الكل",
        WebStringKey.CATEGORIES_FILTER_FLIGHTS to "رحلات",
        WebStringKey.CATEGORIES_FILTER_HOTELS to "فنادق",
        WebStringKey.CATEGORIES_FILTER_GUEST_HOUSES to "بيوت الضيافة",
        WebStringKey.CATEGORIES_FILTER_CAR_RENTALS to "تأجير السيارات",
        WebStringKey.CATEGORIES_FILTER_VISA_SERVICES to "خدمات التأشيرة",
        WebStringKey.CATEGORIES_FILTER_TOURS to "جولات",
        WebStringKey.CATEGORIES_FILTER_TRANSFERS to "خدمات نقل",
        WebStringKey.CATEGORIES_EMPTY to "لا توجد فئات في Firestore.",
        WebStringKey.CATEGORIES_NO_MATCH to "لا توجد فئات تطابق بحثك",
        WebStringKey.CATEGORIES_CLEAR_FILTERS to "مسح الفلاتر",
        WebStringKey.CATEGORIES_SHOWING_COUNT to "عرض {0} من {1} فئات",
        WebStringKey.CATEGORY_TYPE_OTHER to "أخرى",
        WebStringKey.FLIGHT_OFFERS to "عروض الطيران",
        WebStringKey.HOTEL to "فنادق",
        WebStringKey.GUEST_HOUSE to "بيوت ضيافة",
        WebStringKey.CAR_RENTAL to "تأجير سيارات",
        WebStringKey.TOUR to "جولة",
        WebStringKey.TOUR_PACKAGES to "باقات سياحية",
        WebStringKey.EXPLORE_FLIGHTS to "رحلات طيران",
        WebStringKey.EXPLORE_STAYS to "أماكن إقامة",
        WebStringKey.EXPLORE_TRANSFER to "خدمات نقل",
        WebStringKey.EXPLORE_VISA to "تأشيرة سفر",
        WebStringKey.ERROR_WITH_MESSAGE to "خطأ: {0}",
        WebStringKey.FLIGHT_TAB_RETURN to "ذهاب وعودة",
        WebStringKey.FLIGHT_TAB_ONE_WAY to "اتجاه واحد",
        WebStringKey.FLIGHT_TAB_MULTI_CITY to "مدن متعددة",
        WebStringKey.FLIGHT_FROM to "من",
        WebStringKey.FLIGHT_TO to "إلى",
        WebStringKey.FLIGHT_SELECT_AIRPORT to "اختر المطار",
        WebStringKey.FLIGHT_DEPARTURE to "المغادرة",
        WebStringKey.FLIGHT_RETURN to "العودة",
        WebStringKey.FLIGHT_ORIGIN_PLACEHOLDER to "المنشأ (مثال: EBB)",
        WebStringKey.FLIGHT_DESTINATION_PLACEHOLDER to "الوجهة (مثال: NBO)",
        WebStringKey.FLIGHT_SELECT_DATE to "اختر التاريخ",
        WebStringKey.FLIGHT_TRAVELERS to "المسافرون",
        WebStringKey.FLIGHT_TRAVELLER_SINGULAR to "مسافر",
        WebStringKey.FLIGHT_TRAVELLER_PLURAL to "مسافرين",
        WebStringKey.FLIGHT_CABIN to "درجة السفر",
        WebStringKey.FLIGHT_SEARCH to "بحث",
        WebStringKey.FLIGHT_SPECIAL_OFFERS to "عروض طيران خاصة ✈️",
        WebStringKey.FLIGHT_NO_OFFERS to "لا توجد عروض طيران متاحة حالياً.",
        WebStringKey.FLIGHT_CLOSE to "إغلاق",
        WebStringKey.FLIGHT_DONE to "تم",
        WebStringKey.FLIGHT_ADULTS to "بالغون",
        WebStringKey.FLIGHT_ADULTS_WITH_COUNT to "بالغون: {0}",
        WebStringKey.FLIGHT_INCREASE to "زيادة",
        WebStringKey.FLIGHT_DECREASE to "نقصان",
        WebStringKey.FLIGHT_PRICE to "السعر",
        WebStringKey.FLIGHT_DISCOUNTED to "مخفض",
        WebStringKey.FLIGHT_NEW to "جديد",
        WebStringKey.FLIGHT_DETAILS to "تفاصيل الرحلة",
        WebStringKey.FLIGHT_AVAILABLE_OPTIONS to "الخيارات المتاحة",
        WebStringKey.FLIGHT_BOOK_NOW_FROM to "احجز الآن",
        WebStringKey.FLIGHT_ARROW to "→",
        WebStringKey.FLIGHT_CABIN_ECONOMY to "الدرجة السياحية",
        WebStringKey.FLIGHT_CABIN_PREMIUM_ECONOMY to "السياحية الممتازة",
        WebStringKey.FLIGHT_CABIN_BUSINESS to "درجة رجال الأعمال",
        WebStringKey.FLIGHT_CABIN_FIRST to "الدرجة الأولى",
        WebStringKey.VISA_TITLE to "متطلبات التأشيرة",
        WebStringKey.VISA_SUBTITLE to "تحقق من متطلبات التأشيرة لرحلتك القادمة",
        WebStringKey.VISA_PASSPORT_COUNTRY to "بلد جواز السفر",
        WebStringKey.VISA_DESTINATION_COUNTRY to "بلد الوجهة",
        WebStringKey.VISA_PASSPORT_HINT to "ابحث عن دولة أو أدخل الرمز (مثلاً: UG أو أوغندا)",
        WebStringKey.VISA_DESTINATION_HINT to "ابحث عن دولة أو أدخل الرمز (مثلاً: US أو أمريكا)",
        WebStringKey.VISA_CHECKING to "جاري الفحص...",
        WebStringKey.VISA_CHECK_BUTTON to "عرض متطلبات التأشيرة",
        WebStringKey.VISA_ERROR to "خطأ",
        WebStringKey.VISA_ALWAYS_VERIFY to "ℹ️ يرجى التأكد دائماً من المصادر الرسمية قبل السفر",
        WebStringKey.VISA_EXPAND_DETAILS to "عرض التفاصيل",
        WebStringKey.VISA_COLLAPSE_DETAILS to "إخفاء التفاصيل",
        WebStringKey.VISA_STAY_DURATION to "مدة الإقامة: {0}",
        WebStringKey.VISA_NO_DETAILS to "لا توجد تفاصيل إضافية.",
        WebStringKey.VISA_SEARCH_TIP to "💡 ابحث باسم الدولة أو رمزها المكون من حرفين (مثلاً: UG أو أوغندا)",
        WebStringKey.VISA_CURRENCY to "العملة",
        WebStringKey.VISA_CAPITAL to "العاصمة",
        WebStringKey.VISA_PASSPORT_VALIDITY to "صلاحية جواز السفر",
        WebStringKey.VISA_STATUS_VISA_FREE to "بدون تأشيرة",
        WebStringKey.VISA_STATUS_VISA_ON_ARRIVAL to "تأشيرة عند الوصول",
        WebStringKey.VISA_STATUS_EVISA to "تأشيرة إلكترونية",
        WebStringKey.VISA_STATUS_VISA_REQUIRED to "تأشيرة مطلوبة",
        WebStringKey.VISA_STATUS_UNKNOWN to "غير معروف",
        WebStringKey.VISA_UNIT_MONTH to "شهر",
        WebStringKey.VISA_UNIT_MONTHS to "أشهر",
        WebStringKey.VISA_UNIT_DAY to "يوم",
        WebStringKey.VISA_UNIT_DAYS to "أيام",
        WebStringKey.VISA_UNIT_YEAR to "سنة",
        WebStringKey.VISA_UNIT_YEARS to "سنوات",
        WebStringKey.CAR_FIND_A_CAR to "ابحث عن سيارة",
        WebStringKey.CAR_PICKUP_LOCATION to "مكان الاستلام",
        WebStringKey.CAR_DROPOFF_LOCATION_OPTIONAL to "مكان التسليم (اختياري)",
        WebStringKey.CAR_PICKUP_DATETIME to "تاريخ ووقت الاستلام",
        WebStringKey.CAR_DROPOFF_DATETIME to "تاريخ ووقت التسليم",
        WebStringKey.CAR_DRIVER_AGE to "عمر السائق",
        WebStringKey.CAR_SEARCH_CARS to "بحث عن سيارات",
        WebStringKey.HOTEL_WHERE_TO to "إلى أين؟",
        WebStringKey.HOTEL_SEARCH_DESTINATION to "ابحث عن وجهة",
        WebStringKey.HOTEL_CHECK_IN to "موعد الوصول",
        WebStringKey.HOTEL_CHECK_OUT to "موعد المغادرة",
        WebStringKey.HOTEL_GUESTS_ROOMS to "الضيوف والغرف",
        WebStringKey.HOTEL_ADULT_SINGULAR to "شخص بالغ",
        WebStringKey.HOTEL_ADULT_PLURAL to "بالغين",
        WebStringKey.HOTEL_CHILD_SINGULAR to "طفل",
        WebStringKey.HOTEL_CHILD_PLURAL to "أطفال",
        WebStringKey.HOTEL_ROOM_SINGULAR to "غرفة",
        WebStringKey.HOTEL_ROOM_PLURAL to "غرف",
        WebStringKey.HOTEL_SEARCH_HOTELS to "بحث عن فنادق",
        WebStringKey.HOTEL_ADULTS to "بالغون",
        WebStringKey.HOTEL_CHILDREN to "أطفال",
        WebStringKey.HOTEL_ROOMS to "غرف",
        WebStringKey.HOTEL_DONE to "تم",
        WebStringKey.HOTEL_CLOSE to "إغلاق",
        WebStringKey.HOTEL_WHERE_ARE_YOU_GOING to "إلى أين تود الذهاب؟",
        WebStringKey.HOTEL_SEARCH_DESTINATIONS to "البحث عن وجهات",
        WebStringKey.HOTEL_START_TYPING to "ابدأ الكتابة للبحث",
        WebStringKey.HOTEL_ENTER_CITY_HOTEL_DESTINATION to "اسم المدينة أو الفندق أو الوجهة",
        WebStringKey.HOTEL_SEARCHING_DESTINATIONS to "جاري البحث عن وجهات...",
        WebStringKey.HOTEL_NO_DESTINATIONS_FOUND to "لم يتم العثور على نتائج",
        WebStringKey.HOTEL_TRY_DIFFERENT_SEARCH_TERM to "حاول استخدام كلمات بحث أخرى",
        WebStringKey.HOTEL_CLEAR to "مسح",
        WebStringKey.HOTEL_HOTELS to "فنادق",
        WebStringKey.HOTEL_UNKNOWN to "غير معروف",
        WebStringKey.CONTACT_SUBTITLE to "نحن هنا لمساعدتك في جميع احتياجات السفر.",
        WebStringKey.CONTACT_INFORMATION to "معلومات الاتصال",
        WebStringKey.SOCIAL_LABEL to "اجتماعي",
        WebStringKey.SEND_A_COMMENT to "أرسل تعليقًا",
        WebStringKey.YOUR_NAME to "اسمك",
        WebStringKey.FULL_NAME_PLACEHOLDER to "الاسم الكامل",
        WebStringKey.EMAIL_OPTIONAL to "البريد الإلكتروني (اختياري)",
        WebStringKey.EMAIL_PLACEHOLDER to "you@example.com",
        WebStringKey.MESSAGE_COMMENTS to "الرسالة / التعليقات",
        WebStringKey.MESSAGE_PLACEHOLDER to "اكتب رسالتك هنا...",
        WebStringKey.ERROR_NAME_MESSAGE_REQUIRED to "يرجى إدخال الاسم والرسالة.",
        WebStringKey.WHATSAPP_SENT_HINT to "تم فتح واتساب برسالتك. اضغط إرسال للإرسال.",
        WebStringKey.SEND_VIA_WHATSAPP to "أرسل عبر واتساب",
        WebStringKey.CONTACT_MESSAGE_TEMPLATE to "مرحبًا FYAT Travel & Tour LTD،\n\nأود مشاركة التعليق التالي:\n\nالاسم: {0}\nالبريد الإلكتروني: {1}\nالرسالة: {2}\n\nشكرًا.",
        WebStringKey.CAR_PICKUP_CITY to "مدينة الاستلام",
        WebStringKey.CAR_DROPOFF_CITY_OPTIONAL to "مدينة التسليم (اختياري)",
        WebStringKey.CAR_PICKUP_DATE to "تاريخ الاستلام",
        WebStringKey.CAR_DROPOFF_DATE to "تاريخ التسليم",
        WebStringKey.CAR_PICKUP_TIME to "وقت الاستلام (HH:mm)",
        WebStringKey.CAR_DROPOFF_TIME to "وقت التسليم (HH:mm)",
        WebStringKey.ERROR_SEARCH_CARS_FAILED to "فشل البحث عن تأجير السيارات",
        WebStringKey.ERROR_INVALID_RESPONSE to "استجابة غير صحيحة من الخادم",
        WebStringKey.ERROR_NETWORK to "خطأ في الشبكة (هل تم نشر وظيفة السحابة؟)",
        WebStringKey.OPEN_ON_BOOKING to "افتح على Booking.com",
        WebStringKey.CAR_RESULTS_COUNT to "السيارات ({0})",
        WebStringKey.CAR_LABEL to "سيارة",
        WebStringKey.ERROR_SEARCH_HOTELS_FAILED to "فشل البحث عن الفنادق",
        WebStringKey.HOTEL_RESULTS_COUNT to "الفنادق ({0})",
        WebStringKey.RATING_WITH_REVIEWS to "التقييم: {0} ({1} مراجعات)",
        WebStringKey.NO_HOTELS_FOUND to "لم يتم العثور على فنادق لهذا البحث. جرّب مدينة أو تواريخ أخرى.",
        WebStringKey.QUICK_SELECT to "اختيار سريع",
        WebStringKey.BOOK_YOUR_JOURNEY to "احجز رحلتك",
        WebStringKey.CLOSE_FORM to "أغلق النموذج",
        WebStringKey.CLICK_TO_FILL_DETAILS to "انقر لملء تفاصيل سفرك",
        WebStringKey.ENQUIRY_SENT to "✓ تم إرسال الاستعلام! سنتواصل معك قريبًا.",
        WebStringKey.SEND_ANOTHER to "أرسل طلبًا آخر",
        WebStringKey.ENTER_YOUR_NAME to "أدخل اسمك",
        WebStringKey.EMAIL_LABEL to "البريد الإلكتروني",
        WebStringKey.SERVICE_LABEL to "الخدمة",
        WebStringKey.DEPARTURE_CITY_PLACEHOLDER to "مدينة المغادرة",
        WebStringKey.DESTINATION_PLACEHOLDER to "الوجهة",
        WebStringKey.GUESTS_LABEL to "الضيوف",
        WebStringKey.GUESTS_PLACEHOLDER to "بالغ واحد",
        WebStringKey.NOTES_LABEL to "ملاحظات",
        WebStringKey.NOTES_PLACEHOLDER to "أي طلبات خاصة...",
        WebStringKey.SENDING to "جارٍ الإرسال...",
        WebStringKey.SEND_EMAIL to "إرسال بريد إلكتروني",
        WebStringKey.CONNECTIVITY_NO_INTERNET to "لا يوجد اتصال بالإنترنت",
        WebStringKey.CONNECTIVITY_RETRY to "إعادة المحاولة",
        WebStringKey.CONNECTIVITY_CONNECTED to "متصل",
        WebStringKey.BOOKING_ENQUIRY_TITLE to "FYAT Travel & Tour - طلب حجز جديد",
        WebStringKey.VALIDATION_ENTER_FULL_NAME to "يرجى إدخال الاسم الكامل",
        WebStringKey.VALIDATION_ENTER_EMAIL_OR_PHONE to "يرجى إدخال البريد الإلكتروني أو رقم الهاتف",
        WebStringKey.VALIDATION_ENTER_DEPARTURE to "يرجى إدخال مكان المغادرة",
        WebStringKey.VALIDATION_ENTER_DESTINATION to "يرجى إدخال الوجهة",
        WebStringKey.ADDITIONAL_DETAILS_LABEL to "تفاصيل إضافية",
        WebStringKey.GUESTS_AND_CABIN_LABEL to "الضيوف والدرجة",
        WebStringKey.FILTER_BY_AIRLINE to "تصفية حسب شركة الطيران",
        WebStringKey.CLEAR_FILTER to "مسح التصفية",
        WebStringKey.NO_AIRLINE_FLIGHTS_FOUND to "لا توجد رحلات {0} في هذه النتائج.",
        WebStringKey.NO_FLIGHTS_FOUND_MESSAGE to "لم يتم العثور على رحلات. جرّب تواريخ أو مطارات مختلفة.",
        WebStringKey.FLIGHT_OFFER_LABEL to "عرض رحلة",
        WebStringKey.FLIGHT_NUMBER_LABEL to "رحلة {0}",
        WebStringKey.COMPLETE_BOOKING to "أكمل حجزك",
        WebStringKey.BOOKING_REQUEST_SENT to "تم إرسال طلب الحجز!",
        WebStringKey.BOOKING_REQUEST_SUBTITLE to "سيتواصل معك فريقنا قريبًا لتأكيد التوفر وخيارات الدفع.",
        WebStringKey.YOUR_DETAILS_SECTION to "بياناتك",
        WebStringKey.TRAVEL_DETAILS_SECTION to "تفاصيل السفر",
        WebStringKey.GUESTS_EXAMPLE_PLACEHOLDER to "مثال: 2 بالغين، 1 طفل",
        WebStringKey.SPECIAL_REQUIREMENTS_PLACEHOLDER to "أي متطلبات خاصة، احتياجات غذائية، طلبات وصول...",
        WebStringKey.PRIVACY_NOTE to "سيتم استخدام معلوماتك فقط لمعالجة طلب الحجز. سنتواصل معك خلال 24 ساعة.",
        WebStringKey.SEND_VIA_EMAIL to "أرسل عبر البريد الإلكتروني",
        WebStringKey.OFFER_WEEKEND_ESCAPE to "عطلة نهاية الأسبوع",
        WebStringKey.OFFER_WEEKEND_DESC to "وفر كثيرًا هذا الأسبوع",
        WebStringKey.OFFER_HOLIDAY_DEALS to "عروض العطلات",
        WebStringKey.OFFER_HOLIDAY_DESC to "عرض لفترة محدودة",
        WebStringKey.HOME_SUBTITLE to "استكشف الجولات والرحلات وعروض السفر",
        WebStringKey.HOME_HELP_TEXT to "تصفح الفئات وافتح منتجًا وشاهد التفاصيل الكاملة — مدعومًا من Firebase.",
        WebStringKey.FEATURED_FLIGHT_OFFERS to "عروض طيران مميزة",
        WebStringKey.VIEW_ALL to "عرض الكل →",
        WebStringKey.BROWSE_CATEGORIES to "تصفح الفئات",
        WebStringKey.ITEMS_COUNT to "{0} عناصر",
        WebStringKey.BOOK_ACTION to "احجز",
        WebStringKey.WHATSAPP_DEFAULT_MESSAGE to "مرحبًا! أنا مهتم بخدمات السفر لديكم. هل يمكنكم مساعدتي؟",
        WebStringKey.WHATSAPP_CHAT_LABEL to "الدردشة على واتساب",
        WebStringKey.WHATSAPP_ASK_LABEL to "اسأل عبر واتساب",
        WebStringKey.WHATSAPP_NEED_HELP_TITLE to "تحتاج مساعدة؟",
        WebStringKey.WHATSAPP_HELP_SUBTITLE to "تحدث مع خبراء السفر لدينا",
        WebStringKey.WHATSAPP_CHAT_NOW to "ابدأ الدردشة",
        WebStringKey.WHATSAPP_MESSAGE_FLIGHT to "مرحبًا! أحتاج مساعدة في حجز رحلة. هل يمكنك المساعدة؟",
        WebStringKey.WHATSAPP_MESSAGE_HOTEL to "مرحبًا! أبحث عن توصيات الفنادق. هل يمكنك المساعدة؟",
        WebStringKey.WHATSAPP_MESSAGE_VISA to "مرحبًا! لدي أسئلة حول متطلبات التأشيرة. هل يمكنك المساعدة؟",
        WebStringKey.WHATSAPP_MESSAGE_TOUR to "مرحبًا! أنا مهتم بحجز باقة سياحية. هل يمكنك المساعدة؟",
        WebStringKey.WHATSAPP_MESSAGE_CAR to "مرحبًا! أحتاج إلى استئجار سيارة. هل يمكنك تقديم خيارات؟",
        WebStringKey.WHATSAPP_MESSAGE_GENERAL to "مرحبًا! أحتاج مساعدة في حجز السفر. هل يمكنك مساعدتي؟",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_TITLE to "مؤشر قاعدة البيانات مطلوب",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_BODY to "يحتاج التطبيق إلى مؤشر Firestore لعرض المنتجات حسب الفئة. هذا إعداد لمرة واحدة.",
        WebStringKey.FIRESTORE_CREATE_INDEX to "إنشاء المؤشر →",
        WebStringKey.FIRESTORE_DISMISS to "إغلاق",
        WebStringKey.FIRESTORE_INDEX_NOTE to "المؤشر: product → category (تصاعدي) + createdAt (تنازلي)",
        WebStringKey.FIRESTORE_INDEX_MISSING to "مؤشر قاعدة البيانات مفقود. انقر على 'إنشاء المؤشر' لإصلاح ذلك.",
        WebStringKey.FIRESTORE_ACCESS_DENIED to "تم رفض الوصول. يرجى التحقق من الأذونات.",
        WebStringKey.FIRESTORE_NOT_FOUND to "لم يتم العثور على البيانات المطلوبة.",
        WebStringKey.FIRESTORE_NETWORK_UNAVAILABLE to "الشبكة غير متاحة. يرجى التحقق من الاتصال.",
        WebStringKey.FOOTER_BRAND to "FYAT TRAVEL & TOUR LTD.",
        WebStringKey.FOOTER_TAGLINE to "شريكك الموثوق للرحلات والفنادق والتأشيرات والمغامرات حول العالم.",
        WebStringKey.COPYRIGHT_TEXT to "© 2025 Fyat travel & tour Ltd.",
        WebStringKey.QUICK_LINKS to "روابط سريعة",
        WebStringKey.SERVICES_LABEL to "الخدمات",
        WebStringKey.ABOUT_US to "من نحن",
        WebStringKey.CONTACT_LABEL to "اتصل بنا",
        WebStringKey.BOOK_NOW_LABEL to "احجز الآن",
        WebStringKey.TOP_SERVICES to "أفضل الخدمات",
        WebStringKey.FLIGHT_BOOKING to "حجز الرحلات",
        WebStringKey.HOTEL_RESERVATIONS to "حجوزات الفنادق",
        WebStringKey.VISA_PROCESSING to "معالجة التأشيرات",
        WebStringKey.CAR_HIRE to "تأجير السيارات",
        WebStringKey.GET_APP to "احصل على التطبيق",
        WebStringKey.GET_IT_ON to "احصل عليه على",
        WebStringKey.DOWNLOAD_ON to "حمّل من",
        WebStringKey.GOOGLE_PLAY to "Google Play",
        WebStringKey.APP_STORE to "App Store",
        WebStringKey.PAYMENT_SUCCESS_TITLE to "تم الدفع بنجاح!",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_WITH_NAME to "شكرًا لك {0}! تمت معالجة دفعتك بنجاح.",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_GENERIC to "شكرًا لك! تمت معالجة دفعتك بنجاح.",
        WebStringKey.ORDER_DETAILS to "تفاصيل الطلب",
        WebStringKey.ORDER_ID_LABEL to "رقم الطلب:",
        WebStringKey.STATUS_LABEL to "الحالة:",
        WebStringKey.PAYMENT_STATUS_PAID to "مدفوع",
        WebStringKey.PAYMENT_METHOD_LABEL to "طريقة الدفع:",
        WebStringKey.PAYMENT_METHOD_PESAPAL to "PesaPal",
        WebStringKey.CONFIRMATION_EMAIL_NOTE to "سيتم إرسال بريد تأكيدي قريبًا. إذا كانت لديك أسئلة، يرجى التواصل مع فريق الدعم.",
        WebStringKey.BROWSE_MORE_PRODUCTS to "تصفح المزيد من المنتجات",
        WebStringKey.GO_TO_HOME to "العودة إلى الرئيسية",
        WebStringKey.NEED_HELP_CONTACT to "هل تحتاج مساعدة؟ تواصل معنا عبر info@fyattraveltour.com أو +256 758 250 625",
        WebStringKey.PAYMENT_FAILED_TITLE to "فشل الدفع",
        WebStringKey.PAYMENT_FAILED_MESSAGE to "للأسف لم يكتمل الدفع. قد يكون ذلك بسبب الإلغاء أو مشكلة تقنية.",
        WebStringKey.PAYMENT_FAILED_SUGGESTIONS_TITLE to "ماذا يمكنك أن تفعل؟",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_1 to "حاول الدفع مرة أخرى ببطاقة مختلفة أو عبر موبايل موني",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_2 to "استخدم واتساب لترتيب دفع نقدي",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_3 to "تواصل مع فريقنا وسنساعدك يدويًا",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_4 to "تحقق من اتصال الإنترنت وحاول مرة أخرى",
        WebStringKey.TRY_AGAIN to "حاول مرة أخرى",
        WebStringKey.CONTACT_VIA_WHATSAPP to "تواصل عبر واتساب",
        WebStringKey.PAYMENT_FAILED_WHATSAPP_MESSAGE to "مرحبًا، حاولت إجراء الدفع لكنه فشل. أود ترتيب حجزي للمنتج رقم: {0}"
        ,WebStringKey.SEND_INQUIRY to "إرسال الاستفسار"
        ,WebStringKey.VALIDATION_ENTER_VALID_EMAIL to "يرجى إدخال عنوان بريد إلكتروني صحيح"
    )

    private val so = mapOf(
        WebStringKey.APP_NAME to "FYAT Travel & Tour LTD",
        WebStringKey.BRAND_SHORT to "FyatTravel",
        WebStringKey.BRAND_SUFFIX to "Tour LTD",
        WebStringKey.SEARCH to "Raadi",
        WebStringKey.GO to "Tag",
        WebStringKey.UPDATED_AT to "La cusbooneysiiyey: {0}",
        WebStringKey.REFRESH to "Cusboonaysii",
        WebStringKey.CATEGORIES to "Qaybaha",
        WebStringKey.CART to "Gaariga wax iibsiga",
        WebStringKey.FLIGHTS to "Duullimaadyo",
        WebStringKey.STAYS to "Hoy",
        WebStringKey.CARS to "Baabuur",
        WebStringKey.CARS_PAGE_SUBTITLE to "Noo sheeg faahfaahinta kirada gaariga, kooxdayadu waxay kula soo xiriiri doontaa WhatsApp ama email.",
        WebStringKey.VISA to "Fiiso",
        WebStringKey.EXPLORE to "Saham",
        WebStringKey.CONTACT to "Xiriir",
        WebStringKey.STAYS_PAGE_SUBTITLE to "Noo sheeg faahfaahinta joogitaankaaga, kooxdayadu waxay kula soo xiriiri doontaa WhatsApp ama email.",
        WebStringKey.MY_PROFILE to "Boggaaga",
        WebStringKey.SIGN_OUT to "Ka bax",
        WebStringKey.ACCOUNT_ACTIONS to "Ficillada Akoonka",
        WebStringKey.EMAIL_NOT_VERIFIED to "⚠ Imeelka (email) lama xaqiijin",
        WebStringKey.USER_LABEL to "Isticmaale",
        WebStringKey.USER_ID to "Aqoonsiga Isticmaalaha",
        WebStringKey.PHONE_NUMBER to "Telefoon",
        WebStringKey.NOT_PROVIDED to "Lama bixin",
        WebStringKey.EMAIL_VERIFIED to "Email waa la xaqiijiyey",
        WebStringKey.YES_TEXT to "Haa",
        WebStringKey.NO_TEXT to "Maya",
        WebStringKey.ACCOUNT_TYPE to "Nooca Akoonka",
        WebStringKey.ACCOUNT_TYPE_EMAIL to "Email",
        WebStringKey.ACCOUNT_TYPE_PHONE to "Telefoon",
        WebStringKey.SIGN_OUT_TITLE to "Ka bax",
        WebStringKey.SIGN_OUT_CONFIRMATION to "Ma hubtaa inaad ka baxdo? Waa inaad mar kale soo gashaa si aad u gasho akoonkaaga.",
        WebStringKey.SIGN_IN to "Soo gal",
        WebStringKey.PROFILE to "Boggaaga",
        WebStringKey.ADMIN to "Maamul",
        WebStringKey.NOT_FOUND to "Lama helin",
        WebStringKey.UNKNOWN_ROUTE to "Wadadan lama yaqaan: {0}",
        WebStringKey.EXPLORE_COMING_SOON to "Bogga sahanka ee webka wuu imaanayaa dhawaan.",
        WebStringKey.CART_COMING_SOON to "Bogga gaariga wax iibsiga ee webka wuu imaanayaa dhawaan.",
        WebStringKey.ADMIN_COMING_SOON to "Dashboard-ka maamulka ee webka waa la diyaarin doonaa dhawaan.",
        WebStringKey.SEARCH_PAGE to "Raadi",
        WebStringKey.SEARCH_WITH_QUERY to "Raadi: {0}",
        WebStringKey.TRAVELERS_ECONOMY_CURRENCY to "1 socdaale • Economy • USD / UGX",
        WebStringKey.SEARCHING to "Raadinaya...",
        WebStringKey.VISA_PAGE_SUBTITLE to "Hubi shuruudaha fiisada meel kasta. Geli dalka baasaboorkaaga iyo halka aad u safreyso.",
        WebStringKey.PASSPORT_COUNTRY_LABEL to "Dalka Baasaboorka",
        WebStringKey.SELECT_PASSPORT_COUNTRY to "Dooro dalka baasaboorka",
        WebStringKey.DESTINATION_COUNTRY_LABEL to "Dalka loo socdo",
        WebStringKey.SELECT_DESTINATION_COUNTRY to "Dooro dalka loo socdo",
        WebStringKey.SEARCH_COUNTRIES_PLACEHOLDER to "Raadi waddamada...",
        WebStringKey.CHECK_VISA_REQUIREMENTS to "Hubi shuruudaha fiisada",
        WebStringKey.CHECKING to "La hubinayaa...",
        WebStringKey.VISA_REQUIREMENT_TITLE to "Shuruudaha fiisada",
        WebStringKey.VISA_FREE_STATUS to "Fiiso la'aan",
        WebStringKey.VISA_ON_ARRIVAL_STATUS to "Fiiso marka la soo galo",
        WebStringKey.EVISA_STATUS to "Fiiso elektaroonig ah ayaa la heli karaa",
        WebStringKey.VISA_REQUIRED_STATUS to "Fiiso waa loo baahan yahay",
        WebStringKey.UNKNOWN_STATUS to "Aan la aqoon",
        WebStringKey.PASSPORT_FROM to "Baasaboorka ka yimid",
        WebStringKey.TRAVELING_TO to "U socda",
        WebStringKey.MAXIMUM_STAY to "Joogitaanka ugu badan",
        WebStringKey.IMPORTANT_INFORMATION to "Macluumaad muhiim ah",
        WebStringKey.DESTINATION_INFORMATION to "Macluumaadka meesha loo socdo",
        WebStringKey.CURRENCY_LABEL to "Lacagta: {0}",
        WebStringKey.PHONE_LABEL to "Telefoon: +{0}",
        WebStringKey.TIMEZONE_LABEL to "Aagga waqtiga: {0}",
        WebStringKey.VISIT_EMBASSY_WEBSITE to "Booqo website-ka safaaradda →",
        WebStringKey.VISA_REQUIREMENTS_WARNING to "⚠️ Shuruudaha fiisadu way is beddeli karaan. Mar walba ka xaqiiji safaaradda rasmiga ah ka hor safarka.",
        WebStringKey.LANGUAGE to "Luuqad",
        WebStringKey.LANGUAGE_SETTINGS to "Dejinta Luuqadda",
        WebStringKey.SELECT_LANGUAGE to "Dooro luuqaddaada",
        WebStringKey.CURRENT_LANGUAGE to "Luuqadda hadda jirta",
        WebStringKey.APPLY_LANGUAGE to "Dhaqan geli luuqadda",
        WebStringKey.LANGUAGE_HELP to "Dooro luuqadda aad rabto inaad ku isticmaasho webka.",
        WebStringKey.OPEN_LANGUAGE to "Beddel luuqadda",
        WebStringKey.CLOSE to "Xir",
        WebStringKey.SAVE to "Kaydi",
        WebStringKey.DONE to "Dhammee",
        WebStringKey.CANCEL to "Ka noqo",
        WebStringKey.APPLY to "Dhaqan geli",
        WebStringKey.LOADING to "Waa la rarayaa...",
        WebStringKey.RETRY to "Isku day mar kale",
        WebStringKey.APP_NAME to "FYAT TRAVEL & TOUR LTD",
        WebStringKey.SIGN_IN_SUBTITLE to "Soo gal si aad u sii wadato",
        WebStringKey.AUTH_SUCCESS to "Xaqiijintu waa guulaysatay!",
        WebStringKey.ERROR_NO_INTERNET to "Internet-ka ma shaqaynayo.",
        WebStringKey.ERROR_SIGN_IN_CANCELED to "Gelitaanka waa la joojiyay.",
        WebStringKey.ERROR_UNKNOWN to "Cillad aan la garanayn ayaa dhacday",
        WebStringKey.SIGN_IN_WITH_GOOGLE to "Ku gal Google",
        WebStringKey.PLEASE_WAIT to "Fadlan sug...",
        WebStringKey.CONTACT_US to "Nala soo xiriir",
        WebStringKey.BACK to "Dib u laabo",
        WebStringKey.GET_IN_TOUCH to "Nala soo xiriir",
        WebStringKey.CONNECT_SOCIAL_MEDIA to "Nagala soco baraha bulshada",
        WebStringKey.CHAT_WITH_US to "Nala soo hadal",
        WebStringKey.FOLLOW_US to "Na raac",
        WebStringKey.NEED_IMMEDIATE_ASSISTANCE to "Ma u baahan tahay caawimaad degdeg ah?",
        WebStringKey.WHATSAPP_FASTEST_RESPONSE to "Farriin degdeg ah noogu soo dir WhatsApp",
        WebStringKey.WHATSAPP to "WhatsApp",
        WebStringKey.INSTAGRAM to "Instagram",
        WebStringKey.FACEBOOK to "Facebook",
        WebStringKey.TWITTER_X to "Twitter (X)",
        WebStringKey.TIKTOK to "TikTok",
        WebStringKey.OPEN_LINK to "Fur",
        WebStringKey.MY_PROFILE to "Xogtayda",
        WebStringKey.UPDATE to "Cusboonaysii",
        WebStringKey.SUCCESSFULLY_UPDATED to "Waa la cusboonaysiiyay!",
        WebStringKey.OOPS to "Iska raalli noqo!",
        WebStringKey.LANGUAGE to "Luqadda",
        WebStringKey.SELECT_LANGUAGE_TITLE to "Dooro Luqadda",
        WebStringKey.CHOOSE_PREFERRED_LANGUAGE to "Dooro luqadda aad doorbidayso",
        WebStringKey.SELECTED to "Waa la doortay",
        WebStringKey.COMING_SOON to "Dhowaan filo",
        WebStringKey.MORE_LANGUAGES_COMING to "Luqado kale ayaa dhowaan soo kordhi doona!",
        WebStringKey.INFO to "Macluumaad",
        WebStringKey.ENGLISH to "English",
        WebStringKey.KISWAHILI to "Sawaaxili",
        WebStringKey.TIGRINYA to "Tigrinya",
        WebStringKey.AMHARIC to "Amxaari",
        WebStringKey.ARABIC to "Carabi",
        WebStringKey.SOMALI to "Soomaali",
        WebStringKey.FYAT_TRAVEL_TOUR to "Fyat Travel & Tour Ltd",
        WebStringKey.TRAVEL_OPERATOR to "Adeegga Safarka",
        WebStringKey.PROFILE to "Profile",
        WebStringKey.SIGN_OUT to "Ka bax",
        WebStringKey.ADMIN to "Maamule",
        WebStringKey.BLOG to "Blog",
        WebStringKey.LOCATIONS to "Goobaha",
        WebStringKey.CHECKOUT to "Bixinta",
        WebStringKey.MENU to "Menu",
        WebStringKey.CLOSE to "Xir",
        WebStringKey.SHOP to "Dukaan",
        WebStringKey.EXPLORE_LABEL to "Baadh",
        WebStringKey.CART_LABEL to "Dambiisha",
        WebStringKey.CATEGORIES_LABEL to "Qaybaha",
        WebStringKey.CATEGORIES_SEARCH_PLACEHOLDER to "Ka raadi qaybaha...",
        WebStringKey.CATEGORIES_FILTER_ALL to "Dhammaan",
        WebStringKey.CATEGORIES_FILTER_FLIGHTS to "Duulimaadyo",
        WebStringKey.CATEGORIES_FILTER_HOTELS to "Hoteello",
        WebStringKey.CATEGORIES_FILTER_GUEST_HOUSES to "Guryaha Martida",
        WebStringKey.CATEGORIES_FILTER_CAR_RENTALS to "Kirada Baabuur",
        WebStringKey.CATEGORIES_FILTER_VISA_SERVICES to "Adeegyada Fiisaha",
        WebStringKey.CATEGORIES_FILTER_TOURS to "Dalxiisyo",
        WebStringKey.CATEGORIES_FILTER_TRANSFERS to "Gaadiid",
        WebStringKey.CATEGORIES_EMPTY to "Qaybo lagama helin Firestore.",
        WebStringKey.CATEGORIES_NO_MATCH to "Qaybo la jaanqaadaya raadintaada ma jiraan",
        WebStringKey.CATEGORIES_CLEAR_FILTERS to "Tirtir filtarrada",
        WebStringKey.CATEGORIES_SHOWING_COUNT to "Muujinaya {0} ka mid ah {1} qaybo",
        WebStringKey.CATEGORY_TYPE_OTHER to "Kale",
        WebStringKey.FLIGHT_OFFERS to "Qiimo Dhimista Duulimaadka",
        WebStringKey.HOTEL to "Hoteel",
        WebStringKey.GUEST_HOUSE to "Guri Marti",
        WebStringKey.CAR_RENTAL to "Kirada Baabuurta",
        WebStringKey.TOUR to "Dalxiis",
        WebStringKey.TOUR_PACKAGES to "Xirmooyinka Dalxiiska",
        WebStringKey.EXPLORE_FLIGHTS to "Duulimaad",
        WebStringKey.EXPLORE_STAYS to "Hoyga",
        WebStringKey.EXPLORE_TRANSFER to "Gaadiid",
        WebStringKey.EXPLORE_VISA to "Fiiso",
        WebStringKey.ERROR_WITH_MESSAGE to "Cillad: {0}",
        WebStringKey.FLIGHT_TAB_RETURN to "Tir iyo soo noqosho",
        WebStringKey.FLIGHT_TAB_ONE_WAY to "Hal dhinac",
        WebStringKey.FLIGHT_TAB_MULTI_CITY to "Magaalooyin badan",
        WebStringKey.FLIGHT_FROM to "Ka",
        WebStringKey.FLIGHT_TO to "Ku",
        WebStringKey.FLIGHT_SELECT_AIRPORT to "Dooro garoonka",
        WebStringKey.FLIGHT_DEPARTURE to "Bixitaanka",
        WebStringKey.FLIGHT_RETURN to "Soo-noqoshada",
        WebStringKey.FLIGHT_ORIGIN_PLACEHOLDER to "Asal (tusaale: EBB)",
        WebStringKey.FLIGHT_DESTINATION_PLACEHOLDER to "Meesha loo socdo (tusaale: NBO)",
        WebStringKey.FLIGHT_SELECT_DATE to "Dooro taariikhda",
        WebStringKey.FLIGHT_TRAVELERS to "Rakaabka",
        WebStringKey.FLIGHT_TRAVELLER_SINGULAR to "Rakaab",
        WebStringKey.FLIGHT_TRAVELLER_PLURAL to "Rakaab",
        WebStringKey.FLIGHT_CABIN to "Heerka Diyaaradda",
        WebStringKey.FLIGHT_SEARCH to "Raadi",
        WebStringKey.FLIGHT_SPECIAL_OFFERS to "Qiimo dhimis gaar ah ✈️",
        WebStringKey.FLIGHT_NO_OFFERS to "Ma jiraan dalabyo hadda jira.",
        WebStringKey.FLIGHT_CLOSE to "Xir",
        WebStringKey.FLIGHT_DONE to "Dhammaystir",
        WebStringKey.FLIGHT_ADULTS to "Dadka waaweyn",
        WebStringKey.FLIGHT_ADULTS_WITH_COUNT to "Dadka waaweyn: {0}",
        WebStringKey.FLIGHT_INCREASE to "Kordhi",
        WebStringKey.FLIGHT_DECREASE to "Yaree",
        WebStringKey.FLIGHT_PRICE to "Qiimaha",
        WebStringKey.FLIGHT_DISCOUNTED to "Qiimo dhimis",
        WebStringKey.FLIGHT_NEW to "Cusub",
        WebStringKey.FLIGHT_DETAILS to "Faahfaahinta",
        WebStringKey.FLIGHT_AVAILABLE_OPTIONS to "Xulashooyinka jira",
        WebStringKey.FLIGHT_BOOK_NOW_FROM to "Hadda gooso",
        WebStringKey.VISA_TITLE to "Hubinta Fiisaha",
        WebStringKey.VISA_SUBTITLE to "Hubi shuruudaha fiisaha ee safarkaaga",
        WebStringKey.VISA_PASSPORT_COUNTRY to "Waddanka Baasaboorka",
        WebStringKey.VISA_DESTINATION_COUNTRY to "Waddanka aad u socoto",
        WebStringKey.VISA_PASSPORT_HINT to "Magaca waddanka (tusaale: Somalia)",
        WebStringKey.VISA_DESTINATION_HINT to "Magaca waddanka (tusaale: Kenya)",
        WebStringKey.VISA_CHECKING to "Waa la hubinayaa...",
        WebStringKey.VISA_CHECK_BUTTON to "Eeg Shuruudaha",
        WebStringKey.VISA_ALWAYS_VERIFY to "ℹ️ Fadlan ka hubi ilaha rasmiga ah ka hor safarka",
        WebStringKey.VISA_EXPAND_DETAILS to "Muuji faahfaahinta",
        WebStringKey.VISA_COLLAPSE_DETAILS to "Qari faahfaahinta",
        WebStringKey.VISA_STAY_DURATION to "Muddada joogista: {0}",
        WebStringKey.VISA_SEARCH_TIP to "💡 Raadi magaca waddanka ama koodhka (SO, KE)",
        WebStringKey.VISA_CURRENCY to "Lacagta",
        WebStringKey.VISA_CAPITAL to "Caasimada",
        WebStringKey.VISA_PASSPORT_VALIDITY to "Ansaxnimada Baasaboorka",
        WebStringKey.VISA_STATUS_VISA_FREE to "FIISO LA'AAN",
        WebStringKey.VISA_STATUS_VISA_ON_ARRIVAL to "FIISO MARKAAD TIMAADDO",
        WebStringKey.VISA_STATUS_EVISA to "E-FIISO (E-VISA)",
        WebStringKey.VISA_STATUS_VISA_REQUIRED to "FIISO AYAA LOO BAAHAN YAHAY",
        WebStringKey.VISA_STATUS_UNKNOWN to "LAMA YAQAAN",
        WebStringKey.VISA_UNIT_MONTH to "bil",
        WebStringKey.VISA_UNIT_MONTHS to "bilo",
        WebStringKey.VISA_UNIT_DAY to "maalin",
        WebStringKey.VISA_UNIT_DAYS to "maalmo",
        WebStringKey.VISA_UNIT_YEAR to "sano",
        WebStringKey.VISA_UNIT_YEARS to "sano",
        WebStringKey.CAR_FIND_A_CAR to "Raadi baabuur",
        WebStringKey.CAR_PICKUP_LOCATION to "Goobta laga qaadayo",
        WebStringKey.CAR_DROPOFF_LOCATION_OPTIONAL to "Goobta lagu celinayo (ikhtiyaari)",
        WebStringKey.CAR_PICKUP_DATETIME to "Waqtiga qaadashada",
        WebStringKey.CAR_DROPOFF_DATETIME to "Waqtiga celinta",
        WebStringKey.CAR_DRIVER_AGE to "Da'da darawalka",
        WebStringKey.CAR_SEARCH_CARS to "Raadi baabuurta",
        WebStringKey.HOTEL_WHERE_TO to "Halkee u socotaa?",
        WebStringKey.HOTEL_SEARCH_DESTINATION to "Raadi meel",
        WebStringKey.HOTEL_CHECK_IN to "Xilliga imaanshaha",
        WebStringKey.HOTEL_CHECK_OUT to "Xilliga bixitaanka",
        WebStringKey.HOTEL_ADULTS to "Dadka waaweyn",
        WebStringKey.HOTEL_ROOMS to "Qolalka",
        WebStringKey.HOTEL_GUESTS_ROOMS to "Martida & Qolalka",
        WebStringKey.HOTEL_ADULT_SINGULAR to "Qof weyn",
        WebStringKey.HOTEL_ADULT_PLURAL to "Dad waaweyn",
        WebStringKey.HOTEL_CHILD_SINGULAR to "Cunug",
        WebStringKey.HOTEL_CHILD_PLURAL to "Carruur",
        WebStringKey.HOTEL_ROOM_SINGULAR to "Qol",
        WebStringKey.HOTEL_ROOM_PLURAL to "Qolal",
        WebStringKey.HOTEL_SEARCH_HOTELS to "Raadi Hoteellada",
        WebStringKey.HOTEL_DONE to "DHAMMAYSTIR",
        WebStringKey.HOTEL_CLOSE to "Xir",
        WebStringKey.HOTEL_WHERE_ARE_YOU_GOING to "Halkee ayaad u socotaa?",
        WebStringKey.HOTEL_SEARCH_DESTINATIONS to "Raadi meelaha",
        WebStringKey.HOTEL_START_TYPING to "Qor si aad u raadiso",
        WebStringKey.HOTEL_ENTER_CITY_HOTEL_DESTINATION to "Geli magaalada ama hoteelka",
        WebStringKey.HOTEL_SEARCHING_DESTINATIONS to "Waa la raadinayaa...",
        WebStringKey.HOTEL_NO_DESTINATIONS_FOUND to "Lama helin goobtaas",
        WebStringKey.HOTEL_CLEAR to "Tirtir",
        WebStringKey.HOTEL_HOTELS to "Hoteellada",
        WebStringKey.CONTACT_SUBTITLE to "Waxaan halkaan u joognaa inaan kaa caawino baahiyahaaga safarka.",
        WebStringKey.CONTACT_INFORMATION to "Macluumaadka Xiriirka",
        WebStringKey.SOCIAL_LABEL to "Bulsho",
        WebStringKey.SEND_A_COMMENT to "Dir Fikir",
        WebStringKey.YOUR_NAME to "Magacaaga",
        WebStringKey.FULL_NAME_PLACEHOLDER to "Magac buuxa",
        WebStringKey.EMAIL_OPTIONAL to "Email (ikhtiyaari)",
        WebStringKey.EMAIL_PLACEHOLDER to "you@example.com",
        WebStringKey.MESSAGE_COMMENTS to "Fariin / Faallo",
        WebStringKey.MESSAGE_PLACEHOLDER to "Halkan ku qor fariintaada...",
        WebStringKey.ERROR_NAME_MESSAGE_REQUIRED to "Fadlan geli magacaaga iyo fariinta.",
        WebStringKey.WHATSAPP_SENT_HINT to "WhatsApp ayaa la furay fariintaada. Taabo send si aad u dirto.",
        WebStringKey.SEND_VIA_WHATSAPP to "Ku dir WhatsApp",
        WebStringKey.CONTACT_MESSAGE_TEMPLATE to "Salaan FYAT Travel & Tour LTD,\n\nWaxaan jeclaan lahaa inaan wadaago faallooyinka soo socda:\n\nMagac: {0}\nEmail: {1}\nFariin: {2}\n\nMahadsanid.",
        WebStringKey.CAR_PICKUP_CITY to "Magaalada laga qaadayo",
        WebStringKey.CAR_DROPOFF_CITY_OPTIONAL to "Magaalada lagu celinayo (ikhtiyaari)",
        WebStringKey.CAR_PICKUP_DATE to "Taariikhda qaadashada",
        WebStringKey.CAR_DROPOFF_DATE to "Taariikhda celinta",
        WebStringKey.CAR_PICKUP_TIME to "Waqtiga qaadashada (HH:mm)",
        WebStringKey.CAR_DROPOFF_TIME to "Waqtiga celinta (HH:mm)",
        WebStringKey.ERROR_SEARCH_CARS_FAILED to "Ku guul darreystay raadinta kireynta baabuurta",
        WebStringKey.ERROR_INVALID_RESPONSE to "Jawaab aan sax ahayn oo ka timid server-ka",
        WebStringKey.ERROR_NETWORK to "Cilad shabakad (ma la daabacay Cloud Function?)",
        WebStringKey.OPEN_ON_BOOKING to "Ka fur Booking.com",
        WebStringKey.CAR_RESULTS_COUNT to "Baabuur ({0})",
        WebStringKey.CAR_LABEL to "Baabuur",
        WebStringKey.ERROR_SEARCH_HOTELS_FAILED to "Ku guul darreystay raadinta hoteellada",
        WebStringKey.HOTEL_RESULTS_COUNT to "Hoteello ({0})",
        WebStringKey.RATING_WITH_REVIEWS to "Qiimeyn: {0} ({1} faallooyin)",
        WebStringKey.NO_HOTELS_FOUND to "Hoteello laguma helin raadintan. Isku day magaalo ama taariikho kale.",
        WebStringKey.QUICK_SELECT to "Doorasho Degdeg ah",
        WebStringKey.BOOK_YOUR_JOURNEY to "Buug safarkaaga",
        WebStringKey.CLOSE_FORM to "Xir foomka",
        WebStringKey.CLICK_TO_FILL_DETAILS to "Guji si aad u buuxiso faahfaahinta safarka",
        WebStringKey.ENQUIRY_SENT to "✓ Codsiga waa la diray! Waan kula soo xiriiri doonaa.",
        WebStringKey.SEND_ANOTHER to "Dir mid kale",
        WebStringKey.ENTER_YOUR_NAME to "Geli magacaaga",
        WebStringKey.EMAIL_LABEL to "Email",
        WebStringKey.SERVICE_LABEL to "Adeeg",
        WebStringKey.DEPARTURE_CITY_PLACEHOLDER to "Magaalada ka bixitaanka",
        WebStringKey.DESTINATION_PLACEHOLDER to "Meesha loo socdo",
        WebStringKey.GUESTS_LABEL to "Martida",
        WebStringKey.GUESTS_PLACEHOLDER to "1 Qof weyn",
        WebStringKey.NOTES_LABEL to "Qoraal",
        WebStringKey.NOTES_PLACEHOLDER to "Codsi gaar ah...",
        WebStringKey.SENDING to "Diraya...",
        WebStringKey.SEND_EMAIL to "Dir Email",
        WebStringKey.CONNECTIVITY_NO_INTERNET to "Internet ma jiro",
        WebStringKey.CONNECTIVITY_RETRY to "Isku day mar kale",
        WebStringKey.CONNECTIVITY_CONNECTED to "Ku xiran",
        WebStringKey.BOOKING_ENQUIRY_TITLE to "FYAT Travel & Tour - Codsi Booking cusub",
        WebStringKey.VALIDATION_ENTER_FULL_NAME to "Fadlan geli magacaaga buuxa",
        WebStringKey.VALIDATION_ENTER_EMAIL_OR_PHONE to "Fadlan geli email ama telefoon",
        WebStringKey.VALIDATION_ENTER_DEPARTURE to "Fadlan geli goobta bixitaanka",
        WebStringKey.VALIDATION_ENTER_DESTINATION to "Fadlan geli meesha loo socdo",
        WebStringKey.ADDITIONAL_DETAILS_LABEL to "Faahfaahin Dheeraad ah",
        WebStringKey.GUESTS_AND_CABIN_LABEL to "Martida & Kaalinta",
        WebStringKey.FILTER_BY_AIRLINE to "Sifee iyadoo loo eegayo shirkadda diyaaradaha",
        WebStringKey.CLEAR_FILTER to "Nadiifi sifaynta",
        WebStringKey.NO_AIRLINE_FLIGHTS_FOUND to "Ma jiraan duullimaad {0} oo ku jira natiijooyinkan.",
        WebStringKey.NO_FLIGHTS_FOUND_MESSAGE to "Duullimaad lama helin. Isku day taariikho ama garoomo kale.",
        WebStringKey.FLIGHT_OFFER_LABEL to "Dalab Duullimaad",
        WebStringKey.FLIGHT_NUMBER_LABEL to "Duullimaad {0}",
        WebStringKey.COMPLETE_BOOKING to "Dhammaystir Booskaaga",
        WebStringKey.BOOKING_REQUEST_SENT to "Codsiga Booska waa la diray!",
        WebStringKey.BOOKING_REQUEST_SUBTITLE to "Kooxdayadu waxay kula soo xiriiri doonaan si ay u xaqiijiyaan helitaanka iyo ikhtiyaarrada lacag bixinta.",
        WebStringKey.YOUR_DETAILS_SECTION to "Faahfaahintaada",
        WebStringKey.TRAVEL_DETAILS_SECTION to "Faahfaahinta Safarka",
        WebStringKey.GUESTS_EXAMPLE_PLACEHOLDER to "tusaale: 2 Qaangaar, 1 Ilmo",
        WebStringKey.SPECIAL_REQUIREMENTS_PLACEHOLDER to "Shuruudo gaar ah, baahiyo cunto, codsiyo helitaan...",
        WebStringKey.PRIVACY_NOTE to "Macluumaadkaaga waxaa loo adeegsan doonaa oo keliya codsiga booskan. Waxaan kula soo xiriiri doonaa 24 saacadood gudahood.",
        WebStringKey.SEND_VIA_EMAIL to "Ku dir Email",
        WebStringKey.OFFER_WEEKEND_ESCAPE to "Fasax Usbuuca",
        WebStringKey.OFFER_WEEKEND_DESC to "Kayd weyn usbuucan",
        WebStringKey.OFFER_HOLIDAY_DEALS to "Dalabyo Fasax",
        WebStringKey.OFFER_HOLIDAY_DESC to "Dalab xadidan",
        WebStringKey.HOME_SUBTITLE to "Saham dalxiisyada, duullimaadyada, iyo dalabyada safarka",
        WebStringKey.HOME_HELP_TEXT to "Baadh qaybaha, fur badeecad, oo arag faahfaahinta oo dhan — waxaa taageeraya Firebase.",
        WebStringKey.FEATURED_FLIGHT_OFFERS to "Dalabyada Duullimaadyada La Doortay",
        WebStringKey.VIEW_ALL to "Eeg Dhammaan →",
        WebStringKey.BROWSE_CATEGORIES to "Baadh Qaybaha",
        WebStringKey.ITEMS_COUNT to "{0} shay",
        WebStringKey.BOOK_ACTION to "Booso",
        WebStringKey.WHATSAPP_DEFAULT_MESSAGE to "Salaan! Waxaan xiiseynayaa adeegyada safarka. Ma iga caawin kartaa?",
        WebStringKey.WHATSAPP_CHAT_LABEL to "Ku chat garee WhatsApp",
        WebStringKey.WHATSAPP_ASK_LABEL to "Ku weydii WhatsApp",
        WebStringKey.WHATSAPP_NEED_HELP_TITLE to "Ma u baahan tahay caawimaad?",
        WebStringKey.WHATSAPP_HELP_SUBTITLE to "La hadal khubarada safarka",
        WebStringKey.WHATSAPP_CHAT_NOW to "Hadal hadda",
        WebStringKey.WHATSAPP_MESSAGE_FLIGHT to "Salaan! Waxaan u baahanahay caawimaad ku saabsan duullimaad. Ma iga caawin kartaa?",
        WebStringKey.WHATSAPP_MESSAGE_HOTEL to "Salaan! Waxaan raadinayaa talo hoteello. Ma iga caawin kartaa?",
        WebStringKey.WHATSAPP_MESSAGE_VISA to "Salaan! Waxaan qabaa su'aalo ku saabsan fiisaha. Ma iga caawin kartaa?",
        WebStringKey.WHATSAPP_MESSAGE_TOUR to "Salaan! Waxaan rabaa inaan qabsado xirmo dalxiis. Ma iga caawin kartaa?",
        WebStringKey.WHATSAPP_MESSAGE_CAR to "Salaan! Waxaan rabaa inaan kireysto baabuur. Ma i siin kartaa ikhtiyaaro?",
        WebStringKey.WHATSAPP_MESSAGE_GENERAL to "Salaan! Waxaan u baahanahay caawimaad ku saabsan booking. Ma iga caawin kartaa?",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_TITLE to "Index-ka Database waa loo baahan yahay",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_BODY to "App-ka wuxuu u baahan yahay index Firestore si uu u muujiyo badeecooyinka qayb ahaan. Tani waa hal mar.",
        WebStringKey.FIRESTORE_CREATE_INDEX to "Abuur Index →",
        WebStringKey.FIRESTORE_DISMISS to "Xir",
        WebStringKey.FIRESTORE_INDEX_NOTE to "Index: product → category (kor u kaca) + createdAt (hoos u dhaca)",
        WebStringKey.FIRESTORE_INDEX_MISSING to "Index-ka database ma jiro. Riix 'Abuur Index' si aad u saxdo.",
        WebStringKey.FIRESTORE_ACCESS_DENIED to "Gelitaan waa la diiday. Fadlan hubi oggolaanshaha.",
        WebStringKey.FIRESTORE_NOT_FOUND to "Xogta la codsaday lama helin.",
        WebStringKey.FIRESTORE_NETWORK_UNAVAILABLE to "Shabakad lama heli karo. Fadlan hubi isku xirka.",
        WebStringKey.FOOTER_BRAND to "FYAT TRAVEL & TOUR LTD.",
        WebStringKey.FOOTER_TAGLINE to "Saaxiibkaaga la aamini karo ee duullimaadyada, hoteellada, fiisooyinka, iyo dalxiisyada adduunka.",
        WebStringKey.COPYRIGHT_TEXT to "© 2025 Fyat travel & tour Ltd.",
        WebStringKey.QUICK_LINKS to "Xiriir Degdeg ah",
        WebStringKey.SERVICES_LABEL to "Adeegyada",
        WebStringKey.ABOUT_US to "Nagu Saabsan",
        WebStringKey.CONTACT_LABEL to "Xiriir",
        WebStringKey.BOOK_NOW_LABEL to "Hadda Booso",
        WebStringKey.TOP_SERVICES to "Adeegyada Sare",
        WebStringKey.FLIGHT_BOOKING to "Booska Duullimaad",
        WebStringKey.HOTEL_RESERVATIONS to "Booska Hoteel",
        WebStringKey.VISA_PROCESSING to "Habaynta Fiisaha",
        WebStringKey.CAR_HIRE to "Kirada Baabuur",
        WebStringKey.GET_APP to "Hel App-ka",
        WebStringKey.GET_IT_ON to "Ka hel",
        WebStringKey.DOWNLOAD_ON to "Ka soo degso",
        WebStringKey.GOOGLE_PLAY to "Google Play",
        WebStringKey.APP_STORE to "App Store",
        WebStringKey.PAYMENT_SUCCESS_TITLE to "Lacag-bixin Waa La Guulaystay!",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_WITH_NAME to "Mahadsanid {0}! Lacag-bixinta waa la farsameeyay.",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_GENERIC to "Mahadsanid! Lacag-bixinta waa la farsameeyay.",
        WebStringKey.ORDER_DETAILS to "Faahfaahinta Dalabka",
        WebStringKey.ORDER_ID_LABEL to "Aqoonsiga Dalabka:",
        WebStringKey.STATUS_LABEL to "Xaaladda:",
        WebStringKey.PAYMENT_STATUS_PAID to "LA BIXIYAY",
        WebStringKey.PAYMENT_METHOD_LABEL to "Habka Lacag-bixinta:",
        WebStringKey.PAYMENT_METHOD_PESAPAL to "PesaPal",
        WebStringKey.CONFIRMATION_EMAIL_NOTE to "Email xaqiijin ah ayaa dhawaan laguu soo diri doonaa. Haddii aad qabto su'aalo, fadlan la xiriir taageerada.",
        WebStringKey.BROWSE_MORE_PRODUCTS to "Baadh Alaabooyin Dheeraad ah",
        WebStringKey.GO_TO_HOME to "U laabo Bogga Hore",
        WebStringKey.NEED_HELP_CONTACT to "Ma u baahan tahay caawimaad? Nagala soo xiriir info@fyattraveltour.com ama +256 758 250 625",
        WebStringKey.PAYMENT_FAILED_TITLE to "Lacag-bixin Fashilantay",
        WebStringKey.PAYMENT_FAILED_MESSAGE to "Nasiib darro, lacag-bixintu ma dhamaystirmin. Waxaa laga yaabaa in la joojiyay ama cilad farsamo.",
        WebStringKey.PAYMENT_FAILED_SUGGESTIONS_TITLE to "Maxaad samayn kartaa?",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_1 to "Mar kale isku day lacag-bixin kaar kale ama mobile money",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_2 to "Isticmaal WhatsApp si aad u diyaarsato lacag caddaan ah",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_3 to "La xiriir kooxdayada si aan kuugu caawino",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_4 to "Hubi internet-kaaga oo mar kale isku day",
        WebStringKey.TRY_AGAIN to "Mar Kale Isku Day",
        WebStringKey.CONTACT_VIA_WHATSAPP to "La xiriir WhatsApp",
        WebStringKey.PAYMENT_FAILED_WHATSAPP_MESSAGE to "Salaan, waxaan isku dayay inaan bixiyo lacag laakiin way fashilantay. Waxaan rabaa inaan diyaarsado dalabka alaabta: {0}"
        ,WebStringKey.SEND_INQUIRY to "Dir Su'aasha"
        ,WebStringKey.VALIDATION_ENTER_VALID_EMAIL to "Fadlan geli ciwaan email sax ah"
    )

    private val sw = mapOf(
        WebStringKey.APP_NAME to "FYAT Travel & Tour LTD",
        WebStringKey.BRAND_SHORT to "FyatTravel",
        WebStringKey.BRAND_SUFFIX to "Tour LTD",
        WebStringKey.SEARCH to "Tafuta",
        WebStringKey.GO to "Nenda",
        WebStringKey.UPDATED_AT to "Imesasishwa: {0}",
        WebStringKey.REFRESH to "Sasisha",
        WebStringKey.CATEGORIES to "Makundi",
        WebStringKey.CART to "Kikapu",
        WebStringKey.FLIGHTS to "Ndege",
        WebStringKey.STAYS to "Malazi",
        WebStringKey.CARS to "Magari",
        WebStringKey.CARS_PAGE_SUBTITLE to "Tupe maelezo ya ukodishaji wa gari na timu yetu itawasiliana nawe kupitia WhatsApp au barua pepe.",
        WebStringKey.VISA to "Viza",
        WebStringKey.EXPLORE to "Gundua",
        WebStringKey.CONTACT to "Wasiliana",
        WebStringKey.STAYS_PAGE_SUBTITLE to "Tupe maelezo ya ukaaji wako na timu yetu itawasiliana nawe kupitia WhatsApp au barua pepe.",
        WebStringKey.MY_PROFILE to "Profaili yangu",
        WebStringKey.SIGN_OUT to "Toka",
        WebStringKey.ACCOUNT_ACTIONS to "Vitendo vya akaunti",
        WebStringKey.EMAIL_NOT_VERIFIED to "⚠ Barua pepe haijathibitishwa",
        WebStringKey.USER_LABEL to "Mtumiaji",
        WebStringKey.USER_ID to "Kitambulisho cha mtumiaji",
        WebStringKey.PHONE_NUMBER to "Simu",
        WebStringKey.NOT_PROVIDED to "Haijatolewa",
        WebStringKey.EMAIL_VERIFIED to "Barua pepe imethibitishwa",
        WebStringKey.YES_TEXT to "Ndiyo",
        WebStringKey.NO_TEXT to "Hapana",
        WebStringKey.ACCOUNT_TYPE to "Aina ya akaunti",
        WebStringKey.ACCOUNT_TYPE_EMAIL to "Barua pepe",
        WebStringKey.ACCOUNT_TYPE_PHONE to "Simu",
        WebStringKey.SIGN_OUT_TITLE to "Toka",
        WebStringKey.SIGN_OUT_CONFIRMATION to "Una uhakika unataka kutoka? Utahitaji kuingia tena ili kufikia akaunti yako.",
        WebStringKey.SIGN_IN to "Ingia",
        WebStringKey.PROFILE to "Profaili",
        WebStringKey.ADMIN to "Msimamizi",
        WebStringKey.NOT_FOUND to "Haijapatikana",
        WebStringKey.UNKNOWN_ROUTE to "Njia isiyojulikana: {0}",
        WebStringKey.EXPLORE_COMING_SOON to "Ukurasa wa Gundua wa wavuti unakuja hivi karibuni.",
        WebStringKey.CART_COMING_SOON to "Ukurasa wa Kikapu wa wavuti unakuja hivi karibuni.",
        WebStringKey.ADMIN_COMING_SOON to "Dashibodi ya msimamizi ya wavuti itatayarishwa hivi karibuni.",
        WebStringKey.SEARCH_PAGE to "Tafuta",
        WebStringKey.SEARCH_WITH_QUERY to "Tafuta: {0}",
        WebStringKey.TRAVELERS_ECONOMY_CURRENCY to "Msafiri 1 • Economy • USD / UGX",
        WebStringKey.SEARCHING to "Inatafuta...",
        WebStringKey.VISA_PAGE_SUBTITLE to "Angalia mahitaji ya viza kwa destinasheni yoyote. Weka nchi ya pasipoti yako na unakotaka kusafiri.",
        WebStringKey.PASSPORT_COUNTRY_LABEL to "Nchi ya Pasipoti",
        WebStringKey.SELECT_PASSPORT_COUNTRY to "Chagua nchi ya pasipoti",
        WebStringKey.DESTINATION_COUNTRY_LABEL to "Nchi unakoenda",
        WebStringKey.SELECT_DESTINATION_COUNTRY to "Chagua nchi unakoenda",
        WebStringKey.SEARCH_COUNTRIES_PLACEHOLDER to "Tafuta nchi...",
        WebStringKey.CHECK_VISA_REQUIREMENTS to "Angalia mahitaji ya viza",
        WebStringKey.CHECKING to "Inakaguliwa...",
        WebStringKey.VISA_REQUIREMENT_TITLE to "Mahitaji ya viza",
        WebStringKey.VISA_FREE_STATUS to "Bila viza",
        WebStringKey.VISA_ON_ARRIVAL_STATUS to "Viza unapowasili",
        WebStringKey.EVISA_STATUS to "Viza ya mtandaoni inapatikana",
        WebStringKey.VISA_REQUIRED_STATUS to "Viza inahitajika",
        WebStringKey.UNKNOWN_STATUS to "Haijulikani",
        WebStringKey.PASSPORT_FROM to "Pasipoti kutoka",
        WebStringKey.TRAVELING_TO to "Unasafiri kwenda",
        WebStringKey.MAXIMUM_STAY to "Muda wa juu wa kukaa",
        WebStringKey.IMPORTANT_INFORMATION to "Taarifa muhimu",
        WebStringKey.DESTINATION_INFORMATION to "Taarifa za destinasheni",
        WebStringKey.CURRENCY_LABEL to "Sarafu: {0}",
        WebStringKey.PHONE_LABEL to "Simu: +{0}",
        WebStringKey.TIMEZONE_LABEL to "Saa za eneo: {0}",
        WebStringKey.VISIT_EMBASSY_WEBSITE to "Tembelea tovuti ya ubalozi →",
        WebStringKey.VISA_REQUIREMENTS_WARNING to "⚠️ Mahitaji ya viza yanaweza kubadilika. Hakikisha kila wakati kwa ubalozi rasmi kabla ya kusafiri.",
        WebStringKey.LANGUAGE to "Lugha",
        WebStringKey.LANGUAGE_SETTINGS to "Mipangilio ya Lugha",
        WebStringKey.SELECT_LANGUAGE to "Chagua lugha yako",
        WebStringKey.CURRENT_LANGUAGE to "Lugha ya sasa",
        WebStringKey.APPLY_LANGUAGE to "Tumia lugha",
        WebStringKey.LANGUAGE_HELP to "Chagua lugha unayotaka kutumia kwenye tovuti.",
        WebStringKey.OPEN_LANGUAGE to "Badilisha lugha",
        WebStringKey.CLOSE to "Funga",
        WebStringKey.SAVE to "Hifadhi",
        WebStringKey.DONE to "Imekamilika",
        WebStringKey.CANCEL to "Ghairi",
        WebStringKey.APPLY to "Tumia",
        WebStringKey.LOADING to "Inapakia...",
        WebStringKey.RETRY to "Jaribu tena",
        WebStringKey.APP_NAME to "Fyat Travel & Tour Ltd",
        WebStringKey.SIGN_IN_SUBTITLE to "Ingia ili kuendelea",
        WebStringKey.AUTH_SUCCESS to "Uthibitisho umefaulu!",
        WebStringKey.ERROR_NO_INTERNET to "Hitilafu ya muunganisho wa intaneti.",
        WebStringKey.ERROR_SIGN_IN_CANCELED to "Kuingia kumeghairiwa.",
        WebStringKey.ERROR_UNKNOWN to "Hitilafu isiyojulikana imetokea",
        WebStringKey.SIGN_IN_WITH_GOOGLE to "Ingia na Google",
        WebStringKey.PLEASE_WAIT to "Tafadhali subiri...",
        WebStringKey.CONTACT_US to "Wasiliana Nasi",
        WebStringKey.BACK to "Rudi",
        WebStringKey.GET_IN_TOUCH to "Wasiliana Nasi",
        WebStringKey.CONNECT_SOCIAL_MEDIA to "Tufuate kwenye mitandao ya kijamii",
        WebStringKey.CHAT_WITH_US to "Zungumza nasi",
        WebStringKey.FOLLOW_US to "Tufuate",
        WebStringKey.NEED_IMMEDIATE_ASSISTANCE to "Unahitaji msaada wa haraka?",
        WebStringKey.WHATSAPP_FASTEST_RESPONSE to "Tuma ujumbe wa WhatsApp kwa jibu la haraka",
        WebStringKey.WHATSAPP to "WhatsApp",
        WebStringKey.INSTAGRAM to "Instagram",
        WebStringKey.FACEBOOK to "Facebook",
        WebStringKey.TWITTER_X to "Twitter (X)",
        WebStringKey.TIKTOK to "TikTok",
        WebStringKey.OPEN_LINK to "Fungua",
        WebStringKey.MY_PROFILE to "Wasifu Wangu",
        WebStringKey.UPDATE to "Sasisha",
        WebStringKey.SUCCESSFULLY_UPDATED to "Imesasishwa kikamilifu!",
        WebStringKey.OOPS to "Samahani!",
        WebStringKey.LANGUAGE to "Lugha",
        WebStringKey.SELECT_LANGUAGE_TITLE to "Chagua Lugha",
        WebStringKey.CHOOSE_PREFERRED_LANGUAGE to "Chagua lugha unayopendelea",
        WebStringKey.SELECTED to "Imechaguliwa",
        WebStringKey.COMING_SOON to "Inakuja hivi karibuni",
        WebStringKey.MORE_LANGUAGES_COMING to "Lugha zaidi zinakuja hivi karibuni!",
        WebStringKey.INFO to "Taarifa",
        WebStringKey.ENGLISH to "Kiingereza",
        WebStringKey.KISWAHILI to "Kiswahili",
        WebStringKey.TIGRINYA to "Kitigrinya",
        WebStringKey.AMHARIC to "Kiamhari",
        WebStringKey.ARABIC to "Kiarabu",
        WebStringKey.SOMALI to "Kisomali",
        WebStringKey.FYAT_TRAVEL_TOUR to "Fyat Travel & Tour Ltd",
        WebStringKey.TRAVEL_OPERATOR to "Mtoa Huduma za Usafiri",
        WebStringKey.PROFILE to "Wasifu",
        WebStringKey.SIGN_OUT to "Ondoka",
        WebStringKey.ADMIN to "Msimamizi",
        WebStringKey.BLOG to "Blogu",
        WebStringKey.LOCATIONS to "Maeneo",
        WebStringKey.CHECKOUT to "Kamilisha Malipo",
        WebStringKey.MENU to "Menyu",
        WebStringKey.CLOSE to "Funga",
        WebStringKey.SHOP to "Duka",
        WebStringKey.EXPLORE_LABEL to "Gundua",
        WebStringKey.CART_LABEL to "Kikapu",
        WebStringKey.CATEGORIES_LABEL to "Kategoria",
        WebStringKey.CATEGORIES_SEARCH_PLACEHOLDER to "Tafuta kategoria...",
        WebStringKey.CATEGORIES_FILTER_ALL to "Zote",
        WebStringKey.CATEGORIES_FILTER_FLIGHTS to "Ndege",
        WebStringKey.CATEGORIES_FILTER_HOTELS to "Hoteli",
        WebStringKey.CATEGORIES_FILTER_GUEST_HOUSES to "Nyumba za Wageni",
        WebStringKey.CATEGORIES_FILTER_CAR_RENTALS to "Kukodisha Magari",
        WebStringKey.CATEGORIES_FILTER_VISA_SERVICES to "Huduma za Viza",
        WebStringKey.CATEGORIES_FILTER_TOURS to "Ziara",
        WebStringKey.CATEGORIES_FILTER_TRANSFERS to "Usafiri",
        WebStringKey.CATEGORIES_EMPTY to "Hakuna kategoria kwenye Firestore.",
        WebStringKey.CATEGORIES_NO_MATCH to "Hakuna kategoria zinazoendana na utafutaji wako",
        WebStringKey.CATEGORIES_CLEAR_FILTERS to "Futa vichujio",
        WebStringKey.CATEGORIES_SHOWING_COUNT to "Inaonyesha {0} kati ya {1} kategoria",
        WebStringKey.CATEGORY_TYPE_OTHER to "Nyingine",
        WebStringKey.FLIGHT_OFFERS to "Ofa za Ndege",
        WebStringKey.HOTEL to "Hoteli",
        WebStringKey.GUEST_HOUSE to "Nyumba ya Wageni",
        WebStringKey.CAR_RENTAL to "Kodisha Gari",
        WebStringKey.TOUR to "Ziara",
        WebStringKey.TOUR_PACKAGES to "Vifurushi vya Ziara",
        WebStringKey.EXPLORE_FLIGHTS to "Ndege",
        WebStringKey.EXPLORE_STAYS to "Malazi",
        WebStringKey.EXPLORE_TRANSFER to "Usafiri",
        WebStringKey.EXPLORE_VISA to "Visa",
        WebStringKey.FLIGHT_TAB_RETURN to "Safari ya Marudio",
        WebStringKey.FLIGHT_TAB_ONE_WAY to "Njia Moja tu",
        WebStringKey.FLIGHT_TAB_MULTI_CITY to "Miji mingi",
        WebStringKey.FLIGHT_FROM to "Kutoka",
        WebStringKey.FLIGHT_TO to "Kwenda",
        WebStringKey.FLIGHT_SELECT_AIRPORT to "Chagua uwanja wa ndege",
        WebStringKey.FLIGHT_DEPARTURE to "Kuondoka",
        WebStringKey.FLIGHT_RETURN to "Kurudi",
        WebStringKey.FLIGHT_ORIGIN_PLACEHOLDER to "Asili (mfano: EBB)",
        WebStringKey.FLIGHT_DESTINATION_PLACEHOLDER to "Mahali pa kwenda (mfano: NBO)",
        WebStringKey.FLIGHT_SELECT_DATE to "Chagua tarehe",
        WebStringKey.FLIGHT_TRAVELERS to "Wasafiri",
        WebStringKey.FLIGHT_TRAVELLER_SINGULAR to "Msafiri",
        WebStringKey.FLIGHT_TRAVELLER_PLURAL to "Wasafiri",
        WebStringKey.FLIGHT_CABIN to "Daraja la Usafiri",
        WebStringKey.FLIGHT_SEARCH to "Tafuta",
        WebStringKey.FLIGHT_SPECIAL_OFFERS to "Ofa Maalum ✈️",
        WebStringKey.FLIGHT_NO_OFFERS to "Hakuna ofa zilizopatikana.",
        WebStringKey.FLIGHT_CLOSE to "Funga",
        WebStringKey.FLIGHT_DONE to "Kamilisha",
        WebStringKey.FLIGHT_ADULTS to "Watu Wazima",
        WebStringKey.FLIGHT_PRICE to "Bei",
        WebStringKey.FLIGHT_DISCOUNTED to "Punguzo",
        WebStringKey.FLIGHT_NEW to "Mpya",
        WebStringKey.FLIGHT_DETAILS to "Maelezo ya Ndege",
        WebStringKey.FLIGHT_AVAILABLE_OPTIONS to "Chaguo Zilizopo",
        WebStringKey.FLIGHT_BOOK_NOW_FROM to "Weka Nafasi",
        WebStringKey.VISA_TITLE to "Mahitaji ya Visa",
        WebStringKey.VISA_SUBTITLE to "Angalia masharti ya visa kwa safari yako",
        WebStringKey.VISA_PASSPORT_COUNTRY to "Nchi ya Pasipoti",
        WebStringKey.VISA_DESTINATION_COUNTRY to "Nchi Unayoenda",
        WebStringKey.VISA_PASSPORT_HINT to "Ingiza jina la nchi (mfano: Uganda)",
        WebStringKey.VISA_DESTINATION_HINT to "Ingiza jina la nchi (mfano: Kenya)",
        WebStringKey.VISA_CHECKING to "Tunakagua...",
        WebStringKey.VISA_CHECK_BUTTON to "Kagua Mahitaji",
        WebStringKey.VISA_ALWAYS_VERIFY to "ℹ️ Hakikisha unapata maelezo kutoka vyanzo rasmi",
        WebStringKey.VISA_EXPAND_DETAILS to "Maelezo zaidi",
        WebStringKey.VISA_COLLAPSE_DETAILS to "Ficha maelezo",
        WebStringKey.VISA_STAY_DURATION to "Muda wa Kukaa: {0}",
        WebStringKey.VISA_NO_DETAILS to "Hakuna maelezo zaidi.",
        WebStringKey.VISA_CURRENCY to "Sarafu",
        WebStringKey.VISA_CAPITAL to "Mji mkuu",
        WebStringKey.VISA_PASSPORT_VALIDITY to "Muda wa Pasipoti",
        WebStringKey.VISA_STATUS_VISA_FREE to "VISA HAIHITAJIKI",
        WebStringKey.VISA_STATUS_VISA_ON_ARRIVAL to "VISA UNAPOWASILI",
        WebStringKey.VISA_STATUS_EVISA to "E-VISA (MTANDAONI)",
        WebStringKey.VISA_STATUS_VISA_REQUIRED to "VISA INAHITAJIKA",
        WebStringKey.VISA_STATUS_UNKNOWN to "HAIJULIKANI",
        WebStringKey.CAR_FIND_A_CAR to "Tafuta Gari",
        WebStringKey.CAR_PICKUP_LOCATION to "Mahali pa kuchukua",
        WebStringKey.CAR_DROPOFF_LOCATION_OPTIONAL to "Mahali pa kurudisha (hiari)",
        WebStringKey.CAR_PICKUP_DATETIME to "Tarehe na Saa ya kuchukua",
        WebStringKey.CAR_DROPOFF_DATETIME to "Tarehe na Saa ya kurudisha",
        WebStringKey.CAR_DRIVER_AGE to "Umri wa Dereva",
        WebStringKey.CAR_SEARCH_CARS to "Tafuta Magari",
        WebStringKey.HOTEL_WHERE_TO to "Unaenda wapi?",
        WebStringKey.HOTEL_SEARCH_DESTINATION to "Tafuta mahali",
        WebStringKey.HOTEL_CHECK_IN to "Tarehe ya Kuingia",
        WebStringKey.HOTEL_CHECK_OUT to "Tarehe ya Kutoka",
        WebStringKey.HOTEL_ADULTS to "Watu wazima",
        WebStringKey.HOTEL_ROOMS to "Vyumba",
        WebStringKey.HOTEL_GUESTS_ROOMS to "Wageni na Vyumba",
        WebStringKey.HOTEL_ADULT_SINGULAR to "Mtu mzima",
        WebStringKey.HOTEL_ADULT_PLURAL to "Watu wazima",
        WebStringKey.HOTEL_CHILD_SINGULAR to "Mtoto",
        WebStringKey.HOTEL_CHILD_PLURAL to "Watoto",
        WebStringKey.HOTEL_ROOM_SINGULAR to "Chumba",
        WebStringKey.HOTEL_ROOM_PLURAL to "Vyumba",
        WebStringKey.HOTEL_SEARCH_HOTELS to "Tafuta Hoteli",
        WebStringKey.HOTEL_DONE to "Kamilisha",
        WebStringKey.HOTEL_WHERE_ARE_YOU_GOING to "Unapanga kusafiri wapi?",
        WebStringKey.HOTEL_ENTER_CITY_HOTEL_DESTINATION to "Ingiza jina la jiji au hoteli",
        WebStringKey.HOTEL_SEARCHING_DESTINATIONS to "Inatafuta...",
        WebStringKey.HOTEL_NO_DESTINATIONS_FOUND to "Hakuna mahali palipopatikana",
        WebStringKey.HOTEL_CLEAR to "Futa",
        WebStringKey.CONTACT_SUBTITLE to "Tuko hapa kukusaidia kwa mahitaji yako yote ya safari.",
        WebStringKey.CONTACT_INFORMATION to "Taarifa za Mawasiliano",
        WebStringKey.SOCIAL_LABEL to "Mitandao ya kijamii",
        WebStringKey.SEND_A_COMMENT to "Tuma Maoni",
        WebStringKey.YOUR_NAME to "Jina lako",
        WebStringKey.FULL_NAME_PLACEHOLDER to "Jina kamili",
        WebStringKey.EMAIL_OPTIONAL to "Barua pepe (hiari)",
        WebStringKey.EMAIL_PLACEHOLDER to "you@example.com",
        WebStringKey.MESSAGE_COMMENTS to "Ujumbe / Maoni",
        WebStringKey.MESSAGE_PLACEHOLDER to "Andika ujumbe wako hapa...",
        WebStringKey.ERROR_NAME_MESSAGE_REQUIRED to "Tafadhali weka jina lako na ujumbe.",
        WebStringKey.WHATSAPP_SENT_HINT to "WhatsApp imefunguliwa na ujumbe wako. Bonyeza tuma ili kutuma.",
        WebStringKey.SEND_VIA_WHATSAPP to "Tuma kwa WhatsApp",
        WebStringKey.CONTACT_MESSAGE_TEMPLATE to "Habari FYAT Travel & Tour LTD,\n\nNingependa kushiriki maoni yafuatayo:\n\nJina: {0}\nBarua pepe: {1}\nUjumbe: {2}\n\nAsante.",
        WebStringKey.CAR_PICKUP_CITY to "Mji wa kuchukua",
        WebStringKey.CAR_DROPOFF_CITY_OPTIONAL to "Mji wa kurudisha (hiari)",
        WebStringKey.CAR_PICKUP_DATE to "Tarehe ya kuchukua",
        WebStringKey.CAR_DROPOFF_DATE to "Tarehe ya kurudisha",
        WebStringKey.CAR_PICKUP_TIME to "Saa ya kuchukua (HH:mm)",
        WebStringKey.CAR_DROPOFF_TIME to "Saa ya kurudisha (HH:mm)",
        WebStringKey.ERROR_SEARCH_CARS_FAILED to "Imeshindikana kutafuta ukodishaji wa magari",
        WebStringKey.ERROR_INVALID_RESPONSE to "Jibu batili kutoka kwa seva",
        WebStringKey.ERROR_NETWORK to "Hitilafu ya mtandao (je, Cloud Function imesambazwa?)",
        WebStringKey.OPEN_ON_BOOKING to "Fungua kwenye Booking.com",
        WebStringKey.CAR_RESULTS_COUNT to "Magari ({0})",
        WebStringKey.CAR_LABEL to "Gari",
        WebStringKey.ERROR_SEARCH_HOTELS_FAILED to "Imeshindikana kutafuta hoteli",
        WebStringKey.HOTEL_RESULTS_COUNT to "Hoteli ({0})",
        WebStringKey.RATING_WITH_REVIEWS to "Kiwango: {0} ({1} maoni)",
        WebStringKey.NO_HOTELS_FOUND to "Hakuna hoteli zilizopatikana kwa utafutaji huu. Jaribu jiji au tarehe nyingine.",
        WebStringKey.QUICK_SELECT to "Chagua Haraka",
        WebStringKey.BOOK_YOUR_JOURNEY to "Weka Nafasi ya Safari Yako",
        WebStringKey.CLOSE_FORM to "Funga fomu",
        WebStringKey.CLICK_TO_FILL_DETAILS to "Bofya kujaza maelezo ya safari",
        WebStringKey.ENQUIRY_SENT to "✓ Ombi limepelekwa! Tutawasiliana nawe hivi karibuni.",
        WebStringKey.SEND_ANOTHER to "Tuma nyingine",
        WebStringKey.ENTER_YOUR_NAME to "Weka jina lako",
        WebStringKey.EMAIL_LABEL to "Barua pepe",
        WebStringKey.SERVICE_LABEL to "Huduma",
        WebStringKey.DEPARTURE_CITY_PLACEHOLDER to "Mji wa kuondoka",
        WebStringKey.DESTINATION_PLACEHOLDER to "Mahali pa kwenda",
        WebStringKey.GUESTS_LABEL to "Wageni",
        WebStringKey.GUESTS_PLACEHOLDER to "Mtu mzima 1",
        WebStringKey.NOTES_LABEL to "Maelezo",
        WebStringKey.NOTES_PLACEHOLDER to "Maombi maalum...",
        WebStringKey.SENDING to "Inatuma...",
        WebStringKey.SEND_EMAIL to "Tuma Barua pepe",
        WebStringKey.CONNECTIVITY_NO_INTERNET to "Hakuna muunganisho wa intaneti",
        WebStringKey.CONNECTIVITY_RETRY to "Jaribu tena",
        WebStringKey.CONNECTIVITY_CONNECTED to "Imeunganishwa",
        WebStringKey.BOOKING_ENQUIRY_TITLE to "FYAT Travel & Tour - Ombi Jipya la Kuhifadhi",
        WebStringKey.VALIDATION_ENTER_FULL_NAME to "Tafadhali weka jina lako kamili",
        WebStringKey.VALIDATION_ENTER_EMAIL_OR_PHONE to "Tafadhali weka barua pepe au namba ya simu",
        WebStringKey.VALIDATION_ENTER_DEPARTURE to "Tafadhali weka mahali pa kuondoka",
        WebStringKey.VALIDATION_ENTER_DESTINATION to "Tafadhali weka mahali pa kwenda",
        WebStringKey.ADDITIONAL_DETAILS_LABEL to "Maelezo ya Ziada",
        WebStringKey.GUESTS_AND_CABIN_LABEL to "Wageni & Daraja",
        WebStringKey.FILTER_BY_AIRLINE to "Chuja kwa Shirika la Ndege",
        WebStringKey.CLEAR_FILTER to "Ondoa kichujio",
        WebStringKey.NO_AIRLINE_FLIGHTS_FOUND to "Hakuna ndege za {0} katika matokeo haya.",
        WebStringKey.NO_FLIGHTS_FOUND_MESSAGE to "Hakuna ndege zilizopatikana. Jaribu tarehe au viwanja vingine.",
        WebStringKey.FLIGHT_OFFER_LABEL to "Ofa ya Ndege",
        WebStringKey.FLIGHT_NUMBER_LABEL to "Ndege {0}",
        WebStringKey.COMPLETE_BOOKING to "Kamilisha Uhifadhi Wako",
        WebStringKey.BOOKING_REQUEST_SENT to "Ombi la Kuhifadhi Limetumwa!",
        WebStringKey.BOOKING_REQUEST_SUBTITLE to "Timu yetu itawasiliana nawe hivi karibuni kuthibitisha upatikanaji na chaguo za malipo.",
        WebStringKey.YOUR_DETAILS_SECTION to "Maelezo Yako",
        WebStringKey.TRAVEL_DETAILS_SECTION to "Maelezo ya Safari",
        WebStringKey.GUESTS_EXAMPLE_PLACEHOLDER to "mfano: Watu wazima 2, Mtoto 1",
        WebStringKey.SPECIAL_REQUIREMENTS_PLACEHOLDER to "Mahitaji maalum, mahitaji ya lishe, ombi la ufikivu...",
        WebStringKey.PRIVACY_NOTE to "Maelezo yako yatatumika tu kushughulikia ombi hili. Tutawasiliana nawe ndani ya saa 24.",
        WebStringKey.SEND_VIA_EMAIL to "Tuma kwa Barua pepe",
        WebStringKey.OFFER_WEEKEND_ESCAPE to "Mapumziko ya Wikendi",
        WebStringKey.OFFER_WEEKEND_DESC to "Okoa sana wikendi hii",
        WebStringKey.OFFER_HOLIDAY_DEALS to "Ofa za Likizo",
        WebStringKey.OFFER_HOLIDAY_DESC to "Ofa ya muda mfupi",
        WebStringKey.HOME_SUBTITLE to "Gundua ziara, ndege, na ofa za safari",
        WebStringKey.HOME_HELP_TEXT to "Vinjari kategoria, fungua bidhaa, na uone maelezo kamili — inaendeshwa na Firebase.",
        WebStringKey.FEATURED_FLIGHT_OFFERS to "Ofa Bora za Ndege",
        WebStringKey.VIEW_ALL to "Tazama Zote →",
        WebStringKey.BROWSE_CATEGORIES to "Vinjari Kategoria",
        WebStringKey.ITEMS_COUNT to "{0} vipengee",
        WebStringKey.BOOK_ACTION to "Hifadhi",
        WebStringKey.WHATSAPP_DEFAULT_MESSAGE to "Habari! Ninavutiwa na huduma zenu za safari. Mnaweza kunisaidia?",
        WebStringKey.WHATSAPP_CHAT_LABEL to "Ongea kwenye WhatsApp",
        WebStringKey.WHATSAPP_ASK_LABEL to "Uliza kwenye WhatsApp",
        WebStringKey.WHATSAPP_NEED_HELP_TITLE to "Unahitaji msaada?",
        WebStringKey.WHATSAPP_HELP_SUBTITLE to "Ongea na wataalamu wetu wa safari",
        WebStringKey.WHATSAPP_CHAT_NOW to "Ongea sasa",
        WebStringKey.WHATSAPP_MESSAGE_FLIGHT to "Habari! Nahitaji msaada wa kuhifadhi ndege. Unaweza kusaidia?",
        WebStringKey.WHATSAPP_MESSAGE_HOTEL to "Habari! Nataka mapendekezo ya hoteli. Unaweza kusaidia?",
        WebStringKey.WHATSAPP_MESSAGE_VISA to "Habari! Nina maswali kuhusu viza. Unaweza kusaidia?",
        WebStringKey.WHATSAPP_MESSAGE_TOUR to "Habari! Nataka kuhifadhi kifurushi cha ziara. Unaweza kusaidia?",
        WebStringKey.WHATSAPP_MESSAGE_CAR to "Habari! Nahitaji kukodisha gari. Unaweza kutoa chaguo?",
        WebStringKey.WHATSAPP_MESSAGE_GENERAL to "Habari! Nahitaji msaada wa kuhifadhi safari. Unaweza kunisaidia?",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_TITLE to "Index ya Hifadhidata Inahitajika",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_BODY to "Programu inahitaji index ya Firestore ili kuonyesha bidhaa kwa kategoria. Hii ni usanidi wa mara moja.",
        WebStringKey.FIRESTORE_CREATE_INDEX to "Unda Index →",
        WebStringKey.FIRESTORE_DISMISS to "Funga",
        WebStringKey.FIRESTORE_INDEX_NOTE to "Index: product → category (kupanda) + createdAt (kushuka)",
        WebStringKey.FIRESTORE_INDEX_MISSING to "Index ya hifadhidata haipo. Bofya 'Unda Index' ili kurekebisha.",
        WebStringKey.FIRESTORE_ACCESS_DENIED to "Ufikiaji umekataliwa. Tafadhali angalia ruhusa.",
        WebStringKey.FIRESTORE_NOT_FOUND to "Data iliyoombwa haikupatikana.",
        WebStringKey.FIRESTORE_NETWORK_UNAVAILABLE to "Mtandao haupatikani. Tafadhali angalia muunganisho wako.",
        WebStringKey.FOOTER_BRAND to "FYAT TRAVEL & TOUR LTD.",
        WebStringKey.FOOTER_TAGLINE to "Mshirika wako wa kuaminika kwa ndege, hoteli, viza, na safari duniani.",
        WebStringKey.COPYRIGHT_TEXT to "© 2025 Fyat travel & tour Ltd.",
        WebStringKey.QUICK_LINKS to "Viungo vya Haraka",
        WebStringKey.SERVICES_LABEL to "Huduma",
        WebStringKey.ABOUT_US to "Kuhusu Sisi",
        WebStringKey.CONTACT_LABEL to "Wasiliana",
        WebStringKey.BOOK_NOW_LABEL to "Hifadhi Sasa",
        WebStringKey.TOP_SERVICES to "Huduma Kuu",
        WebStringKey.FLIGHT_BOOKING to "Uhifadhi wa Ndege",
        WebStringKey.HOTEL_RESERVATIONS to "Uhifadhi wa Hoteli",
        WebStringKey.VISA_PROCESSING to "Uchakataji wa Viza",
        WebStringKey.CAR_HIRE to "Kukodisha Gari",
        WebStringKey.GET_APP to "Pata App",
        WebStringKey.GET_IT_ON to "Pata kwenye",
        WebStringKey.DOWNLOAD_ON to "Pakua kwenye",
        WebStringKey.GOOGLE_PLAY to "Google Play",
        WebStringKey.APP_STORE to "App Store",
        WebStringKey.PAYMENT_SUCCESS_TITLE to "Malipo Yamefanikiwa!",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_WITH_NAME to "Asante {0}! Malipo yako yameshughulikiwa kwa mafanikio.",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_GENERIC to "Asante! Malipo yako yameshughulikiwa kwa mafanikio.",
        WebStringKey.ORDER_DETAILS to "Maelezo ya Oda",
        WebStringKey.ORDER_ID_LABEL to "Kitambulisho cha Oda:",
        WebStringKey.STATUS_LABEL to "Hali:",
        WebStringKey.PAYMENT_STATUS_PAID to "IMELIPWA",
        WebStringKey.PAYMENT_METHOD_LABEL to "Njia ya Malipo:",
        WebStringKey.PAYMENT_METHOD_PESAPAL to "PesaPal",
        WebStringKey.CONFIRMATION_EMAIL_NOTE to "Barua pepe ya uthibitisho itatumwa hivi karibuni. Ikiwa una maswali, tafadhali wasiliana na timu ya msaada.",
        WebStringKey.BROWSE_MORE_PRODUCTS to "Vinjari Bidhaa Zaidi",
        WebStringKey.GO_TO_HOME to "Nenda Nyumbani",
        WebStringKey.NEED_HELP_CONTACT to "Unahitaji msaada? Wasiliana nasi kupitia info@fyattraveltour.com au +256 758 250 625",
        WebStringKey.PAYMENT_FAILED_TITLE to "Malipo Yameshindwa",
        WebStringKey.PAYMENT_FAILED_MESSAGE to "Kwa bahati mbaya, malipo yako hayajakamilika. Huenda imetokana na kughairi au tatizo la kiufundi.",
        WebStringKey.PAYMENT_FAILED_SUGGESTIONS_TITLE to "Unaweza kufanya nini?",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_1 to "Jaribu tena malipo kwa kadi tofauti au mobile money",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_2 to "Tumia WhatsApp kupanga malipo ya pesa taslimu",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_3 to "Wasiliana na timu yetu tutakusaidia",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_4 to "Angalia muunganisho wako wa intaneti na ujaribu tena",
        WebStringKey.TRY_AGAIN to "Jaribu Tena",
        WebStringKey.CONTACT_VIA_WHATSAPP to "Wasiliana kupitia WhatsApp",
        WebStringKey.PAYMENT_FAILED_WHATSAPP_MESSAGE to "Habari, nilijaribu kufanya malipo lakini yalishindikana. Ningependa kupanga booking ya bidhaa: {0}"
        ,WebStringKey.SEND_INQUIRY to "Tuma Ombi"
        ,WebStringKey.VALIDATION_ENTER_VALID_EMAIL to "Tafadhali weka anwani sahihi ya barua pepe"
    )

    private val ti = mapOf(
        WebStringKey.APP_NAME to "FYAT Travel & Tour LTD",
        WebStringKey.BRAND_SHORT to "FyatTravel",
        WebStringKey.BRAND_SUFFIX to "Tour LTD",
        WebStringKey.SEARCH to "ድለይ",
        WebStringKey.GO to "ሂድ",
        WebStringKey.UPDATED_AT to "ተሓዲሱ: {0}",
        WebStringKey.REFRESH to "ኣዳምጽ",
        WebStringKey.CATEGORIES to "ምድባት",
        WebStringKey.CART to "ሳጥን ግዢ",
        WebStringKey.FLIGHTS to "በረራታት",
        WebStringKey.STAYS to "መድረኻት",
        WebStringKey.CARS to "መኪናታት",
        WebStringKey.CARS_PAGE_SUBTITLE to "ዝርዝር ናይ መኪና ክራይ ንገሩና፣ ጋንኦትና ብ WhatsApp ወይ ኢመይል ክራኸበኩም ኢዩ.",
        WebStringKey.VISA to "ቪዛ",
        WebStringKey.EXPLORE to "ምርመራ",
        WebStringKey.CONTACT to "መገናኛ",
        WebStringKey.STAYS_PAGE_SUBTITLE to "ዝርዝር ናይ መዓስከርኩም ንገሩና፣ ጋንኦትና ብ WhatsApp ወይ ኢመይል ክራኸበኩም ኢዩ.",
        WebStringKey.MY_PROFILE to "ፕሮፋይል ናይ",
        WebStringKey.SIGN_OUT to "ውጻእ",
        WebStringKey.ACCOUNT_ACTIONS to "ተግባራት ኣካውንት",
        WebStringKey.EMAIL_NOT_VERIFIED to "⚠ ኢሜይል ኣይተረጋገጸን",
        WebStringKey.USER_LABEL to "ተጠቃሚ",
        WebStringKey.USER_ID to "መለለዪ ተጠቃሚ",
        WebStringKey.PHONE_NUMBER to "ተለፎን",
        WebStringKey.NOT_PROVIDED to "ኣይተሰጠን",
        WebStringKey.EMAIL_VERIFIED to "ኢሜይል ተረጋገጸ",
        WebStringKey.YES_TEXT to "እወ",
        WebStringKey.NO_TEXT to "ኣይ",
        WebStringKey.ACCOUNT_TYPE to "ዓይነት ኣካውንት",
        WebStringKey.ACCOUNT_TYPE_EMAIL to "ኢሜይል",
        WebStringKey.ACCOUNT_TYPE_PHONE to "ተለፎን",
        WebStringKey.SIGN_OUT_TITLE to "ውጻእ",
        WebStringKey.SIGN_OUT_CONFIRMATION to "ብርግጽ ክትወጽእ ትደሊ ዲኻ? ኣካውንትካ ክትእቱ እንደገና ክትእቱ ይግባእ።",
        WebStringKey.SIGN_IN to "እቶ",
        WebStringKey.PROFILE to "ፕሮፋይል",
        WebStringKey.ADMIN to "ኣቀናባሪ",
        WebStringKey.NOT_FOUND to "ኣይተረኽበን",
        WebStringKey.UNKNOWN_ROUTE to "ዘይተፈለጠ መንገዲ: {0}",
        WebStringKey.EXPLORE_COMING_SOON to "ገፅ ምርመራ ንዌብ ቀሊል ይመጽእ ኣሎ።",
        WebStringKey.CART_COMING_SOON to "ገፅ ሳጥን ግዢ ንዌብ ቀሊል ይመጽእ ኣሎ።",
        WebStringKey.ADMIN_COMING_SOON to "ዳሽቦርድ ኣቀናባሪ ንዌብ ቀሊል ይዝየድ ኣሎ።",
        WebStringKey.SEARCH_PAGE to "ድለይ",
        WebStringKey.SEARCH_WITH_QUERY to "ድለይ: {0}",
        WebStringKey.TRAVELERS_ECONOMY_CURRENCY to "1 ተጓዓዪ • Economy • USD / UGX",
        WebStringKey.SEARCHING to "ይድለይ ኣሎ...",
        WebStringKey.VISA_PAGE_SUBTITLE to "ንኩሉ መድረኽ የብራርሑ መወዳእታ ቪዛ ምርመራ ይኽእል እዩ። ሃገር ፓስፖርትካን ናብ ዝትጓዓይ ቦታን ኣቑል።",
        WebStringKey.PASSPORT_COUNTRY_LABEL to "ሃገር ፓስፖርት",
        WebStringKey.SELECT_PASSPORT_COUNTRY to "ሃገር ፓስፖርት ምረጽ",
        WebStringKey.DESTINATION_COUNTRY_LABEL to "ሃገር መድረሻ",
        WebStringKey.SELECT_DESTINATION_COUNTRY to "ሃገር መድረሻ ምረጽ",
        WebStringKey.SEARCH_COUNTRIES_PLACEHOLDER to "ሃገራት ድለይ...",
        WebStringKey.CHECK_VISA_REQUIREMENTS to "መወዳእታ ቪዛ ምርመራ",
        WebStringKey.CHECKING to "ይምርመር ኣሎ...",
        WebStringKey.VISA_REQUIREMENT_TITLE to "መወዳእታ ቪዛ",
        WebStringKey.VISA_FREE_STATUS to "ቪዛ ኣይድልን",
        WebStringKey.VISA_ON_ARRIVAL_STATUS to "ቪዛ ምስ ምጻእ",
        WebStringKey.EVISA_STATUS to "ኢ-ቪዛ ኣሎ",
        WebStringKey.VISA_REQUIRED_STATUS to "ቪዛ ኣለማዊ እዩ",
        WebStringKey.UNKNOWN_STATUS to "ዘይተፈለጠ",
        WebStringKey.PASSPORT_FROM to "ፓስፖርት ካብ",
        WebStringKey.TRAVELING_TO to "ናብ ዝጓዓይ",
        WebStringKey.MAXIMUM_STAY to "እቲ ኣብ ላዕሊ ዝጸንሕ ግዜ",
        WebStringKey.IMPORTANT_INFORMATION to "ኣስፈላጊ ሓበሬታ",
        WebStringKey.DESTINATION_INFORMATION to "ሓበሬታ መድረሻ",
        WebStringKey.CURRENCY_LABEL to "ምልክት ገንዘብ: {0}",
        WebStringKey.PHONE_LABEL to "ተለፎን: +{0}",
        WebStringKey.TIMEZONE_LABEL to "ዞን ሰዓት: {0}",
        WebStringKey.VISIT_EMBASSY_WEBSITE to "ድሕሪ መርበብ ሳፋራ ተመልከት →",
        WebStringKey.VISA_REQUIREMENTS_WARNING to "⚠️ መወዳእታ ቪዛ ክቀይር ይኽእል እዩ። ቅድሚ ጉዕዞ ኣብ ሕጋዊ ሳፋራ ርግጸት ኣድርግ።",
        WebStringKey.LANGUAGE to "ቋንቋ",
        WebStringKey.LANGUAGE_SETTINGS to "ምትካእ ቋንቋ",
        WebStringKey.SELECT_LANGUAGE to "ቋንቋኻ ምረጽ",
        WebStringKey.CURRENT_LANGUAGE to "እዋናዊ ቋንቋ",
        WebStringKey.APPLY_LANGUAGE to "ቋንቋ ተግብር",
        WebStringKey.LANGUAGE_HELP to "ኣብ ድሕሪ መርበብ ክትጠቀም ዝትደልዮ ቋንቋ ምረጽ።",
        WebStringKey.OPEN_LANGUAGE to "ቋንቋ ቀይር",
        WebStringKey.CLOSE to "ዕጽው",
        WebStringKey.SAVE to "ዓትር",
        WebStringKey.DONE to "ተጠናቀቐ",
        WebStringKey.CANCEL to "ሰርዝ",
        WebStringKey.APPLY to "ተግብር",
        WebStringKey.LOADING to "ይጽንዕ ኣሎ...",
        WebStringKey.RETRY to "ደጊም ፈትን",
        WebStringKey.APP_NAME to "Fyat Travel & Tour Ltd",
        WebStringKey.SIGN_IN_SUBTITLE to "ንምቕጻል በጃኹም ይእተዉ",
        WebStringKey.AUTH_SUCCESS to "ምርግጋጽ ተዓዊቱ!",
        WebStringKey.ERROR_NO_INTERNET to "ናይ ኢንተርነት ርክብ የለን።",
        WebStringKey.ERROR_SIGN_IN_CANCELED to "ተሰሪዙ።",
        WebStringKey.ERROR_UNKNOWN to "ዘይፍለጥ ጌጋ",
        WebStringKey.SIGN_IN_WITH_GOOGLE to "ብጉግል እቶ",
        WebStringKey.PLEASE_WAIT to "በጃኹም ተጸበዩ...",
        WebStringKey.CONTACT_US to "ርኸቡና",
        WebStringKey.BACK to "ተመለስ",
        WebStringKey.GET_IN_TOUCH to "ርኸቡና",
        WebStringKey.CONNECT_SOCIAL_MEDIA to "ብማሕበራዊ ሚዲያ ስዓቡና",
        WebStringKey.CHAT_WITH_US to "ኣዕልሉና",
        WebStringKey.FOLLOW_US to "ተኸተሉና",
        WebStringKey.NEED_IMMEDIATE_ASSISTANCE to "ቅልጡፍ ሓገዝ ምስ ትደልዩ",
        WebStringKey.WHATSAPP_FASTEST_RESPONSE to "ንቕልጡፍ መልሲ ብዋትስአፕ ጸሓፉልና",
        WebStringKey.WHATSAPP to "ዋትስአፕ",
        WebStringKey.INSTAGRAM to "ኢንስታግራም",
        WebStringKey.FACEBOOK to "ፌስቡክ",
        WebStringKey.TWITTER_X to "ትዊተር (X)",
        WebStringKey.TIKTOK to "ቲክቶክ",
        WebStringKey.OPEN_LINK to "ክፈት",
        WebStringKey.MY_PROFILE to "ውልቀ-መግለጺ",
        WebStringKey.UPDATE to "ኣሐድስ",
        WebStringKey.SUCCESSFULLY_UPDATED to "ብዓወት ተሓዲሱ!",
        WebStringKey.OOPS to "ይቕሬታ!",
        WebStringKey.LANGUAGE to "ቋንቋ",
        WebStringKey.SELECT_LANGUAGE_TITLE to "ቋንቋ ምረጽ",
        WebStringKey.CHOOSE_PREFERRED_LANGUAGE to "ዝጥዕመኩም ቋንቋ ምረጹ",
        WebStringKey.SELECTED to "ተመሪጹ",
        WebStringKey.COMING_SOON to "ኣብ ቀረባ ግዜ",
        WebStringKey.MORE_LANGUAGES_COMING to "ተወሳኺ ቋንቋታት ኣብ ቀረባ ግዜ ክውሰኹ እዮም!",
        WebStringKey.INFO to "ሓበሬታ",
        WebStringKey.ENGLISH to "እንግሊዝኛ",
        WebStringKey.KISWAHILI to "ስዋሂሊ",
        WebStringKey.TIGRINYA to "ትግርኛ",
        WebStringKey.AMHARIC to "ኣምሓርኛ",
        WebStringKey.ARABIC to "ዓረብኛ",
        WebStringKey.SOMALI to "ሶማሊኛ",
        WebStringKey.FYAT_TRAVEL_TOUR to "Fyat Travel & Tour Ltd",
        WebStringKey.TRAVEL_OPERATOR to "ኣገልግሎት መገሻ",
        WebStringKey.PROFILE to "ውልቀ-መግለጺ",
        WebStringKey.SIGN_OUT to "ውጻእ",
        WebStringKey.ADMIN to "ኣመሓዳሪ",
        WebStringKey.BLOG to "ብሎግ",
        WebStringKey.LOCATIONS to "ቦታታት",
        WebStringKey.CHECKOUT to "ከፍልካ ውጻእ",
        WebStringKey.MENU to "ዝርዝር",
        WebStringKey.CLOSE to "ዕጸው",
        WebStringKey.SHOP to "ድኳን",
        WebStringKey.EXPLORE_LABEL to "ዳህስስ",
        WebStringKey.CART_LABEL to "ዘንቢል",
        WebStringKey.CATEGORIES_LABEL to "ምድባት",
        WebStringKey.CATEGORIES_SEARCH_PLACEHOLDER to "ምድባት ድልዩ...",
        WebStringKey.CATEGORIES_FILTER_ALL to "ኩሉ",
        WebStringKey.CATEGORIES_FILTER_FLIGHTS to "በረራታት",
        WebStringKey.CATEGORIES_FILTER_HOTELS to "ሆቴላት",
        WebStringKey.CATEGORIES_FILTER_GUEST_HOUSES to "ቤታት ኣጋይሽ",
        WebStringKey.CATEGORIES_FILTER_CAR_RENTALS to "ክራይ መኪና",
        WebStringKey.CATEGORIES_FILTER_VISA_SERVICES to "ኣገልግሎት ቪዛ",
        WebStringKey.CATEGORIES_FILTER_TOURS to "ዑደታት",
        WebStringKey.CATEGORIES_FILTER_TRANSFERS to "ትራንስፈር",
        WebStringKey.CATEGORIES_EMPTY to "ኣብ Firestore ምንም ምድብ ኣይተረኽበን።",
        WebStringKey.CATEGORIES_NO_MATCH to "ምድባት ከም ምድላይካ ዘይምስል",
        WebStringKey.CATEGORIES_CLEAR_FILTERS to "ማጣሪያታት ኣፍዕል",
        WebStringKey.CATEGORIES_SHOWING_COUNT to "ዝረኣዩ {0} ካብ {1} ምድባት",
        WebStringKey.CATEGORY_TYPE_OTHER to "ካልእ",
        WebStringKey.FLIGHT_OFFERS to "ናይ በረራ ዕድላት",
        WebStringKey.HOTEL to "ሆቴል",
        WebStringKey.GUEST_HOUSE to "መዕረፊ ኣጋይሽ",
        WebStringKey.CAR_RENTAL to "ክራይ መኪና",
        WebStringKey.TOUR to "ዑደት",
        WebStringKey.TOUR_PACKAGES to "ጥምሮ ዑደታት",
        WebStringKey.EXPLORE_FLIGHTS to "በረራታት",
        WebStringKey.EXPLORE_STAYS to "መዕረፊታት",
        WebStringKey.EXPLORE_TRANSFER to "ትራንስፈር",
        WebStringKey.EXPLORE_VISA to "ቪዛ",
        WebStringKey.ERROR_WITH_MESSAGE to "ጌጋ፦ {0}",
        WebStringKey.FLIGHT_TAB_RETURN to "መመላለሲ",
        WebStringKey.FLIGHT_TAB_ONE_WAY to "ሓደ ወገን",
        WebStringKey.FLIGHT_TAB_MULTI_CITY to "ብዙሕ ከተማታት",
        WebStringKey.FLIGHT_FROM to "ካብ",
        WebStringKey.FLIGHT_TO to "ናብ",
        WebStringKey.FLIGHT_SELECT_AIRPORT to "መዕረፍ ነፈርቲ ምረጽ",
        WebStringKey.FLIGHT_DEPARTURE to "መበገሲ",
        WebStringKey.FLIGHT_RETURN to "ምምላስ",
        WebStringKey.FLIGHT_ORIGIN_PLACEHOLDER to "መነሻ (ምሳሌ፦ EBB)",
        WebStringKey.FLIGHT_DESTINATION_PLACEHOLDER to "መዳረሻ (ምሳሌ፦ NBO)",
        WebStringKey.FLIGHT_SELECT_DATE to "ዕለት ምረጽ",
        WebStringKey.FLIGHT_TRAVELERS to "ተጓዓዝቲ",
        WebStringKey.FLIGHT_TRAVELLER_SINGULAR to "ተጓዓዛይ",
        WebStringKey.FLIGHT_TRAVELLER_PLURAL to "ተጓዓዝቲ",
        WebStringKey.FLIGHT_CABIN to "ክፍሊ በረራ",
        WebStringKey.FLIGHT_SEARCH to "ድለ",
        WebStringKey.FLIGHT_SPECIAL_OFFERS to "ፍሉይ ናይ በረራ ቅናሻት ✈️",
        WebStringKey.FLIGHT_NO_OFFERS to "ዝተረኽበ ናይ በረራ ቅናሽ የለን",
        WebStringKey.FLIGHT_CLOSE to "ዕጸው",
        WebStringKey.FLIGHT_DONE to "ተወዲኡ",
        WebStringKey.FLIGHT_ADULTS to "ዓበይቲ",
        WebStringKey.FLIGHT_ADULTS_WITH_COUNT to "ዓበይቲ፦ {0}",
        WebStringKey.FLIGHT_INCREASE to "ወስኽ",
        WebStringKey.FLIGHT_DECREASE to "ቐንስ",
        WebStringKey.FLIGHT_PRICE to "ዋጋ",
        WebStringKey.FLIGHT_DISCOUNTED to "ቅናሽ ዘለዎ",
        WebStringKey.FLIGHT_NEW to "ሓድሽ",
        WebStringKey.FLIGHT_DETAILS to "ዝርዝር በረራ",
        WebStringKey.FLIGHT_AVAILABLE_OPTIONS to "ዘለዉ ኣማራጺታት",
        WebStringKey.FLIGHT_BOOK_NOW_FROM to "ሕጂ ሓዝ",
        WebStringKey.FLIGHT_ARROW to "→",
        WebStringKey.FLIGHT_CABIN_ECONOMY to "ኢኮኖሚ",
        WebStringKey.FLIGHT_CABIN_PREMIUM_ECONOMY to "ፕሪሚየም ኢኮኖሚ",
        WebStringKey.FLIGHT_CABIN_BUSINESS to "ቢዝነስ",
        WebStringKey.FLIGHT_CABIN_FIRST to "ቀዳማይ ክፍሊ",
        WebStringKey.VISA_TITLE to "መስፈርታት ቪዛ",
        WebStringKey.VISA_SUBTITLE to "ንመገሻኹም ዘድልዩ መስፈርታት ቪዛ ርኣዩ",
        WebStringKey.VISA_PASSPORT_COUNTRY to "ሃገር ፓስፖርት",
        WebStringKey.VISA_DESTINATION_COUNTRY to "መዳረሻ ሃገር",
        WebStringKey.VISA_PASSPORT_HINT to "ስም ሃገር ወይ ኮድ (ንኣብነት፦ Uganda)",
        WebStringKey.VISA_DESTINATION_HINT to "ስም ሃገር ወይ ኮድ (ንኣብነት፦ USA)",
        WebStringKey.VISA_CHECKING to "ኣብ ምጽራይ ይርከብ...",
        WebStringKey.VISA_CHECK_BUTTON to "መስፈርታት ቪዛ ርአ",
        WebStringKey.VISA_ERROR to "ጌጋ",
        WebStringKey.VISA_ALWAYS_VERIFY to "ℹ️ ኩሉ ግዜ ካብ ወግዓዊ ምንጪ ኣረጋግጽ",
        WebStringKey.VISA_EXPAND_DETAILS to "ዝርዝር ኣርእይ",
        WebStringKey.VISA_COLLAPSE_DETAILS to "ዝርዝር ሕብእ",
        WebStringKey.VISA_STAY_DURATION to "ንውሓት ግዜ ጻንሒት፦ {0}",
        WebStringKey.VISA_NO_DETAILS to "ተወሳኺ ሓበሬታ የለን።",
        WebStringKey.VISA_SEARCH_TIP to "💡 ሃገር ብስም ወይ ብኮድ ድለ",
        WebStringKey.VISA_CURRENCY to "ገንዘብ",
        WebStringKey.VISA_CAPITAL to "ርእሰ ከተማ",
        WebStringKey.VISA_PASSPORT_VALIDITY to "ቅቡልነት ፓስፖርት",
        WebStringKey.VISA_STATUS_VISA_FREE to "ቪዛ ኣየድልን",
        WebStringKey.VISA_STATUS_VISA_ON_ARRIVAL to "ቪዛ ምስ በጻሕካ",
        WebStringKey.VISA_STATUS_EVISA to "ኢ-ቪዛ (e-Visa)",
        WebStringKey.VISA_STATUS_VISA_REQUIRED to "ቪዛ የድሊ",
        WebStringKey.VISA_STATUS_UNKNOWN to "ዘይፍለጥ",
        WebStringKey.VISA_UNIT_MONTH to "ወርሒ",
        WebStringKey.VISA_UNIT_MONTHS to "ኣዋርሕ",
        WebStringKey.VISA_UNIT_DAY to "መዓልቲ",
        WebStringKey.VISA_UNIT_DAYS to "መዓልታት",
        WebStringKey.VISA_UNIT_YEAR to "ዓመት",
        WebStringKey.VISA_UNIT_YEARS to "ዓመታት",
        WebStringKey.CAR_FIND_A_CAR to "መኪና ርኸብ",
        WebStringKey.CAR_PICKUP_LOCATION to "መበገሲ ቦታ",
        WebStringKey.CAR_DROPOFF_LOCATION_OPTIONAL to "መውረዲ ቦታ (ኣማራጺ)",
        WebStringKey.CAR_PICKUP_DATETIME to "ዕለትን ሰዓትን ምርካብ",
        WebStringKey.CAR_DROPOFF_DATETIME to "ዕለትን ሰዓትን ምምላስ",
        WebStringKey.CAR_DRIVER_AGE to "ዕድመ ኣሽከርካሪ",
        WebStringKey.CAR_SEARCH_CARS to "መኪናታት ድለ",
        WebStringKey.HOTEL_WHERE_TO to "ናበይ?",
        WebStringKey.HOTEL_SEARCH_DESTINATION to "መዳረሻ ድለ",
        WebStringKey.HOTEL_CHECK_IN to "መእተዊ",
        WebStringKey.HOTEL_CHECK_OUT to "መውጽኢ",
        WebStringKey.HOTEL_GUESTS_ROOMS to "ኣጋይሽን ክፍልታትን",
        WebStringKey.HOTEL_ADULT_SINGULAR to "ዓብዪ",
        WebStringKey.HOTEL_ADULT_PLURAL to "ዓበይቲ",
        WebStringKey.HOTEL_CHILD_SINGULAR to "ቆልዓ",
        WebStringKey.HOTEL_CHILD_PLURAL to "ቆልዑ",
        WebStringKey.HOTEL_ROOM_SINGULAR to "ክፍሊ",
        WebStringKey.HOTEL_ROOM_PLURAL to "ክፍልታት",
        WebStringKey.HOTEL_SEARCH_HOTELS to "ሆቴላት ድለ",
        WebStringKey.HOTEL_ADULTS to "ዓበይቲ",
        WebStringKey.HOTEL_CHILDREN to "ቆልዑ",
        WebStringKey.HOTEL_ROOMS to "ክፍልታት",
        WebStringKey.HOTEL_DONE to "ተወዲኡ",
        WebStringKey.HOTEL_CLOSE to "ዕጸው",
        WebStringKey.HOTEL_WHERE_ARE_YOU_GOING to "ናበይ ክትከዱ ደሊኹም?",
        WebStringKey.HOTEL_SEARCH_DESTINATIONS to "መዳረሻታት ድለ",
        WebStringKey.HOTEL_START_TYPING to "ምጽሓፍ ጀምሩ",
        WebStringKey.HOTEL_ENTER_CITY_HOTEL_DESTINATION to "ስም ከተማ ወይ ሆቴል ኣእቱ",
        WebStringKey.HOTEL_SEARCHING_DESTINATIONS to "መዳረሻታት ይድለ ኣሎ...",
        WebStringKey.HOTEL_NO_DESTINATIONS_FOUND to "ዝተረኽበ መዳረሻ የለን",
        WebStringKey.HOTEL_TRY_DIFFERENT_SEARCH_TERM to "ብኻልእ ቃል ፈትኑ",
        WebStringKey.HOTEL_CLEAR to "ኣጽሪ",
        WebStringKey.HOTEL_HOTELS to "ሆቴላት",
        WebStringKey.HOTEL_UNKNOWN to "ዘይፍለጥ",
        WebStringKey.CONTACT_SUBTITLE to "ኩሉ የጉዞ ድሌታትኩም ንምሕጋዝ ኣብዚ ኢና።",
        WebStringKey.CONTACT_INFORMATION to "ሓበሬታ መገናኛ",
        WebStringKey.SOCIAL_LABEL to "ማሕበራዊ",
        WebStringKey.SEND_A_COMMENT to "ኣስተያየት ስደድ",
        WebStringKey.YOUR_NAME to "ስምካ",
        WebStringKey.FULL_NAME_PLACEHOLDER to "ሙሉ ስም",
        WebStringKey.EMAIL_OPTIONAL to "ኢሜይል (ኣማራጺ)",
        WebStringKey.EMAIL_PLACEHOLDER to "you@example.com",
        WebStringKey.MESSAGE_COMMENTS to "መልእኽቲ / ኣስተያየት",
        WebStringKey.MESSAGE_PLACEHOLDER to "መልእኽትካ ኣብዚ ጽሓፍ...",
        WebStringKey.ERROR_NAME_MESSAGE_REQUIRED to "በጃኹም ስምካን መልእኽትካን ኣእትዉ።",
        WebStringKey.WHATSAPP_SENT_HINT to "ዋትስአፕ ብመልእኽትካ ተኸፊቱ ኣሎ። ንምልእኽት ስደድ ጠቕም።",
        WebStringKey.SEND_VIA_WHATSAPP to "ብዋትስአፕ ስደድ",
        WebStringKey.CONTACT_MESSAGE_TEMPLATE to "ሰላም FYAT Travel & Tour LTD,\n\nኣብ ዚህ ኣስተያየት ክካፈል እደሊ፦\n\nስም: {0}\nኢሜይል: {1}\nመልእኽት: {2}\n\nየቐንየለይ።",
        WebStringKey.CAR_PICKUP_CITY to "ናይ ምርካብ ከተማ",
        WebStringKey.CAR_DROPOFF_CITY_OPTIONAL to "ናይ ምምላስ ከተማ (ኣማራጺ)",
        WebStringKey.CAR_PICKUP_DATE to "ዕለት ምርካብ",
        WebStringKey.CAR_DROPOFF_DATE to "ዕለት ምምላስ",
        WebStringKey.CAR_PICKUP_TIME to "ሰዓት ምርካብ (HH:mm)",
        WebStringKey.CAR_DROPOFF_TIME to "ሰዓት ምምላስ (HH:mm)",
        WebStringKey.ERROR_SEARCH_CARS_FAILED to "ናይ መኪና ኪራይ ምድላይ ኣይተዓወተን",
        WebStringKey.ERROR_INVALID_RESPONSE to "ካብ ሰርቨር ዘይትክክል ምላሽ",
        WebStringKey.ERROR_NETWORK to "ስርዓት ኔትወርክ ጌጋ (Cloud Function ተተግቢሩ ኣሎ?)",
        WebStringKey.OPEN_ON_BOOKING to "ኣብ Booking.com ክፈት",
        WebStringKey.CAR_RESULTS_COUNT to "መኪናታት ({0})",
        WebStringKey.CAR_LABEL to "መኪና",
        WebStringKey.ERROR_SEARCH_HOTELS_FAILED to "ምድላይ ሆቴላት ኣይተዓወተን",
        WebStringKey.HOTEL_RESULTS_COUNT to "ሆቴላት ({0})",
        WebStringKey.RATING_WITH_REVIEWS to "ደረጃ: {0} ({1} ግምገማታት)",
        WebStringKey.NO_HOTELS_FOUND to "ኣብዚ ምድላይ ሆቴል ኣይተረኽበን። ካልእ ከተማ ወይ ዕለት ፈትኑ።",
        WebStringKey.QUICK_SELECT to "ፈጣን ምርጫ",
        WebStringKey.BOOK_YOUR_JOURNEY to "መገሻኻ ሓዝ",
        WebStringKey.CLOSE_FORM to "ፎርም ዕጸው",
        WebStringKey.CLICK_TO_FILL_DETAILS to "ናይ ጉዕዞ ዝርዝር ንምምላእ ጠቕም",
        WebStringKey.ENQUIRY_SENT to "✓ ጥያቄ ተላኢኩ! ቀሊል ንእዋን ክንረክብኩም ኢና.",
        WebStringKey.SEND_ANOTHER to "ካልእ ስደድ",
        WebStringKey.ENTER_YOUR_NAME to "ስምካ ኣእትው",
        WebStringKey.EMAIL_LABEL to "ኢሜይል",
        WebStringKey.SERVICE_LABEL to "ኣገልግሎት",
        WebStringKey.DEPARTURE_CITY_PLACEHOLDER to "ከተማ መበገሲ",
        WebStringKey.DESTINATION_PLACEHOLDER to "መዳረሻ",
        WebStringKey.GUESTS_LABEL to "ኣጋይሽ",
        WebStringKey.GUESTS_PLACEHOLDER to "1 ዓብዪ",
        WebStringKey.NOTES_LABEL to "ምልክታት",
        WebStringKey.NOTES_PLACEHOLDER to "ዝተፈለጠ ጥያቄ...",
        WebStringKey.SENDING to "ይልእኽ...",
        WebStringKey.SEND_EMAIL to "ኢሜይል ስደድ",
        WebStringKey.CONNECTIVITY_NO_INTERNET to "ናይ ኢንተርነት ርክብ የለን",
        WebStringKey.CONNECTIVITY_RETRY to "ደጊም ፈትን",
        WebStringKey.CONNECTIVITY_CONNECTED to "ተራኺቡ",
        WebStringKey.BOOKING_ENQUIRY_TITLE to "FYAT Travel & Tour - ሓድሽ ጥያቄ ምዝገባ",
        WebStringKey.VALIDATION_ENTER_FULL_NAME to "በጃኹም ሙሉ ስምኩም ኣእትዉ",
        WebStringKey.VALIDATION_ENTER_EMAIL_OR_PHONE to "በጃኹም ኢሜይል ወይ ቁጽሪ ተለፎን ኣእትዉ",
        WebStringKey.VALIDATION_ENTER_DEPARTURE to "በጃኹም ቦታ መበገሲ ኣእትዉ",
        WebStringKey.VALIDATION_ENTER_DESTINATION to "በጃኹም መዳረሻ ኣእትዉ",
        WebStringKey.ADDITIONAL_DETAILS_LABEL to "ተወሳኺ ዝርዝር",
        WebStringKey.GUESTS_AND_CABIN_LABEL to "ኣጋይሽ & ክፍሊ",
        WebStringKey.FILTER_BY_AIRLINE to "ብናይ በረራ ኩባንያ ምጽራይ",
        WebStringKey.CLEAR_FILTER to "ማጽሓት",
        WebStringKey.NO_AIRLINE_FLIGHTS_FOUND to "ኣብ እዚ ውጽኢት {0} በረራ የለን።",
        WebStringKey.NO_FLIGHTS_FOUND_MESSAGE to "በረራ ኣይተረኽበን። ካልእ ዕለት ወይ ማዕረፍ ነፈርቲ ፈትኑ።",
        WebStringKey.FLIGHT_OFFER_LABEL to "ናይ በረራ ቅናሽ",
        WebStringKey.FLIGHT_NUMBER_LABEL to "በረራ {0}",
        WebStringKey.COMPLETE_BOOKING to "ምዝገባኻ ዛዘም",
        WebStringKey.BOOKING_REQUEST_SENT to "ጥያቄ ምዝገባ ተላኢኩ!",
        WebStringKey.BOOKING_REQUEST_SUBTITLE to "ቡድንና ንቅርብ ግዜ ክንረክብካ ኢና እዚ ዝርከብን ኣብ መክፈሊ ኣማራጺታትን ንምረግጋጽ።",
        WebStringKey.YOUR_DETAILS_SECTION to "ዝርዝርካ",
        WebStringKey.TRAVEL_DETAILS_SECTION to "ዝርዝር ጉዕዞ",
        WebStringKey.GUESTS_EXAMPLE_PLACEHOLDER to "ምሳሌ፦ 2 ዓበይቲ፣ 1 ቆልዓ",
        WebStringKey.SPECIAL_REQUIREMENTS_PLACEHOLDER to "ዝተፈለጠ ጥራይ፣ ስርዓት ምግቢ፣ ጥያቄ ተደሓሽ...",
        WebStringKey.PRIVACY_NOTE to "ሓበሬታኻ ምዝገባ ንምስራሕ ጥራይ ክንጠቀም። ኣብ 24 ሰዓታት ውሽጢ ክንረክብካ ኢና።",
        WebStringKey.SEND_VIA_EMAIL to "ብኢሜይል ስደድ",
        WebStringKey.OFFER_WEEKEND_ESCAPE to "መዕረፍ መዓርዕ ሰንበት",
        WebStringKey.OFFER_WEEKEND_DESC to "ብዙሕ ኣብ እዚ ሰንበት ምቕናሽ",
        WebStringKey.OFFER_HOLIDAY_DEALS to "ቅናሻት በዓል",
        WebStringKey.OFFER_HOLIDAY_DESC to "ንጽሕፍ ጊዜ ብቻ ቅናሽ",
        WebStringKey.HOME_SUBTITLE to "ዑደታት፣ በረራታትን ናይ ጉዕዞ ቅናሻትን ዳህስስ",
        WebStringKey.HOME_HELP_TEXT to "ምድባት ድልዩ፣ ፕሮዱክት ክፈቱ እና ዝርዝር ኩሉ ርአ — ብ Firebase ይደግፍ።",
        WebStringKey.FEATURED_FLIGHT_OFFERS to "ተመራማሪ ቅናሻት በረራ",
        WebStringKey.VIEW_ALL to "ኩሉ ርአ →",
        WebStringKey.BROWSE_CATEGORIES to "ምድባት ድልዩ",
        WebStringKey.ITEMS_COUNT to "{0} ንብረታት",
        WebStringKey.BOOK_ACTION to "ሓዝ",
        WebStringKey.WHATSAPP_DEFAULT_MESSAGE to "ሰላም! ኣብ ናትኩም ናይ ጉዕዞ ኣገልግሎት ዝምባለ ኣለኒ። ትሕግዙኒ?",
        WebStringKey.WHATSAPP_CHAT_LABEL to "ብዋትስአፕ ወያ",
        WebStringKey.WHATSAPP_ASK_LABEL to "ብዋትስአፕ ሕቶ ሕተት",
        WebStringKey.WHATSAPP_NEED_HELP_TITLE to "ሓገዝ ትደሊ?",
        WebStringKey.WHATSAPP_HELP_SUBTITLE to "ምስ ናይ ጉዕዞ እተማሃርቲ ወይዕ",
        WebStringKey.WHATSAPP_CHAT_NOW to "ሕጂ ወይዕ",
        WebStringKey.WHATSAPP_MESSAGE_FLIGHT to "ሰላም! ናይ በረራ ምዝገባ ሓገዝ እደሊ። ትሕግዙኒ?",
        WebStringKey.WHATSAPP_MESSAGE_HOTEL to "ሰላም! ምክር ሆቴል እደሊ። ትሕግዙኒ?",
        WebStringKey.WHATSAPP_MESSAGE_VISA to "ሰላም! ስለ መስፈርታት ቪዛ ሕቶ ኣለኒ። ትሕግዙኒ?",
        WebStringKey.WHATSAPP_MESSAGE_TOUR to "ሰላም! ጥምሮ ዑደት ክሓዝ እደሊ። ትሕግዙኒ?",
        WebStringKey.WHATSAPP_MESSAGE_CAR to "ሰላም! መኪና ክከራየል እደሊ። ኣማራጺታት ትሰጡኒ?",
        WebStringKey.WHATSAPP_MESSAGE_GENERAL to "ሰላም! ኣብ ምዝገባ ጉዕዞ ሓገዝ እደሊ። ትሕግዙኒ?",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_TITLE to "Index ናይ ዳታቤዝ የድሊ",
        WebStringKey.FIRESTORE_INDEX_REQUIRED_BODY to "ኣፕ ምርቶችን ብምድብ ንምርኣይ ናይ Firestore index የድሊ። እዚ ናይ ሓደ ግዜ ምስናድ እዩ።",
        WebStringKey.FIRESTORE_CREATE_INDEX to "Index ፍጠር →",
        WebStringKey.FIRESTORE_DISMISS to "ዕጸው",
        WebStringKey.FIRESTORE_INDEX_NOTE to "Index: product → category (እትዕብ) + createdAt (እትወርድ)",
        WebStringKey.FIRESTORE_INDEX_MISSING to "Index ናይ ዳታቤዝ የለን። 'Index ፍጠር' ጥቐሙ።",
        WebStringKey.FIRESTORE_ACCESS_DENIED to "መዳረሻ ተከልክሏል። ፈቓድ ርኣዩ።",
        WebStringKey.FIRESTORE_NOT_FOUND to "የተጠየቀ ዳታ ኣይተረኽበን።",
        WebStringKey.FIRESTORE_NETWORK_UNAVAILABLE to "ኔትወርክ ኣይተረኽበን። ርክብኩም ርኣዩ።",
        WebStringKey.FOOTER_BRAND to "FYAT TRAVEL & TOUR LTD.",
        WebStringKey.FOOTER_TAGLINE to "ተኣማኒ ባልደሃ ንበረራ፣ ሆቴል፣ ቪዛን ዓለማዊ ጉዕዞን።",
        WebStringKey.COPYRIGHT_TEXT to "© 2025 Fyat travel & tour Ltd.",
        WebStringKey.QUICK_LINKS to "ቀሊል ሊንክታት",
        WebStringKey.SERVICES_LABEL to "ኣገልግሎት",
        WebStringKey.ABOUT_US to "ስለና",
        WebStringKey.CONTACT_LABEL to "መገናኛ",
        WebStringKey.BOOK_NOW_LABEL to "ሕጂ ሓዝ",
        WebStringKey.TOP_SERVICES to "ኣለዉ ኣገልግሎታት",
        WebStringKey.FLIGHT_BOOKING to "ምዝገባ በረራ",
        WebStringKey.HOTEL_RESERVATIONS to "ምዝገባ ሆቴል",
        WebStringKey.VISA_PROCESSING to "ስራ ቪዛ",
        WebStringKey.CAR_HIRE to "ኪራይ መኪና",
        WebStringKey.GET_APP to "App ኣግኙ",
        WebStringKey.GET_IT_ON to "ኣብ",
        WebStringKey.DOWNLOAD_ON to "ኣውርዱ ኣብ",
        WebStringKey.GOOGLE_PLAY to "Google Play",
        WebStringKey.APP_STORE to "App Store",
        WebStringKey.PAYMENT_SUCCESS_TITLE to "ክፍያ ተዓውቷል!",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_WITH_NAME to "የቐንየልና {0}! ክፍያኻ ተከናውኗል።",
        WebStringKey.PAYMENT_SUCCESS_MESSAGE_GENERIC to "የቐንየልና! ክፍያኻ ተከናውኗል።",
        WebStringKey.ORDER_DETAILS to "ዝርዝር ትእዛዝ",
        WebStringKey.ORDER_ID_LABEL to "መለያ ትእዛዝ:",
        WebStringKey.STATUS_LABEL to "ሁኔታ:",
        WebStringKey.PAYMENT_STATUS_PAID to "ተኸፊሉ",
        WebStringKey.PAYMENT_METHOD_LABEL to "መንገዲ ክፍያ:",
        WebStringKey.PAYMENT_METHOD_PESAPAL to "PesaPal",
        WebStringKey.CONFIRMATION_EMAIL_NOTE to "የረጋገጫ ኢሜይል ብቕርቡ ይላእኽ። ሕቶ እንተሃልዩ ኣብ ድጋፍ ቡድንና ርክቡ።",
        WebStringKey.BROWSE_MORE_PRODUCTS to "ተወሳኺ ፕሮዱክት ድልዩ",
        WebStringKey.GO_TO_HOME to "ናብ መበል ገጽ",
        WebStringKey.NEED_HELP_CONTACT to "ሓገዝ ትደሊ? info@fyattraveltour.com ወይ +256 758 250 625 ርክቡና",
        WebStringKey.PAYMENT_FAILED_TITLE to "ክፍያ ኣይተሳካን",
        WebStringKey.PAYMENT_FAILED_MESSAGE to "ክፍያኹም ኣይተጠናቀቐን። ምኽንያቱ ምስራይ ወይ ቴክኒክ ጉድለት ክኸውን ይኽእል።",
        WebStringKey.PAYMENT_FAILED_SUGGESTIONS_TITLE to "እንታይ ትገብሩ ትኽእሉ?",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_1 to "ብኻልእ ካርድ ወይ ሞባይል ገንዘብ እንደገና ሙከሩ",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_2 to "ብ WhatsApp የእጅ ክፍያ ያዘጋጁ",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_3 to "ምስ ቡድንና ርክቡ እና ንሕግዞ",
        WebStringKey.PAYMENT_FAILED_SUGGESTION_4 to "ኢንተርኔት ርክብኩም ርኣዩ እና ድግሚ ሙከሩ",
        WebStringKey.TRY_AGAIN to "ድግሚ ሙከር",
        WebStringKey.CONTACT_VIA_WHATSAPP to "ብ WhatsApp ርክብ",
        WebStringKey.PAYMENT_FAILED_WHATSAPP_MESSAGE to "ሰላም፣ ክፍያ ለማድረግ ሞከርኩ ግን ኣይተሳካን። ናይ ፕሮዱክት ምዝገባ እፈልጋለሁ: {0}"
        ,WebStringKey.SEND_INQUIRY to "ሕቶ ስደድ"
        ,WebStringKey.VALIDATION_ENTER_VALID_EMAIL to "በጃኹም ቅኑዕ ኢመይል ኣድራሻ ኣእትዉ"
    )

    private val translations = mapOf(
        WebLocale.EN to en,
        WebLocale.AM to am,
        WebLocale.AR to ar,
        WebLocale.SO to so,
        WebLocale.SW to sw,
        WebLocale.TI to ti
    )
 
    @Composable
    fun t(key: WebStringKey): String {
        val locale = WebLocaleStore.locale.value
        return get(locale, key)
    }
 
    fun get(locale: WebLocale, key: WebStringKey): String {
        val map = translations[locale] ?: en
        return map[key] ?: en[key] ?: key.name
    }
 
    @Composable
    fun format(key: WebStringKey, vararg args: String): String {
        val locale = WebLocaleStore.locale.value
        return format(locale, key, *args)
    }
 
    fun format(locale: WebLocale, key: WebStringKey, vararg args: String): String {
        var template = get(locale, key)
        args.forEachIndexed { index, value ->
            template = template.replace("{$index}", value)
        }
        return template
    }
}